// import epsLogin from '@/components/Login.vue'
// import epsHome from '@/components/dashboard/Home.vue';
//Experiments
// const FileUpload = () => import(/* webpackChunkName: "file-upload" */'@/components/TryNError/FileUpload');
// const Sample = () => import(/* webpackChunkName: "sample" */'@/components/TryNError/sample');
// const SampleCalendar = () => import(/* webpackChunkName: "sample-calendar" */'@/components/TryNError/SampleCalendar');
// const TT = () => import(/* webpackChunkName: "tt" */'@/components/TryNError/TT');
// const Training = () => import(/* webpackChunkName: "training" */'@/components/TryNError/Training');
// const Testing = () => import(/* webpackChunkName: "testing" */'@/components/TryNError/testing');
// const certificate = () => import(/* webpackChunkName: "certificate" */'@/components/TryNError/certificate');
// const Hash = () => import(/* webpackChunkName: "hash" */'@/components/TryNError/Hash');
// const Auth = () => import(/* webpackChunkName: "auth" */'@/components/TryNError/Auth');
// const Check = () => import(/* webpackChunkName: "check" */'@/components/TryNError/Check');
// const RefCode = () => import(/* webpackChunkName: "refCode" */'@/components/TryNError/RefCode');
// const ReUsable = () => import(/* webpackChunkName: "reUsable" */'@/components/TryNError/ReUsable');
const SmsTemplateMaster = () => import(/* webpackChunkName: "sms-template-master" */'@/components/Sms/SmsTemplateMaster.vue');


//ends
const ForgotPassword = () => import(/* webpackChunkName: "forgot-password" */'@/components/ForgotPassword.vue');
const SbppsForgetPassword = () => import(/* webpackChunkName: "sbpps-forgot-password" */'@/components/Login/SbppsForgetPassword.vue');
const ParentSignup = () => import(/* webpackChunkName: "parent-signup" */'@/components/ParentSignup.vue');
const QuickPay = () => import(/* webpackChunkName: "parent-signup" */'@/components/QuickPay.vue');
const ChangePassword = () => import(/* webpackChunkName: "change-password" */'@/components/ChangePassword.vue');
const epsLogin = () => import(/* webpackChunkName: "eps-login" */'@/components/Login.vue');
const epsHome = () => import(/* webpackChunkName: "eps-home" */'@/components/dashboard/Home.vue');
const epsHome2 = () => import(/* webpackChunkName: "eps-home2" */'@/components/dashboard/Home2.vue');
const HomeUpdated = () => import(/* webpackChunkName: "eps-home2" */'@/components/dashboard/HomeUpdated.vue');
const TrialBypass = () => import(/* webpackChunkName: "trial-bypass" */'@/components/Login/TrialBypass.vue');

const Modules = () => import(/* webpackChunkName: "modules" */'@/components/dashboard/Modules.vue');
const Editer = () => import(/* webpackChunkName: "editer" */'@/components/Editer.vue');
//Account
//const AccountAdmin = () => import(/* webpackChunkName: "account-admin" */'@/components/Account/AccountAdmin.vue');
//const AccountOfficeStaff = () => import(/* webpackChunkName: "account-office-staff" */'@/components/Account/AccountOfficeStaff.vue');
const AddFeeCategory = () => import(/* webpackChunkName: "add-fee-category" */'@/components/Account/AddFeeCategory.vue');
const FeesType = () => import(/* webpackChunkName: "fees-type" */'@/components/Account/FeesType.vue');
const FeesInstallment = () => import(/* webpackChunkName: "fees-installment" */'@/components/Account/FeesInstallment.vue');
const PaymentMode = () => import(/* webpackChunkName: "payment-mode" */'@/components/Account/PaymentMode.vue');
const FeesComponent = () => import(/* webpackChunkName: "fees-component" */'@/components/Account/FeesComponent.vue');
const Bank = () => import(/* webpackChunkName: "bank" */'@/components/Account/Bank.vue');
//const GetReceipt = () => import(/* webpackChunkName: "get-receipt" */'@/components/Account/GetReceipt.vue');
const AccountMaster = () => import(/* webpackChunkName: "account-master" */'@/components/Account/AccountMaster');
const ReceiptReport = () => import/* webpackChunkName: "receipt-report" */('@/components/Account/ReceiptReport');
//Account ends
//FeesStructure
const ApplicationFormFeesTransctionReport = () => import(/* webpackChunkName: "application-form-fees-transction-report" */'@/components/Account/ApplicationFormFeesTransctionReport');
const FeesStructure = () => import(/* webpackChunkName: "fees-structure" */'@/components/FeesStructure/FeesStructure');
const FeesPaymentSchedule = () => import(/* webpackChunkName: "fees-payment-schedule" */'@/components/FeesStructure/FeesPaymentSchedule');
//FeesStructure ends
//Fees
const FeesPayment = () => import(/* webpackChunkName: "fees-payment" */'@/components/Fees/FeesPayment');
const Receipt = () => import(/* webpackChunkName: "receipt" */'@/components/Fees/Receipt');
const ParentReceipt = () => import(/* webpackChunkName: "parent-receipt" */'@/components/Fees/ParentReceipt');
const AdmissionFeesReceipt = () => import/* webpackChunkName: "admission-fees-receipt" */('@/components/Fees/AdmissionFeesReceipt');
//child  
const AdmissionFees = () => import(/* webpackChunkName: "admission-fees" */'@/components/Fees/AdmissionFees');
const HostelFees = () => import(/* webpackChunkName: "hostel-fees" */'@/components/Fees/HostelFees');
//Fees ends
//RoleManagement
//const RoleManageAdmin = () => import(/* webpackChunkName: "role-management-admin" */'@/components/RoleManagement/RoleManageAdmin.vue');
const AddOrganization = () => import(/* webpackChunkName: "add-organization" */'@/components/RoleManagement/AddOrganization.vue');
const AddRole = () => import(/* webpackChunkName: "add-role" */'@/components/RoleManagement/AddRole.vue');
const SearchStudent = () => import(/* webpackChunkName: "search-student" */'@/components/RoleManagement/SearchStudent.vue');
const SearchEmployee = () => import(/* webpackChunkName: "search-employee" */'@/components/RoleManagement/SearchEmployee.vue');
const EditEmployee = () => import(/* webpackChunkName: "edit-employee" */'@/components/RoleManagement/EditEmployee.vue');
const AddRoleLinks = () => import(/* webpackChunkName: "add-role-links" */'@/components/RoleManagement/AddRoleLinks.vue');
const AddUser = () => import(/* webpackChunkName: "add-user" */'@/components/RoleManagement/AddUser.vue');
const ImportEmployee = () => import(/* webpackChunkName: "import-employee" */'@/components/RoleManagement/ImportEmployee.vue');
const ImportStudent = () => import(/* webpackChunkName: "import-student" */'@/components/RoleManagement/ImportStudent.vue');
const ImportStudentDes = () => import(/* webpackChunkName: "import-student-des" */'@/components/RoleManagement/ImportStudentDes.vue');
const EditStudentImport = () => import(/* webpackChunkName: "edit-student-import" */'@/components/RoleManagement/EditStudentImport.vue');
const GetEmployee_Student = () => import(/* webpackChunkName: "get-employee-student" */'@/components/RoleManagement/GetEmployee_Student.vue');
const ImportEditStudentRegistration = () => import(/* webpackChunkName: "import-edit-student-registration" */'@/components/RoleManagement/ImportEditStudentRegistration.vue');
const ImportEditParentInfo = () => import(/* webpackChunkName: "import-edit-parent-info" */'@/components/RoleManagement/ImportEditParentInfo.vue');
const GetInstructorModuleRoles = () => import(/* webpackChunkName: "get-instructor-module-roles" */'@/components/RoleManagement/GetInstructorModuleRoles.vue');
const AddRoleToUser = () => import(/* webpackChunkName: "add-role-to-user" */'@/components/RoleManagement/AddRoleToUser.vue');
const AddUserAccess = () => import(/* webpackChunkName: "add-user-access" */'@/components/RoleManagement/AddUserAccess.vue');
const RoleHelp = () => import(/* webpackChunkName: "role-help" */'@/components/RoleManagement/RoleHelp.vue');
const EmployeeType = () => import(/* webpackChunkName: "employee-type" */'@/components/RoleManagement/EmployeeType.vue');
const EmployeeShift = () => import(/* webpackChunkName: "employee-shift" */'@/components/RoleManagement/EmployeeShift.vue');
const Designation = () => import(/* webpackChunkName: "designation" */'@/components/RoleManagement/Designation.vue');
const EmployeeBulkRole = () => import(/* webpackChunkName: "employee-bulk-role" */'@/components/RoleManagement/EmployeeBulkRole.vue');
const ParentInfo = () => import(/* webpackChunkName: "parent-info" */'@/components/RoleManagement/ParentInfo.vue');
const DataBetweenDates = () => import(/* webpackChunkName: "data-between-dates" */'@/components/Admin/DataBetweenDates.vue');
const AdminChangePassword = () => import(/* webpackChunkName: "admin-change-password" */'@/components/RoleManagement/AdminChangePassword.vue');
const PasswordManage = () => import(/* webpackChunkName: "admin-change-password" */'@/components/RoleManagement/PasswordManage.vue');
const UsernamePassword = () => import(/* webpackChunkName: "username-password" */'@/components/RoleManagement/UsernamePassword.vue');
const Logs = () => import(/* webpackChunkName: "logs" */'@/components/Admin/Logs.vue');
const LoginDetails = () => import(/* webpackChunkName: "login-details" */'@/components/Admin/LoginDetails.vue');
const Support = () => import(/* webpackChunkName: "support" */'@/components/support.vue');
const CheckMasterStatus = () => import(/* webpackChunkName: "check-master-status" */'@/components/Admin/CheckMasterStatus.vue');
const MngtByPass = () => import/* webpackChunkName: "mngt-bypass" */('@/components/Management/MngtByPass');
const EmpByPassLogin = () => import/* webpackChunkName: "emp-bypass-login" */('@/components/Management/EmpByPassLogin');
const BypassLogin = () => import(/* webpackChunkName: "bypass-login" */'@/components/RoleManagement/BypassLogin.vue');
const SetLearnerStatus = () => import(/* webpackChunkName: "set-learner-status" */'@/components/RoleManagement/SetLearnerStatus.vue');
const MapParentToLearner = () => import(/* webpackChunkName: "map-parent-to-learner" */'@/components/RoleManagement/MapParentToLearner');
const DefalultTypeValue = () => import(/* webpackChunkName: "default-type-value" */'@/components/RoleManagement/DefalultTypeValue');
const DefaultValues = () => import(/* webpackChunkName: "default-values" */'@/components/RoleManagement/DefaultValues');
const MobileAppLinkMaster = () => import(/* webpackChunkName: "mobile-app-link-master" */'@/components/RoleManagement/MobileAppLinkMaster');
const InstructorBulkEdit = () => import(/* webpackChunkName: "instructor-bulk-edit" */'@/components/RoleManagement/InstructorBulkEdit.vue');


//Role Management Masters
const MasterMenu = () => import(/* webpackChunkName: "master-menu" */'@/components/RoleManagement/Masters/MasterMenu.vue');
const ActivityTypeMaster = () => import(/* webpackChunkName: "activity-master" */'@/components/RoleManagement/Masters/ActivityTypeMaster.vue');
const AwardTypeMaster = () => import(/* webpackChunkName: "award-type-master" */'@/components/RoleManagement/Masters/AwardTypeMaster.vue');
const QueryLevelMaster = () => import(/* webpackChunkName: "query-level-master" */'@/components/RoleManagement/Masters/QueryLevelMaster.vue');
const QueryTypeMaster = () => import(/* webpackChunkName: "query-type-master" */'@/components/RoleManagement/Masters/QueryTypeMaster.vue');
const QueryStatusMaster = () => import(/* webpackChunkName: "query-status-master" */'@/components/RoleManagement/Masters/QueryStatusMaster.vue');
const DegreeMaster = () => import(/* webpackChunkName: "degree-master" */'@/components/RoleManagement/Masters/DegreeMaster.vue');
const ERPClassMaster = () => import(/* webpackChunkName: "erp-class-master" */'@/components/RoleManagement/Masters/ERPClassMaster.vue');
const ExperienceTypeMaster = () => import(/* webpackChunkName: "experience-type-master" */'@/components/RoleManagement/Masters/ExperienceTypeMaster.vue');
const PublicationCategoryMaster = () => import(/* webpackChunkName: "publication-category-master" */'@/components/RoleManagement/Masters/PublicationCategoryMaster.vue');
const PublicationIndexTypeMaster = () => import(/* webpackChunkName: "publication-index-type-master" */'@/components/RoleManagement/Masters/PublicationIndexTypeMaster.vue');
const PublicationTypeMaster = () => import(/* webpackChunkName: "publication-type-master" */'@/components/RoleManagement/Masters/PublicationTypeMaster.vue');
const ResearchStatusMaster = () => import(/* webpackChunkName: "research-status-master" */'@/components/RoleManagement/Masters/ResearchStatusMaster.vue');
const ResearchTypeMaster = () => import(/* webpackChunkName: "research-type-master" */'@/components/RoleManagement/Masters/ResearchTypeMaster.vue');

//ends
//role dashboard
const RoleDashboard = () => import(/* webpackChunkName: "role-dashboard" */'@/components/shared/RoleDashboard.vue');
const RoleDashboardStats = () => import(/* webpackChunkName: "role-dashboard-stats" */'@/components/shared/RoleDashboardStats.vue');
const EmpRole = () => import(/* webpackChunkName: "emp-role-dashboard" */'@/components/shared/EmpRole.vue');
const MasterData = () => import(/* webpackChunkName: "master-data" */'@/components/shared/MasterData.vue');

// ----------------Profile ---------------------
const userProfile = () => import(/* webpackChunkName: "user-profile" */'@/components/profile/UserProfile');
const updatePassword = () => import(/* webpackChunkName: "update-password" */'@/components/profile/UpdatePassword');
const ChangeLoginId = () => import(/* webpackChunkName: "change-login-id" */'@/components/profile/ChangeLoginId');
//...............@/.Profile-------------------
//admission
const ApplicationForm = () => import(/* webpackChunkName: "application-form" */'@/components/Admission/ApplicationForm');
const ElectiveMeritListGeneartion = () => import(/* webpackChunkName: "elective-merit-list-generation" */'@/components/Admission/ElectiveMeritListGeneartion');
const AdmissionConfirmedStudentReport = () => import(/* webpackChunkName: "admission-confirmed-student-report" */'@/components/Admission/AdmissionConfirmedStudentReport');
const ElectiveChoiceReport = () => import(/* webpackChunkName: "elective-choice-report */'@/components/Admission/ElectiveChoiceReport');
const SyncCurrentStandard = () => import(/* webpackChunkName: "sync-current-standard" */'@/components/Admission/SyncCurrentStandard');
const CopyClassTeacher = () => import(/* webpackChunkName: "copy-class-teacher" */'@/components/Admission/CopyClassTeacher');
const ChangeLearnerDivision = () => import(/* webpackChunkName: "change-learner-division" */'@/components/Admission/ChangeLearnerDivision');
const ChangeBulkLearnerDivision = () => import(/* webpackChunkName: "change-bulk-learner-division" */'@/components/Admission/ChangeBulkLearnerDivision');
const ApplicationFormFeesParent = () => import(/* webpackChunkName: "application-form-fees-parent" */'@/components/Admission/ApplicationFormFeesParent');
const ApplicationFormFeesStaff = () => import(/* webpackChunkName: "application-form-fees-staff" */'@/components/Admission/ApplicationFormFeesStaff');
const FormFeesReceipt = () => import(/* webpackChunkName: "form-fees-reciept" */'@/components/Admission/FormFeesReceipt');
const ViewApplicationForm = () => import(/* webpackChunkName: "view-application-form" */'@/components/Admission/ViewApplicationForm');
const TeacherTrainingReport = () => import(/* webpackChunkName: "teacher-training-report" */'@/components/Admission/TeacherTrainingReport');
const AddAy = () => import(/* webpackChunkName: "add-ay" */'@/components/Admission/AddAy');
const AddDivision = () => import(/* webpackChunkName: "add-division" */'@/components/Admission/AddDivision');
const OfferDivision = () => import(/* webpackChunkName: "offer-division" */'@/components/Admission/OfferDivision');
const ImportAddress = () => import(/* webpackChunkName: "import-address" */'@/components/Admission/ImportAddress');
const CopyOfferDivision = () => import(/* webpackChunkName: "copy-offer-division" */'@/components/Admission/CopyOfferDivision');
const AddStudent = () => import(/* webpackChunkName: "add-student" */'@/components/Admission/AddStudent');
const AddStudentSBPPS = () => import(/* webpackChunkName: "add-student-sbbps" */'@/components/Admission/AddStudentSBPPS');
const AddStudentEPS = () => import(/* webpackChunkName: "add-student-eps" */'@/components/Admission/AddStudentEPS');
const AddStudentWWS = () => import(/* webpackChunkName: "add-student-wws" */'@/components/Admission/AddStudentWWS');
const AddStudentZeal = () => import(/* webpackChunkName: "add-student-zeal" */'@/components/Admission/AddStudentZeal');
const AddEmployee = () => import(/* webpackChunkName: "add-employee" */'@/components/Admission/AddEmployee');
const CreateGmailAccount = () => import(/* webpackChunkName: "create-gmail-account" */'@/components/Admission/CreateGmailAccount');
const AssignCordinator = () => import(/* webpackChunkName: "assign-cordinator" */'@/components/Admission/AssignCordinator');
const ApplicationFormFeesMaster = () => import(/* webpackChunkName: "application-form-fees-master" */'@/components/Admission/ApplicationFormFeesMaster');
const DivisionAllocation = () => import(/* webpackChunkName: "division-allocation" */'@/components/Admission/DivisionAllocation');
const StandardMaster = () => import(/* webpackChunkName: "document-category-master" */'@/components/Admission/AdmissionMaster/StandardMaster');
const DocumentCategoryMaster = () => import(/* webpackChunkName: "document-category-master" */'@/components/Admission/AdmissionMaster/DocumentCategoryMaster');
const DocumentLevelMaster = () => import(/* webpackChunkName: "document-level-master" */'@/components/Admission/AdmissionMaster/DocumentLevelMaster');
const DocumentAccessControlMaster = () => import(/* webpackChunkName: "document-access-control-master" */'@/components/Admission/AdmissionMaster/DocumentAccessControlMaster');
const DocumentSubCategoryMaster = () => import(/* webpackChunkName: "document-sub-category-master" */'@/components/Admission/AdmissionMaster/DocumentSubCategoryMaster');
const DocumentAccessControl = () => import(/* webpackChunkName: "document-access-control" */'@/components/Admission/AdmissionMaster/DocumentAccessControl');
const DocumentAccessLogs = () => import(/* webpackChunkName: "document-access-logs" */'@/components/Admission/AdmissionMaster/DocumentAccessLogs');
const AdmissionMaster = () => import(/* webpackChunkName: "admission-master" */'@/components/Admission/AdmissionMaster/AdmissionMaster');
const ApplicationStatusList = () => import(/* webpackChunkName: "application-status-list" */'@/components/Admission/ApplicationStatusList');
const OneViewApplicationForm = () => import(/* webpackChunkName: "one-view-application-form" */'@/components/Admission/OneViewApplicationForm');
const AdmittedStudentReport = () => import(/* webpackChunkName: "admitted-student-report" */'@/components/Admission/Report/AdmittedStudentReport');
const RelativeDetailsReport = () => import(/* webpackChunkName: "relative-details-report" */'@/components/Admission/Report/RelativeDetailsReport');
const AdmittedStudentReportWithoutLD = () => import(/* webpackChunkName: "admitted-student-report-without-LD" */'@/components/Admission/Report/AdmittedStudentReportWithoutLD');
const EmployeeData = () => import(/* webpackChunkName: "employee-data" */'@/components/Admission/Report/EmployeeData');
const RollCall = () => import(/* webpackChunkName: "roll-call" */'@/components/Admission/Report/RollCall');
const AdmissionInstruction = () => import(/* webpackChunkName: "admission-instruction" */'@/components/Admission/AdmissionInstruction');
const AcademicDashboard = () => import(/* webpackChunkName: "academic-dashboard" */'@/components/Admission/AcademicDashboard');
const AcademicData = () => import(/* webpackChunkName: "academic-data" */'@/components/Admission/AcademicData');
const BulkEditOtherInfo = () => import(/* webpackChunkName: "bulk-edit-other-info" */'@/components/Admission/BulkEditOtherInfo');
const PromoteStudent = () => import(/* webpackChunkName: "promote-student" */'@/components/Admission/PromoteStudent');
const ProvisionalPromoteStudent = () => import(/* webpackChunkName: "provisional-promote-student" */'@/components/Admission/ProvisionalPromoteStudent');
const StudentPromotion = () => import(/* webpackChunkName: "student-promotion" */'@/components/Admission/StudentPromotion');
const SetAgeCriteria = () => import(/* webpackChunkName: "set-age-criteria" */'@/components/Admission/SetAgeCriteria');
const SetStdAdmissionFee = () => import(/* webpackChunkName: "set-std-admission-fee" */'@/components/Admission/SetStdAdmissionFee');
const StandardAdmissionQuota = () => import(/* webpackChunkName: "standard-admission-quota" */'@/components/Admission/StandardAdmissionQuota');
const AdmissionFeeReport = () => import(/* webpackChunkName: "admission-fee-report" */'@/components/Admission/AdmissionFeeReport');
const ImportCity = () => import(/* webpackChunkName: "admission-fee-report" */'@/components/Admission/ImportCity');

const FamilyType = () => import(/* webpackChunkName: "family-type" */'@/components/Admission/FamilyType');
//adminssion-certificate
const Bonafied = () => import(/* webpackChunkName: "bonafied" */'@/components/Admission/Certificate/Bonafied');
const GetBonafideZeal = () => import(/* webpackChunkName: "get-bobafide-zeal" */'@/components/Certificate/GetBonafideZeal');
const GetBonafideWWS = () => import(/* webpackChunkName: "get-bonafide-wws" */'@/components/Certificate/GetBonafideWWS');
const CeritificateReceipt = () => import(/* webpackChunkName: "certificate-receipt" */'@/components/Certificate/CeritificateReceipt');
const LeavingCertificate = () => import(/* webpackChunkName: "leave-certificate" */'@/components/Certificate/LeavingCertificate');
const BulkLeavingCertificate = () => import(/* webpackChunkName: "bulk-leaving-certificate" */'@/components/Certificate/BulkLeavingCertificate');
const GetCertificateZealBonafide = () => import(/* webpackChunkName: "get-certificate-zeal-bonafide" */'@/components/Certificate/GetCertificateZealBonafide');
const getCertificateReport = () => import(/* webpackChunkName: "get-Certificate-Report" */'@/components/Certificate/getCertificateReport');
const FeeReceiptCertificate = () => import(/* webpackChunkName: "fee-receipt-certificate" */'@/components/Certificate/FeeReceiptCertificate');
const getcertificate = () => import(/* webpackChunkName: "get-certificate" */'@/components/Admission/Certificate/getcertificate');
const getcertificate1 = () => import(/* webpackChunkName: "get-certificate1" */'@/components/Admission/Certificate/getcertificate1');
const getcertificateforreportprint = () => import(/* webpackChunkName: "get-certificate1" */'@/components/Admission/Certificate/getcertificateforreportprint');
const getBonafiedCertificatereportprintSJCV = () => import(/* webpackChunkName: "get-bonafied-certificate-report-print-SJCV" */'@/components/Admission/Certificate/getBonafiedCertificatereportprintSJCV');
const getBonafiedCertificatereportprintSSJC = () => import(/* webpackChunkName: "get-bonafied-certificate-report-print-SSJC" */'@/components/Admission/Certificate/getBonafiedCertificatereportprintSSJC');
const getBonafiedCertificateSanjivanireportprint = () => import(/* webpackChunkName: "get-bonafied-certificate-report-print-sanjivani" */'@/components/Admission/Certificate/getBonafiedCertificateSanjivanireportprint');
const getBonafiedCertificatereportVVPprint = () => import(/* webpackChunkName: "get-bonafied-certificate-report-print-vvp" */'@/components/Admission/Certificate/getBonafiedCertificatereportVVPprint');
const getBonafiedCertificatereportWWSprint = () => import(/* webpackChunkName: "get-bonafied-certificate-report-print-wws" */'@/components/Admission/Certificate/getBonafiedCertificatereportWWSprint');
const getBonafiedCertificatereportZealprint = () => import(/* webpackChunkName: "get-bonafied-certificate-report-print-zeal" */'@/components/Admission/Certificate/getBonafiedCertificatereportZealprint');
const getcertificate2 = () => import(/* webpackChunkName: "get-certificate2" */'@/components/Admission/Certificate/getcertificate2');
const getBonafiedCertificateSanjivani = () => import(/* webpackChunkName: "get-bonafied-certificate-sanjivani" */'@/components/Admission/Certificate/getBonafiedCertificateSanjivani');
const getBonafiedCertificateSJCV = () => import(/* webpackChunkName: "get-bonafied-certificate-sjcv" */'@/components/Admission/Certificate/getBonafiedCertificateSJCV');
const getBonafiedCertificateSSJC = () => import(/* webpackChunkName: "get-bonafide-certificate-ssjc" */'@/components/Admission/Certificate/getBonafiedCertificateSSJC');
const getBonafiedCertificateSanjivaniPrint = () => import(/* webpackChunkName: "get-bonafied-certificate-sanjivani-print" */'@/components/Admission/Certificate/getBonafiedCertificateSanjivaniPrint');
const getBonafideCertificateVvp = () => import(/* webpackChunkName: "get-bonafide-certificate-vvp" */'@/components/Admission/Certificate/getBonafideCertificateVvp');
const getBonafideCertificateVvpPrint = () => import(/* webpackChunkName: "get-bonafide-certificate-vvp-print" */'@/components/Admission/Certificate/getBonafideCertificateVvpPrint');
const getBonafideCertificateWws = () => import(/* webpackChunkName: "get-bonafide-certificate-wws" */'@/components/Admission/Certificate/getBonafideCertificateWws');
//AdmissionMaster
const ApplicationStatus = () => import(/* webpackChunkName: "application-status" */'@/components/Admission/AdmissionMaster/ApplicationStatus');
const SerialFieldTypeMaster = () => import(/* webpackChunkName: "serial-field-type-master" */'@/components/Admission/AdmissionMaster/SerialFieldTypeMaster');
const SerialFieldMaster = () => import(/* webpackChunkName: "serial-field-master" */'@/components/Admission/AdmissionMaster/SerialFieldMaster');
const FieldMaster = () => import(/* webpackChunkName: "field-master" */'@/components/Admission/AdmissionMaster/FieldMaster');

const AddressTypeMaster = () => import(/* webpackChunkName: "address-type-master" */'@/components/Admission/AdmissionMaster/AddressTypeMaster');
const DivisionMaster = () => import(/* webpackChunkName: "division-master" */'@/components/Admission/AdmissionMaster/DivisionMaster');
const PinCodeMaster = () => import(/* webpackChunkName: "pincode-master" */'@/components/Admission/AdmissionMaster/PinCodeMaster');
const RelationTypeMaster = () => import(/* webpackChunkName: "relation-type-master" */'@/components/Admission/AdmissionMaster/RelationTypeMaster');
const OccupationMaster = () => import(/* webpackChunkName: "occupation-master" */'@/components/Admission/AdmissionMaster/OccupationMaster');
const CountryMaster = () => import/* webpackChunkName: "country-master" */('@/components/Admission/AdmissionMaster/CountryMaster');
const DocumentTypeMaster = () => import(/* webpackChunkName: "document-type-master" */'@/components/Admission/AdmissionMaster/DocumentTypeMaster');
const DocumentTypeStandardMaster = () => import(/* webpackChunkName: "document-type-standard-master" */'@/components/Admission/AdmissionMaster/DocumentTypeStandardMaster');
const CategoryMaster = () => import(/* webpackChunkName: "category-master" */'@/components/Admission/AdmissionMaster/CategoryMaster');
const DomacileMaster = () => import(/* webpackChunkName: "domacile-master" */'@/components/Admission/AdmissionMaster/DomacileMaster');
const CommunicationModeMaster = () => import(/* webpackChunkName: "communication-master" */'@/components/Admission/AdmissionMaster/CommunicationModeMaster');
const ReligionMaster = () => import(/* webpackChunkName: "religion-master" */'@/components/Admission/AdmissionMaster/ReligionMaster');
const CastMaster = () => import(/* webpackChunkName: "cast-master" */'@/components/Admission/AdmissionMaster/CastMaster');
const SubCasteMaster = () => import(/* webpackChunkName: "subcast-master" */'@/components/Admission/AdmissionMaster/SubCasteMaster');
const RationCardMaster = () => import(/* webpackChunkName: "ration-card-master" */'@/components/Admission/AdmissionMaster/RationCardMaster');
const SchoolBoardMaster = () => import(/* webpackChunkName: "school-board-master" */'@/components/Admission/AdmissionMaster/SchoolBoardMaster');
const GenderMaster = () => import(/* webpackChunkName: "gender-master" */'@/components/Admission/AdmissionMaster/GenderMaster');
const BloodGroupMaster = () => import(/* webpackChunkName: "blood-group-master" */'@/components/Admission/AdmissionMaster/BloodGroupMaster');
const LanguageMaster = () => import(/* webpackChunkName: "language-master" */'@/components/Admission/AdmissionMaster/LanguageMaster');
const FormFieldTypeMaster = () => import(/* webpackChunkName: "form-field-type-master" */'@/components/Admission/AdmissionMaster/FormFieldTypeMaster');
const DayMaster = () => import(/* webpackChunkName: "day-master" */'@/components/Admission/AdmissionMaster/DayMaster');
const RoomTypeMaster = () => import(/* webpackChunkName: "room-type-master" */'@/components/Admission/AdmissionMaster/RoomTypeMaster');
const StreamMaster = () => import(/* webpackChunkName: "stream-master" */'@/components/Admission/AdmissionMaster/StreamMaster');
const QuotaMaster = () => import(/* webpackChunkName: "quota-master" */'@/components/Admission/AdmissionMaster/QuotaMaster');
const HouseMaster = () => import(/* webpackChunkName: "house-master" */'@/components/Admission/AdmissionMaster/HouseMaster');
const MinorityMaster = () => import(/* webpackChunkName: "minority-master" */'@/components/Admission/AdmissionMaster/MinorityMaster');
const SkillMaster = () => import(/* webpackChunkName: "skill-master" */'@/components/Admission/AdmissionMaster/SkillMaster');
const InterestMaster = () => import(/* webpackChunkName: "interest-master" */'@/components/Admission/AdmissionMaster/InterestMaster');
const CareerMaster = () => import(/* webpackChunkName: "career-master" */'@/components/Admission/AdmissionMaster/CareerMaster');
const PhysicalDisabilityTypeMaster = () => import(/* webpackChunkName: "physical-disability-type-master" */'@/components/Admission/AdmissionMaster/PhysicalDisabilityTypeMaster');
const LearnerHouseMapping = () => import(/* webpackChunkName: "learner-house-mapping" */'@/components/Admission//LearnerHouseMapping');
const SemesterMaster = () => import(/* webpackChunkName: "semester-master" */'@/components/Admission/AdmissionMaster/SemesterMaster');
const SerialFieldTracking = () => import(/* webpackChunkName: "serial-field-tracking" */'@/components/Admission/AdmissionMaster/SerialFieldTracking');
const ReceiptHeadersMaster = () => import(/* webpackChunkName: "receipt-headers-master" */'@/components/Admission/AdmissionMaster/ReceiptHeadersMaster');
const CertificateTypeMaster = () => import(/* webpackChunkName: "certificate-type-master" */'@/components/Admission/AdmissionMaster/CertificateType');
const Department = () => import(/* webpackChunkName: "department-master" */'@/components/Admission/AdmissionMaster/Department')
const VaccinationMaster = () => import(/* webpackChunkName: "vaccination-master" */'@/components/Admission/AdmissionMaster/VaccinationMaster');
const TransportationModeMaster = () => import(/* webpackChunkName: "transportation-mode-master" */'@/components/Admission/AdmissionMaster/TransportationModeMaster');
const ConfigurationMaster = () => import(/* webpackChunkName: "configuration-master" */'@/components/Admission/AdmissionMaster/ConfigurationMaster');
const SectionMaster = () => import(/* webpackChunkName: "section-master" */'@/components/Admission/AdmissionMaster/SectionMaster');
const DistrictMaster = () => import(/* webpackChunkName: "district-master" */'@/components/Admission/AdmissionMaster/DistrictMaster');
const StudentTypeMaster = () => import(/* webpackChunkName: "district-master" */'@/components/Admission/AdmissionMaster/StudentTypeMaster');
const FileTypeMaster = () => import(/* webpackChunkName: "file-type-master" */'@/components/Admission/AdmissionMaster/FileTypeMaster');
//ends admission-master
const FormFieldConfig = () => import(/* webpackChunkName: "form-field-config" */'@/components/Admission/FormFieldConfig');
const SerialFieldConfig = () => import(/* webpackChunkName: "serial-field-config" */'@/components/Admission/SerialFieldConfig');
const EditStudentProfile = () => import(/* webpackChunkName: "edit-student-profile" */'@/components/Admission/Profile/Student');
const StudentProfileTabs = () => import(/* webpackChunkName: "student-profile-tabs" */'@/components/Admission/Profile/StudentProfileTabs');
const StudentPrimaryContactDetails = () => import(/* webpackChunkName: "student-primary-contact-details" */'@/components/Admission/Profile/StudentPrimaryContactDetails');
const EditEmpProfile = () => import(/* webpackChunkName: "edit-emp-profile" */'@/components/Admission/Profile/Employee');
const EditEmployeeProfile = () => import(/* webpackChunkName: "edit-employee-profile" */'@/components/Admission/Profile/EditEmployeeProfile');
const EditChildProfile = () => import(/* webpackChunkName: "edit-child-profile" */'@/components/Admission/Profile/EditChildProfile');
const EditChildProfileNew = () => import(/* webpackChunkName: "edit-child-profile-new" */'@/components/Admission/Profile/EditChildProfileNew');
const EditChildProfileByRole = () => import(/* webpackChunkName: "edit-child-profile-by-role" */'@/components/Admission/Profile/EditChildProfileByRole');
const VirtualCard = () => import(/* webpackChunkName: "virtual-card" */'@/components/Icard/VirtualCard');
const EmpProfileTabs = () => import(/* webpackChunkName: "emp-profile-tabs" */'@/components/Admission/Profile/EmployeeProfileTabs');
const StreamMapping = () => import(/* webpackChunkName: "stream-mapping" */'@/components/Admission/StreamMapping');
const AddRollNo = () => import(/* webpackChunkName: "add-roll-no" */'@/components/Admission/AddRollNo');
const ChangeOfferDivision = () => import(/* webpackChunkName: "change-offer-division" */'@/components/Admission/ChangeOfferDivision');
const PayAdmissionFee = () => import(/* webpackChunkName: "pay-admission-fee" */'@/components/PayAdmissionFee');

const WWSGeneratePRN = () => import('@/components/Admission/WWSGeneratePRN.');
const OfferTemplate = () => import('@/components/Admission/ElectiveAdmission/OfferTemplate');
const AllocateElectiveChoices = () => import('@/components/Admission/ElectiveAdmission/AllocateElectiveChoices');
//ends admission
//Admin...........................................................................
const SignIn = () => import(/* webpackChunkName: "sign-in" */'@/components/Admin/Login/SignIn');
const AdminDashboard = () => import(/* webpackChunkName: "admin-dashboard" */'@/components/Admin/AdminDashboard');
const TenantModuleManagement = () => import(/* webpackChunkName: "tenant-module-management" */'@/components/Admin/TenantModuleManagement');
const CreateAdmin = () => import(/* webpackChunkName: "create-admin" */'@/components/Admin/CreateAdmin');
const AccessControl = () => import(/* webpackChunkName: "access-control-admin" */'@/components/Admin/AccessControl');
const AdminAddOrganization = () => import(/* webpackChunkName: "admin-add-organization" */'@/components/Admin/Organization/AdminAddOrganization');
const PushMastersToTenant = () => import(/* webpackChunkName: "push-masters-to-tenant" */'@/components/Admin/PushMastersToTenant');
const AdminSuperMaster = () => import(/* webpackChunkName: "admin-super-master" */'@/components/Admin/SuperMaster/AdminSuperMaster');
const AdminAddTenant = () => import(/* webpackChunkName: "admin-add-tenant" */'@/components/Admin/AdminAddTenant');
const AdminApplicationStatus = () => import(/* webpackChunkName: "admin-application-status" */'@/components/Admin/SuperMaster/AdminApplicationStatus');
const AdminGenderMaster = () => import(/* webpackChunkName: "admin-gender-master" */'@/components/Admin/SuperMaster/AdminGenderMaster');
const AdminUserTypeMaster = () => import(/* webpackChunkName: "admin-user-type-master" */'@/components/Admin/SuperMaster/AdminUserTypeMaster');
const AdminLanguageMaster = () => import(/* webpackChunkName: "admin-language-master" */'@/components/Admin/SuperMaster/AdminLanguageMaster');
const AdminAcademicYearMaster = () => import(/* webpackChunkName: "admin-academic-year-master" */'@/components/Admin/SuperMaster/AdminAcademicYearMaster');
const AdminAddressTypeMaster = () => import(/* webpackChunkName: "admin-address-type-master" */'@/components/Admin/SuperMaster/AdminAddressTypeMaster');
//const AdminDivisionMaster = () => import(/* webpackChunkName: "admin-division-master" */'@/components/Admin/SuperMaster/AdminDivisionMaster');
const AdminAdmissionStatusMaster = () => import(/* webpackChunkName: "admin-admission-status-master" */'@/components/Admin/SuperMaster/AdminAdmissionStatusMaster');
const AdminBankMaster = () => import(/* webpackChunkName: "admin-bank-master" */'@/components/Admin/SuperMaster/AdminBankMaster');
const AdminBloodGroupMaster = () => import(/* webpackChunkName: "admin-blood-group-master" */'@/components/Admin/SuperMaster/AdminBloodGroupMaster');
const AdminCalenderYearMaster = () => import(/* webpackChunkName: "admin-calender-year-master" */'@/components/Admin/SuperMaster/AdminCalenderYearMaster');
const AdminCastMaster = () => import(/* webpackChunkName: "admin-cast-master" */'@/components/Admin/SuperMaster/AdminCastMaster');
const AdminCategoryMaster = () => import(/* webpackChunkName: "admin-category-master" */'@/components/Admin/SuperMaster/AdminCategoryMaster');
const AdminCommunicationTypeMaster = () => import(/* webpackChunkName: "admin-communication-type-master" */'@/components/Admin/SuperMaster/AdminCommunicationTypeMaster');
const AdminCountryMaster = () => import(/* webpackChunkName: "admin-country-master" */'@/components/Admin/SuperMaster/AdminCountryMaster');
const AdminCourseRuleMaster = () => import(/* webpackChunkName: "admin-course-rule-master" */'@/components/Admin/SuperMaster/AdminCourseRuleMaster');
const AdminDocumentTypeMaster = () => import(/* webpackChunkName: "admin-document-type-master" */'@/components/Admin/SuperMaster/AdminDocumentTypeMaster');
const AdminDomacileMaster = () => import(/* webpackChunkName: "admin-domacile-master" */'@/components/Admin/SuperMaster/AdminDomacileMaster');
const AdminFeesComponentMaster = () => import(/* webpackChunkName: "admin-fees-component-master" */'@/components/Admin/SuperMaster/AdminFeesComponentMaster');
const AdminFeesDepositeTypeMaster = () => import(/* webpackChunkName: "admin-fees-deposite-type-master" */'@/components/Admin/SuperMaster/AdminFeesDepositeTypeMaster');
const AdminFeesInstallmentMaster = () => import(/* webpackChunkName: "admin-fees-deposite-installment-master" */'@/components/Admin/SuperMaster/AdminFeesInstallmentMaster');
const AdminFieldTypeMaster = () => import(/* webpackChunkName: "admin-field-type-master" */'@/components/Admin/SuperMaster/AdminFieldTypeMaster');
const AdminFieldMaster = () => import(/* webpackChunkName: "admin-field-master" */'@/components/Admin/SuperMaster/AdminFieldMaster');
const AdminLinkMaster = () => import(/* webpackChunkName: "admin-link-master" */'@/components/Admin/SuperMaster/AdminLinkMaster');
const AdminLogoPurposeMaster = () => import(/* webpackChunkName: "admin-logo-purpose-master" */'@/components/Admin/SuperMaster/AdminLogoPurposeMaster');
const AdminModuleMaster = () => import(/* webpackChunkName: "admin-module-master" */'@/components/Admin/SuperMaster/AdminModuleMaster');
const AdminOccupationMaster = () => import(/* webpackChunkName: "admin-occupation-master" */'@/components/Admin/SuperMaster/AdminOccupationMaster');
const AdminPaymentModeMaster = () => import(/* webpackChunkName: "admin-payment-mode-master" */'@/components/Admin/SuperMaster/AdminPaymentModeMaster');
const AdminPinMaster = () => import(/* webpackChunkName: "admin-pin-master" */'@/components/Admin/SuperMaster/AdminPinMaster');
const AdminRelationTypeMaster = () => import(/* webpackChunkName: "admin-relation-master" */'@/components/Admin/SuperMaster/AdminRelationTypeMaster');
const AdminReligionMaster = () => import(/* webpackChunkName: "admin-religion-master" */'@/components/Admin/SuperMaster/AdminReligionMaster');
const AdminSchoolBoardMaster = () => import(/* webpackChunkName: "admin-school-board-master" */'@/components/Admin/SuperMaster/AdminSchoolBoardMaster');
const AdminSerialFieldTypeMaster = () => import(/* webpackChunkName: "admin-serial-field-type-master" */'@/components/Admin/SuperMaster/AdminSerialFieldTypeMaster');
const AdminStandardMaster = () => import(/* webpackChunkName: "admin-standard-master" */'@/components/Admin/SuperMaster/AdminStandardMaster');
const AdminTemplatePageSizeMaster = () => import(/* webpackChunkName: "admin-template-page-size-master" */'@/components/Admin/SuperMaster/AdminTemplatePageSizeMaster');
const AdminTransportStatusSuperMaster = () => import(/* webpackChunkName: "admin-transport-status-super-master" */'@/components/Admin/SuperMaster/AdminTransportStatusSuperMaster');
const AdminCommunicationModeMaster = () => import(/* webpackChunkName: "admin-communication-mode-master" */'@/components/Admin/SuperMaster/AdminCommunicationModeMaster');
const AdminRoleTypeMaster = () => import(/* webpackChunkName: "admin-role-type-master" */'@/components/Admin/SuperMaster/AdminRoleTypeMaster');
const AdminAssessmentType = () => import(/* webpackChunkName: "admin-assessment-type" */'@/components/Admin/SuperMaster/AdminAssessmentType');
const AdminEvaluationType = () => import(/* webpackChunkName: "admin-evaluation-type" */'@/components/Admin/SuperMaster/AdminEvaluationType');
const AdminSubjectMarksEntryType = () => import(/* webpackChunkName: "admin-subject-marks-entry-type" */'@/components/Admin/SuperMaster/AdminSubjectMarksEntryType');
const AdminEventType = () => import(/* webpackChunkName: "admin-event-type" */'@/components/Admin/SuperMaster/AdminEventType');
const AdminDayMaster = () => import(/* webpackChunkName: "admin-day-master" */'@/components/Admin/SuperMaster/AdminDayMaster');
const AdminStreamMaster = () => import(/* webpackChunkName: "admin-stream-master" */'@/components/Admin/SuperMaster/AdminStreamMaster');
const AdminQuotaMaster = () => import(/* webpackChunkName: "admin-quota-master" */'@/components/Admin/SuperMaster/AdminQuotaMaster');
const AdminRoomTypeMaster = () => import(/* webpackChunkName: "admin-room-type-master" */'@/components/Admin/SuperMaster/AdminRoomTypeMaster');
const AdminComponentCategoryMaster = () => import(/* webpackChunkName: "admin-component-category-master" */'@/components/Admin/SuperMaster/AdminComponentCategoryMaster');
const ActivityTypeSuperMaster = () => import(/* webpackChunkName: "activity-type-super-master" */'@/components/Admin/SuperMaster/ActivityTypeSuperMaster');
const AwardTypeSuperMaster = () => import(/* webpackChunkName: "award-type-super-master" */'@/components/Admin/SuperMaster/AwardTypeSuperMaster');
const DegreeSuperMaster = () => import(/* webpackChunkName: "degree-super-master" */'@/components/Admin/SuperMaster/DegreeSuperMaster');
const ERPClassSuperMaster = () => import(/* webpackChunkName: "erp-class-super-master" */'@/components/Admin/SuperMaster/ERPClassSuperMaster');
const ExperienceTypeSuperMaster = () => import(/* webpackChunkName: "experience-type-super-master" */'@/components/Admin/SuperMaster/ExperienceTypeSuperMaster');
const PublicationCategorySuperMastre = () => import(/* webpackChunkName: "publication-category-super-mastre" */'@/components/Admin/SuperMaster/PublicationCategorySuperMastre');
const PublicationIndexTypeSuperMaster = () => import(/* webpackChunkName: "publication-index-type-super-master" */'@/components/Admin/SuperMaster/PublicationIndexTypeSuperMaster');
const PublicationTypeSuperMaster = () => import(/* webpackChunkName: "publication-type-super-master" */'@/components/Admin/SuperMaster/PublicationTypeSuperMaster');
const ResearchStatusSuperMaster = () => import(/* webpackChunkName: "research-status-super-master" */'@/components/Admin/SuperMaster/ResearchStatusSuperMaster');
const ResearchTypeSuperMaster = () => import(/* webpackChunkName: "research-type-super-master" */'@/components/Admin/SuperMaster/ResearchTypeSuperMaster');
const QuizTypeSuperMaster = () => import(/* webpackChunkName: "quiz-type-super-master" */'@/components/Admin/SuperMaster/QuizTypeSuperMaster');
const SelfApprisalAuthorityTypeSuperMaster = () => import(/* webpackChunkName: "self-appraisal-authority-type-super-master" */'@/components/Admin/SuperMaster/SelfApprisalAuthorityTypeSuperMaster');
const MobileAppLinksSuperMaster = () => import(/* webpackChunkName: "mobile-app-links-super-master" */'@/components/Admin/SuperMaster/MobileAppLinksSuperMaster');
// Add Super Masters
const EventTypeSuperMaster = () => import(/* webpackChunkName: "admin-event-type-super-master" */'@/components/Admin/SuperMaster/EventTypeSuperMaster');
const CourseTypeSuperMaster = () => import(/* webpackChunkName: "admin-course-type-super-master" */'@/components/Admin/SuperMaster/CourseTypeSuperMaster');
const PrimaryReportCardCourseTypeSuperMaster = () => import(/* webpackChunkName: "admin-primary-report-card-course-type-super-master" */'@/components/Admin/SuperMaster/PrimaryReportCardCourseTypeSuperMaster');
const RubricsSuperMaster = () => import(/* webpackChunkName: "admin-rubrics-super-master" */'@/components/Admin/SuperMaster/RubricsSuperMaster');
const RubricsHeaderSuperMaster = () => import(/* webpackChunkName: "admin-rubrics-header-super-master" */'@/components/Admin/SuperMaster/RubricsHeaderSuperMaster');
const PaymentTransactionStatusSuperMaster = () => import(/* webpackChunkName: "admin-payment-transaction-status-super-master" */'@/components/Admin/SuperMaster/PaymentTransactionStatusSuperMaster');
const PaymentTypeSuperMaster = () => import(/* webpackChunkName: "admin-payment-type-super-master" */'@/components/Admin/SuperMaster/PaymentTypeSuperMaster');
const PaymentGatewaySuperMaster = () => import(/* webpackChunkName: "admin-payment-gateway-super-master" */'@/components/Admin/SuperMaster/PaymentGatewaySuperMaster');
const CertificateTypeSuperMaster = () => import(/* webpackChunkName: "admin-certificate-type-super-master" */'@/components/Admin/SuperMaster/CertificateTypeSuperMaster');
const EventBookingStatusSuperMaster = () => import(/* webpackChunkName: "admin-event-booking-status-super-master" */'@/components/Admin/SuperMaster/EventBookingStatusSuperMaster');
const FamilyTypeSuperMaster = () => import(/* webpackChunkName: "admin-family-type-super-master" */'@/components/Admin/SuperMaster/FamilyTypeSuperMaster');
const RationCardSuperMaster = () => import(/* webpackChunkName: "admin-ration-card-super-master" */'@/components/Admin/SuperMaster/RationCardSuperMaster');
const MaritalStatusSuperMaster = () => import(/* webpackChunkName: "admin-marital-status-super-master" */'@/components/Admin/SuperMaster/MaritalStatusSuperMaster');
const EmployeeTypeSuperMaster = () => import(/* webpackChunkName: "admin-employee-type-super-master" */'@/components/Admin/SuperMaster/EmployeeTypeSuperMaster');
const DesignationSuperMaster = () => import(/* webpackChunkName: "admin-designation-super-master" */'@/components/Admin/SuperMaster/DesignationSuperMaster');
const EmployeeShiftSuperMaster = () => import(/* webpackChunkName: "admin-employee-shift-super-master" */'@/components/Admin/SuperMaster/EmployeeShiftSuperMaster');
const SemesterSuperMaster = () => import(/* webpackChunkName: "admin-semester-super-master" */'@/components/Admin/SuperMaster/SemesterSuperMaster');
const DivisionSuperMaster = () => import(/* webpackChunkName: "admin-division-super-master" */'@/components/Admin/SuperMaster/DivisionSuperMaster');
const SectionSuperMaster = () => import(/* webpackChunkName: "admin-section-super-master" */'@/components/Admin/SuperMaster/SectionSuperMaster');
const SubCastSuperMaster = () => import(/* webpackChunkName: "admin-sub-cast-super-master" */'@/components/Admin/SuperMaster/SubCastSuperMaster');
const HouseSuperMaster = () => import(/* webpackChunkName: "admin-house-super-master" */'@/components/Admin/SuperMaster/HouseSuperMaster');
const DocumentCategorySuperMaster = () => import(/* webpackChunkName: "admin-document-category-super-master" */'@/components/Admin/SuperMaster/DocumentCategorySuperMaster');
const DocumentLevelSuperMaster = () => import(/* webpackChunkName: "admin-document-level-super-master" */'@/components/Admin/SuperMaster/DocumentLevelSuperMaster');
const VaccinationMasterSuperMaster = () => import(/* webpackChunkName: "admin-vaccination-super-master" */'@/components/Admin/SuperMaster/VaccinationMasterSuperMaster');
const AdmissionInstructionsSuperMaster = () => import(/* webpackChunkName: "admin-admission-instructions-super-master" */'@/components/Admin/SuperMaster/AdmissionInstructionsSuperMaster');
const RoleSuperMaster = () => import(/* webpackChunkName: "admin-admission-instructions-super-master" */'@/components/Admin/SuperMaster/RoleSuperMaster');

const LeaveAcademicYearSuperMaster = () => import(/* webpackChunkName: "leave-academic-year-super-master" */'@/components/Admin/SuperMaster/LeaveAcademicYearSuperMaster');
const LeaveTypeSuperMaster = () => import(/* webpackChunkName: "leave-type-super-master" */'@/components/Admin/SuperMaster/LeaveTypeSuperMaster');
const LeaveApprovalStatusSuperMaster = () => import(/* webpackChunkName: "leave-approval-status-super-master" */'@/components/Admin/SuperMaster/LeaveApprovalStatusSuperMaster');
const LeaveApprovalAuthoritySuperMaster = () => import(/* webpackChunkName: "leave-approval-authority-super-master" */'@/components/Admin/SuperMaster/LeaveApprovalAuthoritySuperMaster');
const CalendarMonthSuperMaster = () => import(/* webpackChunkName: "calendar-month-super-master" */'@/components/Admin/SuperMaster/CalendarMonthSuperMaster');
const InOutBufferTimeSuperMaster = () => import(/* webpackChunkName: "in-out-buffer-time-super-master" */'@/components/Admin/SuperMaster/InOutBufferTimeSuperMaster');
const HolidaySuperMaster = () => import(/* webpackChunkName: "hoilday-super-master" */'@/components/Admin/SuperMaster/HolidaySuperMaster');
const DiaryMessageTypeSuperMaster = () => import(/* webpackChunkName: "diary-message-super-master" */'@/components/Admin/SuperMaster/DiaryMessageTypeSuperMaster');
const QueryTypeSuperMaster = () => import(/* webpackChunkName: "query-type-super-master" */'@/components/Admin/SuperMaster/QueryTypeSuperMaster');
const QueryCategorySuperMaster = () => import(/* webpackChunkName: "query-category-super-master" */'@/components/Admin/SuperMaster/QueryCategorySuperMaster');
const IODepartmentTypeSuperMaster = () => import(/* webpackChunkName: "io-department-type-super-master" */'@/components/Admin/SuperMaster/IODepartmentTypeSuperMaster');
const MaintenanceSectionSuperMaster = () => import(/* webpackChunkName: "maintenance-section-super-master" */'@/components/Admin/SuperMaster/MaintenanceSectionSuperMaster');
const QuizDifficultyLevelSuperMaster = () => import(/* webpackChunkName: "difficulty-level-super-master" */'@/components/Admin/SuperMaster/QuizDifficultyLevelSuperMaster');
const SlotTypeSuperMaster = () => import(/* webpackChunkName: "slot-type-super-master" */'@/components/Admin/SuperMaster/SlotTypeSuperMaster');
const TimetableEventSuperMaster = () => import(/* webpackChunkName: "timetable-event-super-master" */'@/components/Admin/SuperMaster/TimetableEventSuperMaster');
const RouteStopSuperMaster = () => import(/* webpackChunkName: "rote-stop-super-master" */'@/components/Admin/SuperMaster/RouteStopSuperMaster');
const TransportApprovalAuthoritySuperMaster = () => import(/* webpackChunkName: "transport-approval-authority-super-master" */'@/components/Admin/SuperMaster/TransportApprovalAuthoritySuperMaster');
const CanteenApprovalAuthoritySuperMaster = () => import(/* webpackChunkName: "canteen-approval-authority-super-master" */'@/components/Admin/SuperMaster/CanteenApprovalAuthoritySuperMaster');
const CanteenMenuTypeSuperMaster = () => import(/* webpackChunkName: "canteen-menu-type-super-master" */'@/components/Admin/SuperMaster/CanteenMenuTypeSuperMaster');
const CanteenMenuCategorySuperMaster = () => import(/* webpackChunkName: "canteen-menu-category-super-master" */'@/components/Admin/SuperMaster/CanteenMenuCategorySuperMaster');
const CanteenApprovalStatusSuperMaster = () => import(/* webpackChunkName: "canteen-approval-status-super-master" */'@/components/Admin/SuperMaster/CanteenApprovalStatusSuperMaster');
const CanteenInstallmentTypeSuperMaster = () => import(/* webpackChunkName: "canteen-installment-type-super-master" */'@/components/Admin/SuperMaster/CanteenInstallmentTypeSuperMaster');
const PayCommissionSuperMaster = () => import(/* webpackChunkName: "pay-commission-super-master" */'@/components/Admin/SuperMaster/PayCommissionSuperMaster');
const SalaryCertificateReasonSuperMaster = () => import(/* webpackChunkName: "salary-cert-reason-super-master" */'@/components/Admin/SuperMaster/SalaryCertificateReasonSuperMaster');
const SalaryCertificateStatusSuperMaster = () => import(/* webpackChunkName: "salary-cert-status-super-master" */'@/components/Admin/SuperMaster/SalaryCertificateStatusSuperMaster');
const SalaryComponentTypeSuperMaster = () => import(/* webpackChunkName: "salary-component-type-super-master" */'@/components/Admin/SuperMaster/SalaryComponentTypeSuperMaster');
const JourneyTypeSuperMatser = () => import(/* webpackChunkName: "journey-type-super-master" */'@/components/Admin/SuperMaster/JourneyTypeSuperMatser');
const RouteSuperMaster = () => import(/* webpackChunkName: "route-super-master" */'@/components/Admin/SuperMaster/RouteSuperMaster');
const MiscFeeCategorySuperMaster = () => import(/* webpackChunkName: "misc-fee-cat-super-master" */'@/components/Admin/SuperMaster/MiscFeeCategorySuperMaster');
const BookReviewCriteriaTypeSuperMaster = () => import(/* webpackChunkName: "book-review-criteria-type-super-master" */'@/components/Admin/SuperMaster/BookReviewCriteriaTypeSuperMaster');
const MinoritySuperMaster = () => import(/* webpackChunkName: "minority-super-master" */'@/components/Admin/SuperMaster/MinoritySuperMaster');
const SkillSuperMaster = () => import(/* webpackChunkName: "skill-super-master" */'@/components/Admin/SuperMaster/SkillSuperMaster');
const InterestSuperMaster = () => import(/* webpackChunkName: "interest-super-master" */'@/components/Admin/SuperMaster/InterestSuperMaster');
const CareerSuperMaster = () => import(/* webpackChunkName: "career-super-master" */'@/components/Admin/SuperMaster/CareerSuperMaster');
const PhysicalDisabilityTypeSuperMaster = () => import(/* webpackChunkName: "physical-disability-type-super-master" */'@/components/Admin/SuperMaster/PhysicalDisabilityTypeSuperMaster');
const InvApprovalStatusSuperMaster = () => import(/* webpackChunkName: "inv-approval-status-super-master" */'@/components/Admin/SuperMaster/InvApprovalStatusSuperMaster');
const InvDeadstockStatusSuperMaster = () => import(/* webpackChunkName: "inv-deadstock-status-super-master" */'@/components/Admin/SuperMaster/InvDeadstockStatusSuperMaster');
const InvFinanceApprovingAuthoritySuperMaster = () => import(/* webpackChunkName: "inv-finance-approval-auth-super-master" */'@/components/Admin/SuperMaster/InvFinanceApprovingAuthoritySuperMaster');
const InvMaterialTypeSuperMaster = () => import(/* webpackChunkName: "inv-material-type-super-master" */'@/components/Admin/SuperMaster/InvMaterialTypeSuperMaster');
const GradingSchemeSuperMaster = () => import(/* webpackChunkName: "grading-scheme-super-master" */'@/components/Admin/SuperMaster/GradingSchemeSuperMaster');
const AssessmentSchemeSuperMaster = () => import(/* webpackChunkName: "assessment-scheme-super-master" */'@/components/Admin/SuperMaster/AssessmentSchemeSuperMaster');
const DefaultValueTypeSuperMaster = () => import(/* webpackChunkName: "defaulr-value-type-super-master" */'@/components/Admin/SuperMaster/DefaultValueTypeSuperMaster');


const FeedbackTypeSuperMaster = () => import(/* webpackChunkName: "feedback-type-super-master" */'@/components/Admin/SuperMaster/FeedbackTypeSuperMaster');
const FeedbackQuestionTypeSuperMaster = () => import(/* webpackChunkName: "feedback-question-type-super-master" */'@/components/Admin/SuperMaster/FeedbackQuestionTypeSuperMaster');
const SubjectTypeSuperMaster = () => import(/* webpackChunkName: "subject-type-super-master" */'@/components/Admin/SuperMaster/SubjectTypeSuperMaster');
const AssessmentDetailsFormulaSuperMaster = () => import(/* webpackChunkName: "assessment-details-formula-super-master" */'@/components/Admin/SuperMaster/AssessmentDetailsFormulaSuperMaster');
const ConfigurationSuperMaster = () => import(/* webpackChunkName: "configuration-super-master" */'@/components/Admin/SuperMaster/ConfigurationSuperMaster');
const SalaryRuleSuperMaster = () => import(/* webpackChunkName: "salary-rule-super-master" */'@/components/Admin/SuperMaster/SalaryRuleSuperMaster');
const FileJourneyTypeSuperMaster = () => import(/* webpackChunkName: "file-journey-type-super-master" */'@/components/Admin/SuperMaster/FileJourneyTypeSuperMaster');
const MaintenanceStatusSuperMaster = () => import(/* webpackChunkName: "maintenance-status-master" */'@/components/Admin/SuperMaster/MaintenanceStatusSuperMaster');
const VisitTypeSuperMaster = () => import(/* webpackChunkName: "visit-type-super-master" */'@/components/Admin/SuperMaster/VisitTypeSuperMaster');
const CreateBulkRoles = () => import(/* webpackChunkName: "create-bulk-roles" */'@/components/Admin/CreateBulkRoles');
//Admin ends
//Examination
const ImportSubjectOffering = () => import(/* webpackChunkName: "import-subject-offering" */'@/components/Examination/ImportSubjectOffering');
const ImportSubject = () => import(/* webpackChunkName: "import-subject" */'@/components/Examination/ImportSubject');
const ChangeLearnerSubjectGrade = () => import(/* webpackChunkName: "change-learner-subject-grade" */'@/components/Examination/ChangeLearnerSubjectGrade');
const CopySubjectOffering = () => import(/* webpackChunkName: "copy-subject-offering" */'@/components/Examination/CopySubjectOffering');
const ImportCourseOfferingLearner = () => import(/* webpackChunkName: "import-course-offering-learner" */'@/components/Examination/ImportCourseOfferingLearner');
const ImportCourseOfferingInstructor = () => import(/* webpackChunkName: "import-course-offering-instructor" */'@/components/Examination/ImportCourseOfferingInstructor');
const SubjectRegistration = () => import(/* webpackChunkName: "subject-registration" */'@/components/Examination/SubjectRegistration');
const SubjectRemarkReport = () => import(/* webpackChunkName: "subject-remark-report" */'@/components/Examination/SubjectRemarkReport');
const SubjectMaster = () => import(/* webpackChunkName: "subject-master" */'@/components/Examination/SubjectMaster');
const OfferSubject = () => import(/* webpackChunkName: "offer-subject" */'@/components/Examination/OfferSubject');
const EditOfferSubject = () => import(/* webpackChunkName: "edit-offer-subject" */'@/components/Examination/EditOfferSubject');
const ExamMaster = () => import(/* webpackChunkName: "exam-master" */'@/components/Examination/ExamMaster');
const SubjectRule = () => import(/* webpackChunkName: "subject-rule" */'@/components/Examination/SubjectRule');
const SubjectMarksEntryType = () => import(/* webpackChunkName: "subject-marks-entry-type" */'@/components/Examination/SubjectMarksEntryType');
const AssessmentType = () => import(/* webpackChunkName: "assessment-type" */'@/components/Examination/AssessmentType');
const ManagementRoleMaster = () => import(/* webpackChunkName: "management-role-master" */'@/components/Examination/ManagementRoleMaster');
const ManagementRoleLinksMaster = () => import(/* webpackChunkName: "management-role-links-master" */'@/components/Examination/ManagementRoleLinksMaster');
const ManagementUserRolesMaster = () => import(/* webpackChunkName: "management-user-roles-master" */'@/components/Examination/ManagementUserRolesMaster');
const AssessmentTypeConfigMaster = () => import(/* webpackChunkName: "assessment-type-config-master" */'@/components/Examination/AssessmentTypeConfigMaster');
const EvaluationType = () => import(/* webpackChunkName: "evaluation-type" */'@/components/Examination/EvaluationType');
const Rubrics = () => import(/* webpackChunkName: "rubrics" */'@/components/Examination/Rubrics');
const DocumentTemplateLinking = () => import(/* webpackChunkName: "document-template-linking" */'@/components/Examination/DocumentTemplateLinking');
const DocumentTemplateType = () => import(/* webpackChunkName: "document-template-type" */'@/components/Examination/DocumentTemplateType');
const DocumentTemplate = () => import(/* webpackChunkName: "document-template" */'@/components/Examination/DocumentTemplate');
const AssessmentTypeGradeGroup = () => import(/* webpackChunkName: "assessment-type-grade-group" */'@/components/Examination/AssessmentTypeGradeGroup');
const AssessmentSchemeGroup = () => import(/* webpackChunkName: "assessment-scheme-group" */'@/components/Examination/AssessmentSchemeGroup');
const RubricsHeader = () => import(/* webpackChunkName: "rubrics-header" */'@/components/Examination/RubricsHeader');
const SubjectTeacherMapping = () => import(/* webpackChunkName: "subject-teacher-mapping" */'@/components/Examination/SubjectTeacherMapping');
const AssessmentScheme = () => import(/* webpackChunkName: "asssessment-scheme" */'@/components/Examination/AssessmentScheme/AssessmentScheme');
const DefineAssessmentScheme = () => import(/* webpackChunkName: "define-assessment-scheme" */'@/components/Examination/AssessmentScheme/DefineAssessmentScheme');
const OfferAssessmentScheme = () => import(/* webpackChunkName: "offer-assessment-scheme" */'@/components/Examination/AssessmentScheme/OfferAssessmentScheme');
const ApplyAssessmentScheme = () => import(/* webpackChunkName: "apply-assessment-scheme" */'@/components/Examination/AssessmentScheme/ApplyAssessmentScheme');
const GradingScheme = () => import(/* webpackChunkName: "grading-scheme" */'@/components/Examination/GradingScheme/GradingScheme');
const DefineGradingScheme = () => import(/* webpackChunkName: "defime-grading-scheme" */'@/components/Examination/GradingScheme/DefineGradingScheme');
const OfferGradingScheme = () => import(/* webpackChunkName: "offer-grading-scheme" */'@/components/Examination/GradingScheme/OfferGradingScheme');
const ApplyGradingScheme = () => import(/* webpackChunkName: "apply-grading-scheme" */'@/components/Examination/GradingScheme/ApplyGradingScheme');
const MarksEntry = () => import(/* webpackChunkName: "marks-entry" */'@/components/Examination/ClassTeacher/MarksEntry');
const ReportCardCommentsEntry = () => import(/* webpackChunkName: "marks-entry" */'@/components/Examination/ClassTeacher/ReportCardCommentsEntry');
const MarkEnteryICSE = () => import(/* webpackChunkName: "mark-entry-icse" */'@/components/Examination/ClassTeacher/MarkEnteryICSE');
const LearnerMarksheetAnnual = () => import(/* webpackChunkName: "learner-marksheet-annual" */'@/components/WWSExamination/Admin/LearnerMarksheetAnnual');
const LearnerMarksheetAnnualParent = () => import(/* webpackChunkName: "learner-marksheet-annual-parent" */'@/components/WWSExamination/Admin/LearnerMarksheetAnnualParent');
const MarkEntryICSEPrePrim = () => import(/* webpackChunkName: "mark-entry-icse-pre-prim" */'@/components/Examination/ClassTeacher/MarkEntryICSEPrePrim');
const LearnerMarksheetPrePrimIcse = () => import(/* webpackChunkName: "learner-marksheet-icse-pre-prim" */'@/components/WWSExamination/Admin/LearnerMarksheetPrePrimIcse');
const LearnerMarksheetPrePrimIcseParent = () => import(/* webpackChunkName: "learner-marksheet-icse-pre-prim-parent" */'@/components/WWSExamination/Admin/LearnerMarksheetPrePrimIcseParent');
const importEasyCheckMarksEntry = () => import(/* webpackChunkName: "import-easy-check-marks-entry" */'@/components/Examination/ClassTeacher/importEasyCheckMarksEntry');
const ImportMarks = () => import(/* webpackChunkName: "import-marks-entry" */'@/components/Examination/ImportMarks');
const MarksEntryStatus = () => import(/* webpackChunkName: "marks-entry-status" */'@/components/Examination/ClassTeacher/MarksEntryStatus');
const CombineSubject = () => import(/* webpackChunkName: "combine-subject" */'@/components/Examination/CombineSubject');
const ComibineMarks = () => import(/* webpackChunkName: "combine-marks" */'@/components/Examination/ComibineMarks');
const CombineMarksSbpps = () => import(/* webpackChunkName: "combine-marks-sbbps" */'@/components/Examination/CombineMarksSbpps');
const CombineMarksV2Sbpps = () => import(/* webpackChunkName: "combine-marks-sbbps-v2" */'@/components/Examination/CombineMarksV2Sbpps');
const PrimaryReportCardCourseType = () => import(/* webpackChunkName: "primary-report-card-course-type" */'@/components/Examination/PrimaryReportCardCourseType');
const SchemeAppliedStatus = () => import(/* webpackChunkName: "scheme-applied-status" */'@/components/Examination/SchemeAppliedStatus');
const ElectiveSubjectReport = () => import(/* webpackChunkName: "elective-subject-report" */'@/components/Examination/ElectiveSubjectReport');
const StudentRegistrationInfo = () => import(/* webpackChunkName: "student-registration-info" */'@/components/Examination/StudentRegistrationInfo');
const InstructorSubRegs = () => import(/* webpackChunkName: "instructor-sub-regs" */'@/components/Examination/InstructorSubRegs');
const EasyCheckRedirection = () => import(/* webpackChunkName: "easy-check-redirection" */'@/components/Examination/EasyCheck/EasyCheckRedirection');
const SubjectType = () => import(/* webpackChunkName: "subject-type" */'@/components/Examination/SubjectType');
const CourseType = () => import(/* webpackChunkName: "course-type" */'@/components/Examination/CourseType');
const AssessmentDetailsFormula = () => import(/* webpackChunkName: "assessment-details-formula" */'@/components/Examination/AssessmentDetailsFormula');
const RubricsScheme = () => import(/* webpackChunkName: "rubrics-scheme" */'@/components/Examination/Admin/RubricsScheme');
const DeleteCourseOfferingLearner = () => import(/* webpackChunkName: "delete-course-offering-learner" */'@/components/Examination/Admin/DeleteCourseOfferingLearner');
const RubricSchemeReport = () => import(/* webpackChunkName: "rubrics-scheme-report" */'@/components/Examination/Admin/RubricSchemeReport');
const SubjectConsolidatedReport = () => import(/* webpackChunkName: "subject-consolidated-report" */'@/components/Examination/Admin/SubjectConsolidatedReport');
const AllRubricsSubjectConsolidatedReport = () => import(/* webpackChunkName: "all-rubrics-subject-consolidated-report" */'@/components/Examination/Admin/AllRubricsSubjectConsolidatedReport');
const AllRubricsSubjectConsolidatedReport_V2 = () => import(/* webpackChunkName: "all-rubrics-subject-consolidated-report-v2" */'@/components/Examination/Admin/AllRubricsSubjectConsolidatedReport_V2');
const AllSubjectExamReport = () => import(/* webpackChunkName: "all-subject-exam-report" */'@/components/Examination/Admin/AllSubjectExamReport');
const AssessmentAnalysis = () => import(/* webpackChunkName: "assessment-analysis-report" */'@/components/SanjivaniExamination/Report/AssessmentAnalysis');
const RubricsCombineReport = () => import(/* webpackChunkName: "rubrics-combine-report" */'@/components/SanjivaniExamination/Report/RubricsCombineReport');
const LearnerMarksheet = () => import(/* webpackChunkName: "learner-marksheet" */'@/components/Examination/Admin/LearnerMarksheet');
const SgsParentLearnerMarksheet = () => import(/* webpackChunkName: "sgs-parent-learner-marksheet" */'@/components/SanjivaniExamination/Admin/ParentLearnerMarksheet');
const LearnerMarksheetSGS = () => import(/* webpackChunkName: "learner-marksheet" */'@/components/SanjivaniExamination/Admin/LearnerMarksheet');
const AnnualMarksheetConfig = () => import(/* webpackChunkName: "annual-marksheet-config" */'@/components/SanjivaniExamination/Admin/AnnualMarksheetConfig');
const RankCalculation = () => import(/* webpackChunkName: "rank-calculation" */'@/components/Examination/RankCalculation');
const LearnetMarksheetOfClassTeacher = () => import(/* webpackChunkName: "learnet-marksheet-of-class-teacher" */'@/components/Examination/Admin/LearnetMarksheetOfClassTeacher');
const LearnetMarksheetOfAdmin = () => import(/* webpackChunkName: "learnet-marksheet-of-admin" */'@/components/Examination/Admin/LearnetMarksheetOfAdmin');
const AnnualReportSecondary = () => import(/* webpackChunkName: "annual-report-secondary" */'@/components/Examination/Admin/AnnualReportSecondary');
const AnnualMarksheet = () => import(/* webpackChunkName: "annual-marksheet" */'@/components/Examination/Admin/AnnualMarksheet');
const PrePrimaryMarksheetAdmin = () => import(/* webpackChunkName: "pre-primary-marksheet-admin" */'@/components/Examination/Admin/PrePrimaryMarksheetAdmin');
const PrePrimaryMarksheet = () => import(/* webpackChunkName: "pre-primary-marksheet" */'@/components/Examination/Admin/PrePrimaryMarksheet');
const PrePrimaryMarksheetClassTeacher = () => import(/* webpackChunkName: "pre-primary-marksheet-class-teacher" */'@/components/Examination/Admin/PrePrimaryMarksheetClassTeacher');
const TermSheet = () => import(/* webpackChunkName: "term-sheet" */'@/components/Examination/Admin/TermSheet');
const ExamCustReport = () => import(/* webpackChunkName: "exam-cust-report" */'@/components/Examination/Admin/ExamCustReport');
const TermSheetSSC = () => import(/* webpackChunkName: "term-sheet-ssc" */'@/components/Examination/Admin/TermSheetSSC');
const MarkScheduling = () => import(/* webpackChunkName: "mark-scheduling" */'@/components/Examination/Admin/MarkScheduling');
const UserBMI = () => import(/* webpackChunkName: "user-bmi" */'@/components/Examination/Admin/UserBMI');
const BMIReport = () => import(/* webpackChunkName: "bmi-report" */'@/components/Examination/Admin/BMIReport');
const BlockResult = () => import(/* webpackChunkName: "block-result" */'@/components/Examination/BlockResult');
const Block_Unblock_Result = () => import(/* webpackChunkName: "block-unblock-result" */'@/components/Examination/Block_Unblock_Result');
const Block_Unblock_Hall_Ticket = () => import(/* webpackChunkName: "block-unblock-hall-ticket" */'@/components/Examination/Block_Unblock_Hall_Ticket');
const ExamPlan = () => import(/* webpackChunkName: "exam-plan" */'@/components/Examination/ExamPlan');
const HallticketSJCK = () => import(/* webpackChunkName: "hall-ticket" */'@/components/Examination/HallticketSJCK');
const Active_Inactive_Student = () => import(/* webpackChunkName: "active-inactive-student" */'@/components/Admission/Active_Inactive_Student');
const ParentLearnerMarksheet = () => import(/* webpackChunkName: "parent-learner-mark-sheet" */'@/components/Examination/Admin/ParentLearnerMarksheet');
const ImportRubricMarks = () => import(/* webpackChunkName: "import-rubric-marks" */'@/components/Examination/ImportRubricMarks');
const LearnerRemarks = () => import(/* webpackChunkName: "import-learner-remark" */'@/components/Examination/LearnerRemarks');
const SubjectRemark = () => import(/* webpackChunkName: "import-learner-subject-remark" */'@/components/Examination/SubjectRemark');
const ImportLearnerSubjectRemark = () => import(/* webpackChunkName: "learner-subject-remark" */'@/components/Examination/ImportLearnerSubjectRemark');
const OpenHouse = () => import(/* webpackChunkName: "open-house" */'@/components/Examination/Admin/OpenHouse');
const OpenHouseWWS = () => import(/* webpackChunkName: "open-house" */'@/components/Examination/Admin/OpenHouseWWS');
const HallTicketSetting = () => import(/* webpackChunkName: "hall-ticket-setting" */'@/components/Examination/Admin/HallTicketSetting');
const CombineAssementType = () => import(/* webpackChunkName: "combine-assessment-type" */'@/components/Examination/Admin/CombineAssementType');
const NewAcademicYearSession = () => import(/* webpackChunkName: "new-academic-year-session" */'@/components/Examination/Admin/NewAcademicYearSession');
const TeacherResultAnalysis = () => import(/* webpackChunkName: "teacher-result-analysis" */'@/components/Examination/Admin/TeacherResultAnalysis');
const UpdateRubricsMarksEntry = () => import(/* webpackChunkName: "update-rubrics-marks-entry" */'@/components/Examination/ClassTeacher/UpdateRubricsMarksEntry');
const ResultAnalysis = () => import(/* webpackChunkName: "result-analysis" */'@/components/Examination/ResultAnalysis');
const SyncGradePassingMarks = () => import(/* webpackChunkName: "sync-grade-passing-marks" */'@/components/Examination/Admin/SyncGradePassingMarks');
const SubjectResultAnalysis = () => import(/* webpackChunkName: "subject-result-analysis" */'@/components/Examination/SubjectResultAnalysis');
const AssessmentTypeSubjectAvgCalc = () => import(/* webpackChunkName: "assessment-type-subject-avg-calc" */'@/components/Examination/AssessmentTypeSubjectAvgCalc');
const TeacherMarksEntryExtension = () => import(/* webpackChunkName: "teacher-marks-entry-extention" */'@/components/Examination/Admin/TeacherMarksEntryExtension');
const UploadCourseImage = () => import(/* webpackChunkName: "upload-course-image" */'@/components/Examination/UploadCourseImage');
const AllRubricsMarksSubjectReport = () => import(/* webpackChunkName: "all-rubrics-subject-report" */'@/components/Examination/Admin/AllRubricsMarksSubjectReport');
const GraceMarksCalculation = () => import(/* webpackChunkName: "grace-marks-calculation" */'@/components/Examination/Admin/GraceMarksCalculation');
const AllSubjectMarksReport = () => import(/* webpackChunkName: "all-subject-marks-report" */'@/components/Examination/Admin/AllSubjectMarksReport');
const TermResultSheet = () => import(/* webpackChunkName: "term-result-sheet" */'@/components/SanjivaniExamination/Report/TermResultSheet');
const PassFailAnalysisReports = () => import(/* webpackChunkName: "pass-fail-analysis-report" */'@/components/Examination/Admin/PassFailAnalysisReports');

const ExamSeatingPlan = () => import(/* webpackChunkName: "exam-seating-plan" */'@/components/Examination/SeatingArrangement/ExamPlan/ExamPlan');


//Examination ends

//Academics
const AddAyDetails = () => import(/* webpackChunkName: "ay-details" */'@/components/Admission/AddAyDetails');
const Studentattendance = () => import(/* webpackChunkName: "student-attendance" */'@/components/Academics/StudentAttendance');
const DataVerification = () => import(/* webpackChunkName: "data-verification" */'@/components/Academics/DataVerification');
const DeleteStudent = () => import(/* webpackChunkName: "delete-student" */'@/components/Academics/DeleteStudent');
const LearnerHistory = () => import(/* webpackChunkName: "learner-history" */'@/components/Academics/LearnerHistory');
const ImportLearnerAttendance = () => import(/* webpackChunkName: "import-learner-attendance" */'@/components/Academics/ImportLearnerAttendance');
const DeleteEmployee = () => import(/* webpackChunkName: "delete-employee" */'@/components/Academics/DeleteEmployee');
const AttendanceReport = () => import(/* webpackChunkName: "attendance-report" */'@/components/Academics/AttendanceReport');
const SemesterDateConfig = () => import(/* webpackChunkName: "semester-date-config" */'@/components/Academics/SemesterDateConfig');
const AssessmentTypeConfig = () => import(/* webpackChunkName: "assessment-type-config" */'@/components/Academics/AssessmentTypeConfig');
const Markattendance = () => import(/* webpackChunkName: "mark-attendance" */'@/components/Academics/MarkAttendance');
const Viewstudentattendance = () => import(/* webpackChunkName: "view-student-attendance" */'@/components/Academics/ViewStudentAttendance');
const AcademicDailyLogBook = () => import(/* webpackChunkName: "academic-daily-log-book" */'@/components/Academics/AcademicDailyLogBook');
const Exportattendance = () => import(/* webpackChunkName: "export-attendance" */'@/components/Academics/ExportAttendance');
const Editattendance = () => import(/* webpackChunkName: "edit-attendance" */'@/components/Academics/EditAttendance');
const Editattendancedetails = () => import(/* webpackChunkName: "edit-attendance-details" */'@/components/Academics/EditAttendanceDetails');
const StudentLeave = () => import(/* webpackChunkName: "student-leave" */'@/components/Academics/StudentLeave');
const AttendanceSummaryReport = () => import(/* webpackChunkName: "attendance-summary-report" */'@/components/Academics/AttendanceSummaryReport');
const CoursePlanExecutionTracker = () => import(/* webpackChunkName: "course-plan-execution-tracker" */'@/components/Academics/CoursePlanExecutionTracker');
const CoursePlanExecutionSanjivani = () => import(/* webpackChunkName: "course-plan-execution-tracker-sanjivani" */'@/components/Academics/CoursePlanExecutionSanjivani');
const EditSingleStudentAttendance = () => import(/* webpackChunkName: "edit-single-student-attendance" */'@/components/Academics/EditSingleStudentAttendance');
const MonthlyAttendanceReport = () => import(/* webpackChunkName: "monthly-attendance-report" */'@/components/Academics/MonthlyAttendanceReport');
const WWSAttendanceReport = () => import(/* webpackChunkName: "wws-attendance-report" */'@/components/Academics/WWSAttendanceReport');
const VVPAttendanceReport = () => import(/* webpackChunkName: "vvp-attendance-report" */'@/components/Academics/VVPAttendanceReport');
const SemesterWiseAttendanceReport = () => import(/* webpackChunkName: "semester-wise-attendance-report" */'@/components/Academics/SemesterWiseAttendanceReport');
const AcademicPlannerStudent = () => import(/* webpackChunkName: "academic-planner-student" */'@/components/Academics/AcademicPlanner/AcademicPlannerStudent');
const AcademicPlannerInstructor = () => import(/* webpackChunkName: "academic-planner-instructor" */'@/components/Academics/AcademicPlanner/AcademicPlannerInstructor');
const InstructorCalendar = () => import(/* webpackChunkName: "instructor-calendar" */'@/components/Academics/AcademicPlanner/InstructorCalendar');
const ChildAcademicPlan = () => import(/* webpackChunkName: "child-academic-plan" */'@/components/Academics/AcademicPlanner/Parent/ChildAcademicPlan');
const getChildEvent = () => import(/* webpackChunkName: "get-child-event" */'@/components/Academics/AcademicPlanner/Parent/getChildEvent');
const StudentAcademicPlan = () => import(/* webpackChunkName: "student-academic-plan" */'@/components/Academics/AcademicPlanner/Parent/StudentAcademicPlan');
const BonafideRequest = () => import(/* webpackChunkName: "bonafide-request" */'@/components/Parent/CertificateRequest/BonafideRequest');


//Attendance Academic-Planner wise
const StudentattendanceAP = () => import(/* webpackChunkName: "student-attendance-AP" */'@/components/Academics/AcademicPlanner/StudentAttendanceAP');


//Attendance Academic-calender wise

//parent academics
const StudentLeaveReport = () => import(/* webpackChunkName: "student-leave-report" */'@/components/Academics/StudentLeaveReport');
const ChildAttendance = () => import(/* webpackChunkName: "child-attendance" */'@/components/Parent/Academics/ChildAttendance');
const ViewChildAttendance = () => import(/* webpackChunkName: "view-child-attendance" */'@/components/Parent/Academics/ViewChildAttendance');
const ParentSideLogBook = () => import(/* webpackChunkName: "view-child-attendance" */'@/components/Parent/Academics/ParentSideLogBook');
const RequestLeave = () => import(/* webpackChunkName: "request-a-leave" */'@/components/Parent/Academics/RequestLeave');
const Generate_PRN_From_No = () => import(/* webpackChunkName: "generate-prn-form-no" */'@/components/Academics/Generate_PRN_From_No');


//Academics ends
//Communication
const PutFacultyNotice = () => import(/* webpackChunkName: "put-faculty-notice" */'@/components/FacultyCommunication/PutFacultyNotice');
const InstructorNotice = () => import(/* webpackChunkName: "put-faculty-notice" */'@/components/FacultyCommunication/InstructorNotice');
const CommunicationTypeMaster = () => import(/* webpackChunkName: "communication-type-master" */'@/components/CommunicationType/CommunicationTypeMaster');
const CommunicationType = () => import(/* webpackChunkName: "communication-type" */'@/components/CommunicationType/CommunicationType');
const EventType = () => import(/* webpackChunkName: "event-type" */'@/components/CommunicationType/EventType');
const CommunicationSchedule = () => import(/* webpackChunkName: "communication-schedule" */'@/components/CommunicationType/CommunicationSchedule');
const PutNoticeHW = () => import(/* webpackChunkName: "put-notice-HW" */'@/components/CommunicationType/PutNoticeHW');
const PutNoticeHWReportforTeacher = () => import(/* webpackChunkName: "put-notice-HW" */'@/components/CommunicationType/PutNoticeHWReportforTeacher');
const FacultyDashboard = () => import(/* webpackChunkName: "faculty-dashboard" */'@/components/FacultyDashboard/FacultyDashboardLanding');

const AddEvents = () => import(/* webpackChunkName: "add-events" */'@/components/CommunicationType/AddEvents');
const PutNoticeHWStudent = () => import(/* webpackChunkName: "put-notice-HW-student" */'@/components/CommunicationType/PutNoticeHWStudent');
const TeacherCalendar = () => import(/* webpackChunkName: "teacher-calendar" */'@/components/CommunicationType/TeacherCalendar');
const PutAlbum = () => import(/* webpackChunkName: "put-album" */'@/components/CommunicationType/PutAlbum');
const CordinatorPutAlbum = () => import(/* webpackChunkName: "cordinator-put-album" */'@/components/CommunicationType/CordinatorPutAlbum');
const CordinatorPutNotice = () => import(/* webpackChunkName: "cordinator-put-notice" */'@/components/CommunicationType/CordinatorPutNotice');
const CordinatorPutCalendar = () => import(/* webpackChunkName: "cordinator-put-notice" */'@/components/CommunicationType/CordinatorPutCalendar');
const ClassteacherPutAlbum = () => import(/* webpackChunkName: "class-teacher-put-album" */'@/components/CommunicationType/ClassteacherPutAlbum');
const ClassteacherPutNotice = () => import(/* webpackChunkName: "class-teacher-put-notice" */'@/components/CommunicationType/ClassteacherPutNotice');
const ClassteacherPutCalendar = () => import(/* webpackChunkName: "class-teacher-put-calendar" */'@/components/CommunicationType/ClassteacherPutCalendar');
const CommunicationStatus = () => import(/* webpackChunkName: "communication-status" */'@/components/CommunicationType/CommunicationStatus');
const PutCalendar = () => import(/* webpackChunkName: "put-calendar" */'@/components/CommunicationType/PutCalendar');
const ParentCommunicationLink = () => import(/* webpackChunkName: "parent-communication-link" */'@/components/Parent/Communication/ParentCommunicationLink');
const ParentNotice = () => import(/* webpackChunkName: "parent-notice" */'@/components/Parent/Communication/ParentNotice');
const ParentAlbum = () => import(/* webpackChunkName: "parent-album" */'@/components/Parent/Communication/ParentAlbum');
const ParentCalendar = () => import(/* webpackChunkName: "parent-calendar" */'@/components/Parent/Communication/ParentCalendar');
const AllStudentCommunication = () => import(/* webpackChunkName: "all-student-communication" */'@/components/CommunicationType/AllStudentCommunication');
const AllStudentCommunicationWithTemplate = () => import(/* webpackChunkName: "all-student-communication-with-template" */'@/components/CommunicationType/AllStudentCommunicationWithTemplate');
const AllStudentCommsNew = () => import(/* webpackChunkName: "all-student-comms-new" */'@/components/CommunicationType/AllStudentCommsNew');
const WhatsApp = () => import(/* webpackChunkName: "whats-app" */'@/components/CommunicationType/WhatsApp');
const PutNoticeHwForParent = () => import(/* webpackChunkName: "put-notice-HW-for-parent" */'@/components/CommunicationType/PutNoticeHwForParent');
const HomeworkNoticeManagement = () => import(/* webpackChunkName: "put-notice-home-work-management" */'@/components/CommunicationType/HomeworkNoticeManagement');

//communication group
const MessageStatus = () => import(/* webpackChunkName: "message-status" */'@/components/CommunicationGroup/MessageStatus');
const CreateCommunicationGroup = () => import(/* webpackChunkName: "create-communication-group" */'@/components/CommunicationGroup/CreateCommunicationGroup');
const CommunicationGroupMessage = () => import(/* webpackChunkName: "communication-group-message" */'@/components/CommunicationGroup/CommunicationGroupMessage');
const GroupNotice = () => import(/* webpackChunkName: "group-notice" */'@/components/CommunicationGroup/GroupNotice');
const ViewGroupNotice = () => import(/* webpackChunkName: "view-group-notice" */'@/components/CommunicationGroup/ViewGroupNotice');
const GroupAlbum = () => import(/* webpackChunkName: "group-album" */'@/components/CommunicationGroup/GroupAlbum');
const ViewGroupAlbum = () => import(/* webpackChunkName: "view-group-album" */'@/components/CommunicationGroup/ViewGroupAlbum');
const GroupCalendar = () => import(/* webpackChunkName: "group-calendar" */'@/components/CommunicationGroup/GroupCalendar');
const ViewGroupCalender = () => import(/* webpackChunkName: "view-group-calendar" */'@/components/CommunicationGroup/ViewGroupCalender');
const FacultyJoinGroup = () => import(/* webpackChunkName: "faculty-join-group" */'@/components/CommunicationGroup/FacultyJoinGroup');
const StudentJoinGroup = () => import(/* webpackChunkName: "student-join-group" */'@/components/CommunicationGroup/StudentJoinGroup');
const ReadGroupMessage = () => import(/* webpackChunkName: "read-group-message" */'@/components/CommunicationGroup/ReadGroupMessage');
const GroupCommunicationLink = () => import(/* webpackChunkName: "group-communication-link" */'@/components/CommunicationGroup/GroupCommunicationLink');
const ShowNotifications = () => import(/* webpackChunkName: "show-notifications" */'@/components/CommunicationGroup/ShowNotifications');




//Time Table
const TimeTableRoomOffering = () => import(/* webpackChunkName: "time-table-room-offering" */'@/components/TimeTable/TimeTableRoomOffering');
const Slot = () => import(/* webpackChunkName: "slot" */'@/components/TimeTable/Slot');
const TimeTableEvent = () => import(/* webpackChunkName: "time-table-event" */'@/components/TimeTable/Event');
const CopySlot = () => import(/* webpackChunkName: "copy-slot" */'@/components/TimeTable/CopySlot');
const ManageTimeTable = () => import(/* webpackChunkName: "manage-time-table" */'@/components/TimeTable/ManageTimeTable');
const LoadReport = () => import(/* webpackChunkName: "load-report" */'@/components/TimeTable/LoadReport');
const TeacherAbbreviation = () => import(/* webpackChunkName: "teacher-abbreviation" */'@/components/TimeTable/TeacherAbbreviation');
const TimeTableMaster = () => import(/* webpackChunkName: "time-table-master" */'@/components/TimeTable/TimeTableMaster');
const TimeTableDay = () => import(/* webpackChunkName: "time-table-day" */'@/components/TimeTable/TimeTableDay');
const TimeTableRoom = () => import(/* webpackChunkName: "time-table-room" */'@/components/TimeTable/TimeTableRoom');
const TimeTableRoomType = () => import(/* webpackChunkName: "time-table-room-type" */'@/components/TimeTable/TimeTableRoomType');
const TimeTableSlot = () => import(/* webpackChunkName: "time-table-slot" */'@/components/TimeTable/TimeTableSlot');
const TimeTableSlotType = () => import(/* webpackChunkName: "time-table-slot-type" */'@/components/TimeTable/TimeTableSlotType');
const TimeTableConstraint = () => import(/* webpackChunkName: "time-table-constraint" */'@/components/TimeTable/TimeTableConstraint');
const TimeTableConstraintParameter = () => import(/* webpackChunkName: "time-table-constraint-parameter" */'@/components/TimeTable/TimeTableConstraintParameter');
const TimeTableConstraintAssignment = () => import(/* webpackChunkName: "time-table-constraint-assignment" */'@/components/TimeTable/TimeTableConstraintAssignment');
const TimetableVersionOffering = () => import(/* webpackChunkName: "time-table-version-offering" */'@/components/TimeTable/TimetableVersionOffering');
const TimeTableVersionMaster = () => import(/* webpackChunkName: "time-table-version-master" */'@/components/TimeTable//TimeTableVersionMaster');
const CopyTimeTable = () => import(/* webpackChunkName: "copy-time-table" */'@/components/TimeTable//CopyTimeTable');



const GetFacultyTimeTable = () => import(/* webpackChunkName: "get-faculty-time-table" */'@/components/TimeTable/GetFacultyTimeTable')
const RoomTimeTable = () => import(/* webpackChunkName: "room-time-table" */'@/components/TimeTable/RoomTimeTable')
const MyTimeTable = () => import(/* webpackChunkName: "my-time-table" */'@/components/TimeTable/MyTimeTable')
const GetDivTimeTable = () => import(/* webpackChunkName: "get-div-time-table" */'@/components/TimeTable/GetDivTimeTable')
const ChildTimeTable = () => import(/* webpackChunkName: "child-time-table" */'@/components/TimeTable/ChildTimeTable')
const Library = () => import(/* webpackChunkName: "library" */'@/components/Parent/Library/Library')
const TimeTableEventType = () => import(/* webpackChunkName: "time-table-event-type" */'@/components/TimeTable/TimeTableEventType');
const GetWeakTimeTableReport = () => import(/* webpackChunkName: "get-weak-time-table-report" */'@/components/TimeTable/GetWeakTimeTableReport');
const GetClassTeacherTT = () => import(/* webpackChunkName: "get-class-teacher-TT" */'@/components/TimeTable/GetClassTeacherTT');
//Student
const StudentDetails = () => import(/* webpackChunkName: "student-details" */'@/components/TenantDashboard/StudentDetails');
const StudentTimeTable = () => import(/* webpackChunkName: "student-time-table" */'@/components/Student/LearnerTimeTable');
const ViewLearnerCalender = () => import(/* webpackChunkName: "view-learner-calender" */'@/components/Student/Communication/ViewLearnerCalender');
const ViewLearnerAlbum = () => import(/* webpackChunkName: "view-learner-album" */'@/components/Student/Communication/ViewLearnerAlbum');
const ViewLearnerNotice = () => import(/* webpackChunkName: "view-learner-notice" */'@/components/Student/Communication/ViewLearnerNotice');
const StudentJoin = () => import(/* webpackChunkName: "student-join" */'@/components/Student/Communication/JoinGroup');
const LessonPlanning = () => import(/* webpackChunkName: "lesson-planning" */'@/components/LessonPlanning/LessonPlanning');
const SetLessonPlanner = () => import(/* webpackChunkName: "set-lesson-planner" */'@/components/LessonPlanning/SetLessonPlanner');
const SetCoursePlaneForAdmin = () => import(/* webpackChunkName: "set-course-plane-for-admin" */'@/components/LessonPlanning/SetCoursePlaneForAdmin');
const LessonPlanWeek = () => import(/* webpackChunkName: "lesson-plan-week" */'@/components/LessonPlanning/LessonPlanWeek');
const LessonPlanningTeacher = () => import(/* webpackChunkName: "lesson-planning-teacher" */'@/components/LessonPlanning/LessonPlanningTeacher');
const LessonPlanExecution = () => import(/* webpackChunkName: "lesson-plan-execution" */'@/components/LessonPlanning/LessonPlanExecution');
const LessonPlanForParentStudentSide = () => import(/* webpackChunkName: "lesson-plan-for-parent-student-side" */'@/components/LessonPlanning/LessonPlanForParentStudentSide');
const LessonPlanningHeadAndPlanner = () => import(/* webpackChunkName: "lesson-plan-head-planner" */'@/components/LessonPlanning/LessonPlanningHeadAndPlanner');
const ImportLessonPlans = () => import(/* webpackChunkName: "import-lesson-plan" */'@/components/LessonPlanning/ImportLessonPlans');
const UploadGrlMapping = () => import(/* webpackChunkName: "upload-grl-mapping" */'@/components/LessonPlanning/UploadGrlMapping');
const CopyLessonPlan = () => import(/* webpackChunkName: "copy-lesson-plan" */'@/components/LessonPlanning/CopyLessonPlan');
const LessonPlanTrackingReport = () => import(/* webpackChunkName: "lesson-plan-tracking-report" */'@/components/LessonPlanning/LessonPlanTrackingReport');
//..........................................................................
//Accounts And Fees SBP
const FeesInstallmentFeesComponentMatrix = () => import(/* webpackChunkName: "fees-installment-fees-component-matrix" */'@/components/AccountingAndFees/Master/FeesInstallmentFeesComponentMatrix');
const PaytmRecheckStatus = () => import(/* webpackChunkName: "paytm-recheck-status" */'@/components/AccountingAndFees/PaytmRecheckStatus');
const FeesAccountMaster = () => import(/* webpackChunkName: "fees-account-master" */'@/components/AccountingAndFees/Master/Master');
const PaymentGatewayType = () => import(/* webpackChunkName: "payment-gateway-type" */'@/components/AccountingAndFees/Master/PaymentGatewayType');
const PaymentType = () => import(/* webpackChunkName: "payment-type" */'@/components/AccountingAndFees/Master/PaymentType');
const FeesComponentCategory = () => import(/* webpackChunkName: "fees-component-category" */'@/components/AccountingAndFees/Master/FeesComponentCategory');
const FeesComponentAcademicYear = () => import(/* webpackChunkName: "fees-component-academic-year" */'@/components/AccountingAndFees/Master/FeesComponentAcademicYear');
const PaymentTransactionStatusmaster = () => import(/* webpackChunkName: "payment-transaction-status-master" */'@/components/AccountingAndFees/Master/PaymentTransactionStatusmaster');
const OrderIdMaster = () => import(/* webpackChunkName: "order-id-master" */'@/components/AccountingAndFees/Master/OrderIdMaster')
const PaymentGatewayDetails = () => import(/* webpackChunkName: "payment-gateway-details" */'@/components/AccountingAndFees/Master/PaymentGatewayDetails')
const FeesInstallmentAcademicYear = () => import(/* webpackChunkName: "fees-installment-academic-year" */'@/components/AccountingAndFees/Master/FeesInstallmentAcademicYear');
const PaymentModeMaster_1 = () => import(/* webpackChunkName: "payment-mode-master1" */'@/components/AccountingAndFees/Master/PaymentModeMaster');
const BankMaster_1 = () => import(/* webpackChunkName: "bank-master1" */'@/components/AccountingAndFees/Master/BankMaster');
const StandardPaymentGatewayMapping = () => import(/* webpackChunkName: "standard-payment-gateway-mapping" */'@/components/AccountingAndFees/Master/StandardPaymentGatewayMapping');
const ConfigureBrunchAmount = () => import(/* webpackChunkName: "configure-brunch-amount" */'@/components/AccountingAndFees/ConfigureBrunchAmount');
const FeesStructureInstallment = () => import(/* webpackChunkName: "fees-structure-installment" */'@/components/AccountingAndFees/FeesStructureInstallment');
const LearnerQuotaHistory = () => import(/* webpackChunkName: "learner-quota-history" */'@/components/AccountingAndFees/OfficeStaff/LearnerQuotaHistory');
const SettelmentReport = () => import(/* webpackChunkName: "settelment-report" */'@/components/AccountingAndFees/OfficeStaff/SettelmentReport');
const AssignLeanerQuota = () => import(/* webpackChunkName: "assign-learner-quota" */'@/components/AccountingAndFees/OfficeStaff/AssignLeanerQuota');
const CopyFeesStructure = () => import(/* webpackChunkName: "copy-fees-structure" */'@/components/AccountingAndFees/OfficeStaff/CopyFeesStructure');
const OfficeStaffPayment = () => import(/* webpackChunkName: "office-staff-payment" */'@/components/AccountingAndFees/OfficeStaff/OfficeFeesPayment');
const OnlineFeesPaymentAdmin = () => import(/* webpackChunkName: "online-fees-payment-admin" */'@/components/AccountingAndFees/OfficeStaff/OnlineFeesPaymentAdmin');
const DeletedReceipsLogs = () => import(/* webpackChunkName: "deleted-receips-logs" */'@/components/AccountingAndFees/OfficeStaff/DeletedReceipsLogs');
const ZealStudentReceipts = () => import(/* webpackChunkName: "zeal-student-receipts" */'@/components/AccountingAndFees/OfficeStaff/ZealStudentReceipts');
const GenrateChallan = () => import(/* webpackChunkName: "generate-challan" */'@/components/AccountingAndFees/OfficeStaff/GenrateChallan');
const LearnerFeesInvoice = () => import(/* webpackChunkName: "learner-fees-invoice" */'@/components/AccountingAndFees/OfficeStaff/LearnerFeesInvoice');
const StudentGenerateChallan = () => import(/* webpackChunkName: "student-generate-challan" */'@/components/AccountingAndFees/OfficeStaff/StudentGenerateChallan');
const InstallmentStructureDetails = () => import(/* webpackChunkName: "installment-structure-details" */'@/components/AccountingAndFees/OfficeStaff/InstallmentStructureDetails');
const PaymentTransactionDailyReport = () => import(/* webpackChunkName: "payment-transaction-daily-report" */'@/components/AccountingAndFees/OfficeStaff/PaymentTransactionDailyReport');
const RoboticsFee = () => import(/* webpackChunkName: "robotics-fee" */'@/components/AccountingAndFees/OfficeStaff/RoboticsFee');
const OutstandingFees = () => import(/* webpackChunkName: "outstanding-fees" */'@/components/AccountingAndFees/OfficeStaff/OutstandingFees');
const MiscAndOtherFeesMaster = () => import(/* webpackChunkName: "misc-and-other-fees-master" */'@/components/AccountingAndFees/Master/MiscAndOtherFeesMaster');
const StandardLearnerFees = () => import(/* webpackChunkName: "standard-learner-fees" */'@/components/AccountingAndFees/OfficeStaff/StandardLearnerFees');
const GenerateRefundReceipt = () => import(/* webpackChunkName: "generate-refund-receipt" */'@/components/AccountingAndFees/OfficeStaff/GenerateRefundReceipt');
const GetStudentFeesStructure = () => import(/* webpackChunkName: "get-student-fee-structure" */'@/components/AccountingAndFees/GetStudentFeesStructure');
const ImportLearnerSelection = () => import(/* webpackChunkName: "import-learner-selection" */'@/components/AccountingAndFees/ImportLearnerSelection');
const ImportStudentFeesStructure = () => import(/* webpackChunkName: "import-student-fees-structure" */'@/components/AccountingAndFees/ImportStudentFeesStructure');
const ImportLeanerCompSelectionAmount = () => import(/* webpackChunkName: "import-learner-comp-selection-amount" */'@/components/AccountingAndFees/ImportLeanerCompSelectionAmount');
const SyncLearnerComponentSelction = () => import(/* webpackChunkName: "sync-learner-component-selection" */'@/components/AccountingAndFees/SyncLearnerComponentSelction');
const UpdateReceiptComponent = () => import(/* webpackChunkName: "update-receipt-component" */'@/components/AccountingAndFees/UpdateReceiptComponent');
const PaymentTransactionHistoryReport = () => import(/* webpackChunkName: "payment-transaction-history-report" */'@/components/AccountingAndFees/PaymentTransactionHistoryReport');
const InstallmentOutstandingReport = () => import(/* webpackChunkName: "installment-outstanding-report" */'@/components/AccountingAndFees/Reports/InstallmentOutstandingReport');
const FeesOverallPercentageReport = () => import(/* webpackChunkName: "fee-overall-percentage-report" */'@/components/AccountingAndFees/Reports/FeesOverallPercentageReport');
const AddAdmissionFeeToStd = () => import(/* webpackChunkName: "add-admission-fee-to-std" */'@/components/AccountingAndFees/AdmissionFees/AddAdmissionFeeToStd');
const AddAdmissionFeeToStud = () => import(/* webpackChunkName: "add-admission-fee-to-stud" */'@/components/AccountingAndFees/AdmissionFees/AddAdmissionFeeToStud');
const StudentAdmissionReceipt = () => import(/* webpackChunkName: "student-admission-receipt" */'@/components/AccountingAndFees/AdmissionFees/StudentAdmissionReceipt');
const OnlineFeesPaymentBillDesk = () => import(/* webpackChunkName: "online-fees-payment-bill-desk" */'@/components/AccountingAndFees/Parent/OnlineFeesPaymentBillDesk');
const LearnerInvoiceOnlineFeesPayment = () => import(/* webpackChunkName: "learner-invoice-online-payment" */'@/components/AccountingAndFees/Parent/LearnerInvoiceOnlineFeesPayment');
const ReceiptDetailsReport = () => import(/* webpackChunkName: "receipt-details-report" */'@/components/AccountingAndFees/Reports/ReceiptDetailsReport');
const DailyAyTransactionReport = () => import(/* webpackChunkName: "daily-ay-tranaction-report" */'@/components/AccountingAndFees/Reports/DailyAyTransactionReport');
const RefundReceiptReport = () => import(/* webpackChunkName: "refund-receipt-report" */'@/components/AccountingAndFees/Reports/RefundReceiptReport');
const ApplicationFormFeesPayment = () => import(/* webpackChunkName: "application-form-fees-payment" */'@/components/AccountingAndFees/OfficeStaff/ApplicationFormFeesPayment');
const InstallmentFeesPaymentSbpps = () => import(/* webpackChunkName: "inst-fees-payment" */'@/components/AccountingAndFees/OfficeStaff/InstallmentFeesPaymentSbpps');

//Reports
const TaxFeesReceipts = () => import(/* webpackChunkName: "tax-fees-receipts" */'@/components/AccountingAndFees/Reports/TaxFeesReceipts');
const TaxFeesReceiptsPrint = () => import(/* webpackChunkName: "tax-fees-receipt-print" */'@/components/AccountingAndFees/Reports/TaxFeesReceiptsPrint');
const StudentFeeReceipts = () => import(/* webpackChunkName: "student-fee-receipts" */'@/components/AccountingAndFees/OfficeStaff/StudentFeeReceipts');
const FeeDetailsReport = () => import(/* webpackChunkName: "fee-details-report" */'@/components/AccountingAndFees/Reports/FeeDetailsReport');
const FeeDetailsReportsbpps = () => import(/* webpackChunkName: "fee-details-report-sbpps" */'@/components/AccountingAndFees/Reports/FeeDetailsReportsbpps');
const FeeDetailsReportZeal = () => import(/* webpackChunkName: "fee-details-report-zeal" */'@/components/AccountingAndFees/Reports/FeeDetailsReportZeal');
const FineDetailedReport = () => import(/* webpackChunkName: "fine-details-report" */'@/components/AccountingAndFees/Reports/FineDetailedReport');
const ChallanReport = () => import(/* webpackChunkName: "challan-report" */'@/components/AccountingAndFees/Reports/ChallanReport');
const ExcessAmountReport = () => import(/* webpackChunkName: "excess-amount-report" */'@/components/AccountingAndFees/ExcessAmountReport');
const StudentFeesReceiptWws = () => import(/* webpackChunkName: "student-fees-receipt-wws" */'@/components/AccountingAndFees/OfficeStaff/StudentFeesReceiptWws');
const StudentFeesReceiptUWWS = () => import(/* webpackChunkName: "student-fees-receipt-uwws" */'@/components/AccountingAndFees/OfficeStaff/StudentFeesReceiptUWWS');
const StudentFeesReceiptSanjivani = () => import(/* webpackChunkName: "student-fees-receipt-sanjivani" */'@/components/AccountingAndFees/OfficeStaff/StudentFeesReceiptSanjivani');
const StudentFeesReceiptVvp = () => import(/* webpackChunkName: "student-fees-receipt-vvp" */'@/components/AccountingAndFees/OfficeStaff/StudentFeesReceiptVvp');
const StudentFeesReceiptDes = () => import(/* webpackChunkName: "student-fees-receipt-des" */'@/components/AccountingAndFees/OfficeStaff/StudentFeesReceiptDes');
const StudentElectiveFeesReceiptDES = () => import(/* webpackChunkName: "student-elective-fees-receipts-des" */'@/components/Admission/StudentElectiveFeesReceiptDES');
const AllReceiptVVP = () => import(/* webpackChunkName: "all-fees-receipt-vvp" */'@/components/AccountingAndFees/Reports/AllReceiptVVP');
const FeeReconciliationReport = () => import(/* webpackChunkName: "fee-reconciliation-report" */'@/components/AccountingAndFees/Reports/FeeReconciliationReport');

//Misc and other fees
const ConfigMiscAndOtherFees = () => import(/* webpackChunkName: "config-misc-and-other-fees" */'@/components/AccountingAndFees/MiscAndOtherFees/ConfigMiscAndOtherFees');
const MiscAndOtherFeesPaymentOffline = () => import(/* webpackChunkName: "misc-and-other-fees-payment-offline" */'@/components/AccountingAndFees/MiscAndOtherFees/MiscAndOtherFeesPaymentOffline');
const MiscAndOtherFeesPaymentOnline = () => import(/* webpackChunkName: "misc-and-other-fees-payment-online" */'@/components/AccountingAndFees/MiscAndOtherFees/MiscAndOtherFeesPaymentOnline');
const MiscOtherFeesPaymentBilldesk = () => import(/* webpackChunkName: "misc-other-fees-payment-bill-desk" */'@/components/AccountingAndFees/MiscAndOtherFees/MiscOtherFeesPaymentBilldesk');
const MiscAndOtherFeesPaymentReport = () => import(/* webpackChunkName: "misc-and-other-fees-payment-report" */'@/components/AccountingAndFees/MiscAndOtherFees/MiscAndOtherFeesPaymentReport');
const MiscFeeReceipt = () => import(/* webpackChunkName: "misc-fee-reciept" */'@/components/AccountingAndFees/MiscAndOtherFees/MiscFeeReceipt')
const OtherFees = () => import(/* webpackChunkName: "other-fees" */'@/components/AccountingAndFees/MiscAndOtherFees/OtherFees')
const OtherFeesReceipt = () => import(/* webpackChunkName: "other-fees-receipt" */'@/components/AccountingAndFees/MiscAndOtherFees/OtherFeesReceipt')
const MiscFeeCategory = () => import(/* webpackChunkName: "misc-fee-category" */'@/components/AccountingAndFees/MiscAndOtherFees/MiscFeeCategory')

//outstanding fees
const OfflineOutstandingPayment = () => import(/* webpackChunkName: "offline-outstanding-payment" */'@/components/AccountingAndFees/OutstandingFees/OfflineOutstandingPayment');
const OnlineOutstandingPayment = () => import(/* webpackChunkName: "online-outstanding-payment" */'@/components/AccountingAndFees/OutstandingFees/OnlineOutstandingPayment');
const OutstandingFeeBillDesk = () => import(/* webpackChunkName: "outstanding-fee-bill-desk" */'@/components/AccountingAndFees/Parent/OutstandingFeeBillDesk');
const StudentOutstandingPaymentReceipt = () => import(/* webpackChunkName: "student-outstanding-payment-receipt" */'@/components/AccountingAndFees/OutstandingFees/StudentOutstandingPaymentReceipt');
const OuststandingFeeReport = () => import(/* webpackChunkName: "outstanding-fee-report" */'@/components/AccountingAndFees/OutstandingFees/OuststandingFeeReport');
const StandardOutstandingReport = () => import(/* webpackChunkName: "standard-outstanding-report" */'@/components/AccountingAndFees/OutstandingFees/StandardOutstandingReport');

//Parent
const GetAYFeesDetails = () => import(/* webpackChunkName: "get-AY-fees-details" */'@/components/AccountingAndFees/Parent/GetAYFeesDetails');
const OnlineFeesPayment = () => import(/* webpackChunkName: "online-fees-payment" */'@/components/AccountingAndFees/Parent/OnlineFeesPayment');
const OnlineFeesPaymentSanjivani = () => import(/* webpackChunkName: "online-fees-payment-sanjivani" */'@/components/AccountingAndFees/Parent/OnlineFeesPaymentSanjivani');
const onlinefee_new_multiple = () => import(/* webpackChunkName: "online-fee-new-multiple" */'@/components/AccountingAndFees/Parent/onlinefee_new_multiple');
const ParentFeeHistory = () => import(/* webpackChunkName: "parent-fee-history" */'@/components/AccountingAndFees/Parent/ParentFeeHistory');
const ChildReceiptDetails = () => import(/* webpackChunkName: "child-receipt-details" */'@/components/AccountingAndFees/Parent/ChildReceiptDetails');
const ChildFeesReceipts = () => import(/* webpackChunkName: "child-fees-receipts" */'@/components/AccountingAndFees/Parent/ChildFeesReceipts');
const ChildMiscFeeReceipts = () => import(/* webpackChunkName: "child-misc-fee-receipts" */'@/components/AccountingAndFees/Parent/ChildMiscFeeReceipts');
const ChildOutstandingFeeReceipts = () => import(/* webpackChunkName: "child-outstanding-fee-receipts" */'@/components/AccountingAndFees/Parent/ChildOutstandingFeeReceipts');
const ParentRequestComponent = () => import(/* webpackChunkName: "parent-request-component" */'@/components/AccountingAndFees/Parent/ParentRequestComponent');
const CopyComponentDetails = () => import(/* webpackChunkName: "copy-component-details" */'@/components/AccountingAndFees/CopyComponentDetails');
const TransactionDetails = () => import(/* webpackChunkName: "transaction-details" */'@/components/AccountingAndFees/TransactionDetails');
const AddReceivableAmount = () => import(/* webpackChunkName: "add-receivable-amount" */'@/components/AccountingAndFees/AddReceivableAmount');

//------------------------------------------------------------------------

//Employee Profile
const EmployeePersonalinfo = () => import(/* webpackChunkName: "employee-personal-info" */'@/components/Admission/Profile/EmployeePersonalinfo');
const EmployeeProfilePic = () => import(/* webpackChunkName: "employee-profile-pic" */'@/components/Admission/Profile/EmployeeProfilePicture');
const EmployeeQualification = () => import(/* webpackChunkName: "employee-qualification" */'@/components/Admission/Profile/EmployeeQualification');
//.........
//Quiz Module
const QuizScheduling = () => import(/* webpackChunkName: "quiz-scheduling" */'@/components/Quiz/Teacher/QuizScheduling');
const QuizLiveDashboard = () => import(/* webpackChunkName: "quiz-live-dashboard" */'@/components/Quiz/Teacher/QuizLiveDashboard');
const QuizAssessmentSchemeMapping = () => import(/* webpackChunkName: "quiz-assessment-scheme-mapping" */'@/components/Quiz/Teacher/QuizAssessmentSchemeMapping');
const ApproveUnapproveQuestionBank = () => import(/* webpackChunkName: "approve-unapprove-question-bank" */'@/components/Quiz/Teacher/ApproveUnapproveQuestionBank');

const AccessDenied = () => import(/* webpackChunkName: "access-denied" */'@/components/AccessDenied');
//Quiz Master
const QuizMaster = () => import(/* webpackChunkName: "quiz-master" */'@/components/Quiz/Master/QuizMaster');
const QuizTypeMaster = () => import(/* webpackChunkName: "quiz-type-master" */'@/components/Quiz/Master/QuizTypeMaster');
const DifficultyLevelMaster = () => import(/* webpackChunkName: "quiz-type-master" */'@/components/Quiz/Master/DifficultyLevelMaster');
const ChapterMaster = () => import(/* webpackChunkName: "chapter-master" */'@/components/Quiz/Master/ChapterMaster');
const TopicMaster = () => import(/* webpackChunkName: "chapter-master" */'@/components/Quiz/Master/TopicMaster');


//Quiz..................
const QuestionBankDashboard = () => import(/* webpackChunkName: "question-bank-dashboard" */'@/components/Quiz/Teacher/QuestionBankDashboard');
const ImportQuizQuestionList = () => import(/* webpackChunkName: "question-bank-dashboard" */'@/components/Quiz/Teacher/ImportQuizQuestionList');
const EditQuestionBank = () => import(/* webpackChunkName: "edit-question-bank" */'@/components/Quiz/Teacher/EditQuestionBank');
const CourseChapterCard = () => import/* webpackChunkName: "course-chapter-card" */('@/components/Quiz/Teacher/CourseChapterCard');
//learner quiz........................
const Test = () => import(/* webpackChunkName: "test" */'@/components/Quiz/Learner/Test');
const LearnerStartExam = () => import(/* webpackChunkName: "learner-start-exam" */'@/components/Quiz/Learner/LearnerStartExam');
const LearnerTestResult = () => import(/* webpackChunkName: "learner-test-result" */'@/components/Quiz/Learner/LearnerTestResult');

//Appriasal Strat
//Apprisal Masters
const ApprisalMasterMenu = () => import(/* webpackChunkName: "appraisal-master-menu" */'@/components/SelfAppriasal/Masters/MasterMenu');
const FacultyPostMaster = () => import(/* webpackChunkName: "faculty-post-master" */'@/components/SelfAppriasal/Masters/FacultyPostMaster');
const AppriasalAuthorityTypeMaster = () => import(/* webpackChunkName: "appraisal-authority-type-master" */'@/components/SelfAppriasal/Masters/AppriasalAuthorityTypeMaster');
const AuthorityTypePostLinkingMaster = () => import(/* webpackChunkName: "authority-type-post-linking-master" */'@/components/SelfAppriasal/Masters/AuthorityTypePostLinkingMaster');
const AppriasalParameterMaster = () => import(/* webpackChunkName: "appraisal-parameter-master" */'@/components/SelfAppriasal/Masters/AppriasalParameterMaster');
const SubParameterApprisalLevelLinking = () => import(/* webpackChunkName: "sub-parameter-appraisal-level-linking" */'@/components/SelfAppriasal/Masters/SubParameterApprisalLevelLinking');
const AppriasalSubParameterMaster = () => import(/* webpackChunkName: "appraisal-sub-parameter-master" */'@/components/SelfAppriasal/Masters/AppriasalSubParameterMaster');
const ApprisalLevel = () => import(/* webpackChunkName: "appraisal-level" */'@/components/SelfAppriasal/Masters/ApprisalLevel');
//Apprisal Master End
const FacultyPostLinking = () => import(/* webpackChunkName: "faculty-post-linking" */'@/components/SelfAppriasal/Masters/Faculty/FacultyPostLinking');
const FacultyAuthorityLinking = () => import(/* webpackChunkName: "faculty-authority-linking" */'@/components/SelfAppriasal/Masters/Faculty/FacultyAuthorityLinking');
const FillSelfAppriasal = () => import(/* webpackChunkName: "fill-self-appraisal" */'@/components/SelfAppriasal/Teacher/FillSelfAppriasal');
const FillSelfAppraisalSbpps = () => import(/* webpackChunkName: "fill-self-appriasal-sbpps" */'@/components/SelfAppriasal/Teacher/FillSelfAppraisalSbpps');
const ReviewSelfAppriasal = () => import(/* webpackChunkName: "review-self-appraisal" */'@/components/SelfAppriasal/Coordinator/ReviewSelfAppriasal');

const CoordinatorSelfAppriasalReport = () => import(/* webpackChunkName: "coordinator-self-appraisal-report" */'@/components/SelfAppriasal/Coordinator/CoordinatorSelfAppriasalReport');
const SelfAppriasalStatus = () => import(/* webpackChunkName: "self-appraisal-status" */'@/components/SelfAppriasal/Teacher/SelfAppriasalStatus');
const ReviewAppriasal = () => import(/* webpackChunkName: "review-appraisal" */'@/components/SelfAppriasal/Principal/ReviewAppriasal');
const EmployeeAppraisalReport = () => import(/* webpackChunkName: "employee-appraisal-report" */'@/components/SelfAppriasal/EmployeeAppraisalReport');
const GetEmployeeAppraisalReport = () => import(/* webpackChunkName: "get-employee-appraisal-report" */'@/components/SelfAppriasal/GetEmployeeAppraisalReport');
const SelfEmployeeAppraisalReport = () => import(/* webpackChunkName: "self-employee-appraisal-report" */'@/components/SelfAppriasal/SelfEmployeeAppraisalReport');
const PrincipalSelfAppraisalReport = () => import(/* webpackChunkName: "principal-self-appraisal-report" */'@/components/SelfAppriasal/Principal/PrincipalSelfAppraisalReport');
const TeacherApprisalPerformanceMeasurement = () => import(/* webpackChunkName: "teacher-appraisal-performance-measurement" */'@/components/SelfAppriasal/TeacherApprisalPerformanceMeasurement');
const BulkInstructorAppraisalReport = () => import(/* webpackChunkName: "bulk-inst-appraisal-report" */'@/components/SelfAppriasal/Report/BulkInstructorAppraisalReport');
const TeachersAppraisalReport = () => import(/* webpackChunkName: "teachers-appraisal-report" */'@/components/SelfAppriasal/Report/TeachersAppraisalReport');
//Apprisal End

//Feedback Module Start
//Feedback Master Start
const FeedbackReport = () => import(/* webpackChunkName: "feedback-report" */'@/components/Feedback/Admin/FeedbackReport');

const FeedbackMasterMenu = () => import(/* webpackChunkName: "feedback-master-menu" */'@/components/Feedback/FeedbackMasters/FeedbackMasterMenu');
const FeedbackTypeMaster = () => import(/* webpackChunkName: "feedback-type-master" */'@/components/Feedback/FeedbackMasters/FeedbackTypeMaster');
const FeedbackQuestionTypeMaster = () => import(/* webpackChunkName: "feedback-question-type-master" */'@/components/Feedback/FeedbackMasters/FeedbackQuestionTypeMaster');
const FeedbackVersionMaster = () => import(/* webpackChunkName: "feedback-version-master" */'@/components/Feedback/FeedbackMasters/FeedbackVersionMaster');
const FeedbackQuestionare = () => import(/* webpackChunkName: "feedback-questionare" */'@/components/Feedback/FeedbackMasters/FeedbackQuestionare');
//Feedback Master End
const CopyFeedbackQuestionare = () => import(/* webpackChunkName: "copy-feedback-questionare" */'@/components/Feedback/CopyFeedbackQuestionare');
const GiveStudentFeedback = () => import(/* webpackChunkName: "give-student-feedback" */'@/components/Feedback/Teacher/GiveStudentFeedback');
const PerformanceIndex = () => import(/* webpackChunkName: "performance-index" */'@/components/Feedback/Teacher/PerformanceIndex');
const GiveSubjectFeedback = () => import(/* webpackChunkName: "give-subject-feedback" */'@/components/Feedback/Student/GiveSubjectFeedback');
const FeedbackAttendance = () => import(/* webpackChunkName: "feedback-attendance" */'@/components/Feedback/FeedbackAttendance');
const SubjectFeedback = () => import(/* webpackChunkName: "subject-feedback" */'@/components/Feedback/Student/SubjectFeedback');
//Feedback Module End


//Query Module
const AddQuery = () => import(/* webpackChunkName: "add-query" */'@/components/Query/Learner/AddQuery');
const AddInstructorQuery = () => import(/* webpackChunkName: "add-instructor-query" */'@/components/Query/Instructor/AddInstructorQuery');
const QueryReportLevelOne = () => import(/* webpackChunkName: "query-report-level-one" */'@/components/Query/Instructor/QueryReportLevelOne');
const QueryReportLevelTwo = () => import(/* webpackChunkName: "query-report-level-two" */'@/components/Query/Instructor/QueryReportLevelTwo');
const QueryReportLevelThree = () => import(/* webpackChunkName: "query-report-level-three" */'@/components/Query/Instructor/QueryReportLevelThree');

const QueryMaster = () => import(/* webpackChunkName: "query-master" */'@/components/Query/QueryMaster')

//Query Module



//Leave Mangement
const LeaveMasterCards = () => import(/* webpackChunkName: "leave-master-cards" */'@/components/LeaveManagement/Admin/LeaveMasterCards');
const LeaveType = () => import(/* webpackChunkName: "leave-type" */'@/components/LeaveManagement/Admin/LeaveType');
const LeaveApprovalAuthority = () => import(/* webpackChunkName: "leave-approval-authority" */'@/components/LeaveManagement/Admin/LeaveApprovalAuthority');
const LeaveApprovalHierarchy = () => import(/* webpackChunkName: "leave-approval-hierarchy" */'@/components/LeaveManagement/Admin/LeaveApprovalHierarchy');
const LeaveMaster = () => import(/* webpackChunkName: "leave-master" */'@/components/LeaveManagement/Admin/LeaveMaster');
const LeaveApprovalStatus = () => import(/* webpackChunkName: "leave-approval-status" */'@/components/LeaveManagement/Admin/LeaveApprovalStatus');
const AllotLeaves = () => import(/* webpackChunkName: "allot-leaves" */'@/components/LeaveManagement/Admin/AllotLeaves');
const AppointAuthority = () => import(/* webpackChunkName: "appoint-authority" */'@/components/LeaveManagement/Admin/AppointAuthority');
const ReportingAuthority = () => import(/* webpackChunkName: "reporting-authority" */'@/components/LeaveManagement/Admin/ReportingAuthority');
const SetInstructorLeaveCoordinator = () => import(/* webpackChunkName: "set-instructor-leave-coordinator" */'@/components/LeaveManagement/Admin/SetInstructorLeaveCoordinator');
const LeaveTransactionReport = () => import(/* webpackChunkName: "leave-transaction-report" */'@/components/LeaveManagement/Admin/LeaveTransactionReport');
const LeaveAcademicYear = () => import(/* webpackChunkName: "leave-academic-year" */'@/components/LeaveManagement/Admin/LeaveAcademicYear');
const LeaveReports = () => import(/* webpackChunkName: "leave-data-reports" */'@/components/LeaveManagement/Report/LeaveReports');


//Coordinator
const CoordinatorLeaveApprove = () => import(/* webpackChunkName: "coordinator-leave-approve" */'@/components/LeaveManagement/Co-ordinator/CoordinatorLeaveApprove');

//Principal
const ModifyLeaveApproval = () => import(/* webpackChunkName: "modify-leave-approval" */'@/components/LeaveManagement/Principal/ModifyLeaveApproval.vue');


//instructor
const ApplyLeave = () => import(/* webpackChunkName: "apply-leave" */'@/components/LeaveManagement/Instructor/ApplyLeave');
const CancelSelfLeave = () => import(/* webpackChunkName: "cancel-self-leave" */'@/components/LeaveManagement/Instructor/CancelSelfLeave');
const MarksLeaveApprovalMatrix = () => import(/* webpackChunkName: "marks-leave-approval-matrix" */'@/components/LeaveManagement/Instructor/MarksLeaveApprovalMatrix');

//HomeWork
const learnerHomework = () => import(/* webpackChunkName: "learner-homework" */'@/components/HomeWork/Learner/Homework')
const learnerWorksheet = () => import(/* webpackChunkName: "learner-worksheet" */'@/components/HomeWork/Learner/Worksheet')
const TeacherAddHomeWork = () => import(/* webpackChunkName: "teacher-add-homework" */'@/components/HomeWork/TeacherAddHomeWork');
const TeacherEvaluateHomeWork = () => import(/* webpackChunkName: "teacher-evaluate-homework" */'@/components/HomeWork/TeacherEvaluateHomeWork');
const TeacherCheckHomeWork = () => import(/* webpackChunkName: "teacher-check-homework" */'@/components/HomeWork/TeacherCheckHomeWork');
const ParentSideHomeWork = () => import(/* webpackChunkName: "parent-side-homework" */'@/components/HomeWork/Parent/ParentSideHomeWork');
const ParentSideWorksheet = () => import(/* webpackChunkName: "parent-side-worksheet" */'@/components/HomeWork/Parent/ParentSideWorksheet');
const HomeWorkReport = () => import(/* webpackChunkName: "homework-report" */'@/components/HomeWork/HomeWorkReport');
const HomeworkTrackingReport = () => import(/* webpackChunkName: "homework-tracking-report" */'@/components/HomeWork/HomeworkTrackingReport');
const LeaveApplicationReport = () => import(/* webpackChunkName: "leave-application-report" */'@/components/HomeWork/LeaveApplicationReport');

//CourseAttendance
const CourseAttendance = () => import(/* webpackChunkName: "course-attendance"*/'@/components/CourseAttendance/CourseAttendance');
const MarkCourseAttendance = () => import(/* webpackChunkName: "mark-course-attendance"*/'@/components/CourseAttendance/MarkCourseAttendance');
const EditCourseAttendance = () => import(/* webpackChunkName: "edit-course-attendance"*/'@/components/CourseAttendance/EditCourseAttendance');
const EditCourseAttendanceDetails = () => import(/* webpackChunkName: "edit-course-attendancedetails"*/'@/components/CourseAttendance/EditCourseAttendanceDetails');

//Icard 
const InstructorIcard = () => import(/* webpackChunkName: "instructor-Icard" */'@/components/Icard/InstructorIcard')
const StudentIcard = () => import(/* webpackChunkName: "student-Icard" */'@/components/Icard/StudentIcard')
const IcardMaster = () => import(/* webpackChunkName: "Icard-master" */'@/components/Icard/IcardMaster')
const BlockLearnerIcard = () => import(/* webpackChunkName: "block-icard" */'@/components/Icard/BlockLearnerIcard')
const genrateIdcard= () => import(/* webpackChunkName: "genrateIdcard" */'@/components/IDCard/icard.vue')
const printidcard= () => import(/* webpackChunkName: "printidcardbulk" */'@/components/IDCard/printidcardbulk.vue')

//webinar
const AddWebinarTeacher = () => import(/* webpackChunkName: "add-webinar-teacher" */'@/components/Webinar/AddWebinarTeacher')
const PublishWebinar = () => import(/* webpackChunkName: "publish-webinar" */'@/components/Webinar/PublishWebinar')
const LearnerWebinar = () => import(/* webpackChunkName: "learner-webinar" */'@/components/Webinar/LearnerWebinar')

//payroll
const EmployeePayrollInfo = () => import(/* webpackChunkName: "employee-payroll-info" */'@/components/Payroll/Employee/EmployeePayrollInfo')
const EmployeeMonthlyAttendance = () => import(/* webpackChunkName: "employee-monthly-attendance" */'@/components/Payroll/Employee/EmployeeMonthlyAttendance')
const IndividualEmployeeSalaryMaster = () => import(/* webpackChunkName: "individual-employee-salary-master" */'@/components/Payroll/Employee/IndividualEmployeeSalaryMaster')
const ImportEmployeePayRollInfo = () => import(/* webpackChunkName: "import-employee-payroll-info" */'@/components/Payroll/Employee/ImportEmployeePayRollInfo')
const IncrementYear = () => import(/* webpackChunkName: "increment-year" */'@/components/Payroll/Admin/Masters/IncrementYear')
const EmployeePaymentSection = () => import(/* webpackChunkName: "employee-payment-section" */'@/components/Payroll/Admin/Masters/EmployeePaymentSection')
const MapSalaryRuleToComponent = () => import(/* webpackChunkName: "map-salary-rule-to-component" */'@/components/Payroll/Admin/Masters/MapSalaryRuleToComponent')
const SalarySubComponentMaster = () => import(/* webpackChunkName: "salary-component-sub-master" */'@/components/Payroll/Admin/Masters/SalarySubComponentMaster')
const Month = () => import(/* webpackChunkName: "month" */'@/components/Payroll/Admin/Masters/Month')
const PartialSalarySummary = () => import(/* webpackChunkName: "partial-salary-summary" */'@/components/Payroll/Admin/Masters/PartialSalarySummary')
const PayBand = () => import(/* webpackChunkName: "pay-band" */'@/components/Payroll/Admin/Masters/PayBand')
const PayCommision = () => import(/* webpackChunkName: "pay-commision" */'@/components/Payroll/Admin/Masters/PayCommision')
const PayMatrix = () => import(/* webpackChunkName: "pay-matrix" */'@/components/Payroll/Admin/Masters/PayMatrix')
const PayrollMaster = () => import(/* webpackChunkName: "payroll-master" */'@/components/Payroll/Admin/Masters/PayrollMaster')
const SalaryCertificateReason = () => import(/* webpackChunkName: "salary-certificate-reason" */'@/components/Payroll/Admin/Masters/SalaryCertificateReason')
const Salarycertificatestatus = () => import(/* webpackChunkName: "salary-certificate-status" */'@/components/Payroll/Admin/Masters/Salarycertificatestatus')
const SalaryComponent = () => import(/* webpackChunkName: "salary-component" */'@/components/Payroll/Admin/Masters/SalaryComponent')
const SalarySubComponent = () => import(/* webpackChunkName: "salary-component" */'@/components/Payroll/Admin/Masters/SalarySubComponent')
const SalaryComponentType = () => import(/* webpackChunkName: "salary-component-type" */'@/components/Payroll/Admin/Masters/SalaryComponentType')
const SalaryMonth = () => import(/* webpackChunkName: "salary-month" */'@/components/Payroll/Admin/Masters/SalaryMonth')
const SalaryRuleMaster = () => import(/* webpackChunkName: "salary-rule-master" */'@/components/Payroll/Admin/Masters/SalaryRuleMaster')
const PayrollBank = () => import(/* webpackChunkName: "payroll-bank" */'@/components/Payroll/Admin/Masters/PayrollBank')
const SalaryRuleMasterOffering = () => import(/* webpackChunkName: "salary-rule-master-offering" */'@/components/Payroll/Admin/Masters/SalaryRuleMasterOffering')
const Year = () => import(/* webpackChunkName: "year" */'@/components/Payroll/Admin/Masters/Year')
const MonthlySalaryCalculation = () => import(/* webpackChunkName: "monthly-salary-calculation" */'@/components/Payroll/Accounts/MonthlySalaryCalculation')
const EmployeeSalaryRegister = () => import(/* webpackChunkName: "employee-salary-register" */'@/components/Payroll/Accounts/EmployeeSalaryRegister.vue')
const AllEmployeeSalaryMaster = () => import(/* webpackChunkName: "all-employee-salary-master" */'@/components/Payroll/Employee/AllEmployeeSalaryMaster')
const PartialSalaryCalculation = () => import(/* webpackChunkName: "partial-salary-calculation" */'@/components/Payroll/Employee/PartialSalaryCalculation')
const EmployeeSalaryCertificateApplication = () => import(/* webpackChunkName: "employee-salary-certificate-application" */'@/components/Payroll/Employee/EmployeeSalaryCertificateApplication')
const FreezUnfreezSalaryRegister = () => import(/* webpackChunkName: "freez-unfreez-salary-register" */'@/components/Payroll/Employee/FreezUnfreezSalaryRegister')
const PaySheetSummaryReport = () => import(/* webpackChunkName: "pay-sheet-summary-report" */'@/components/Payroll/Reports/PaySheetSummaryReport')
const MonthlyPaySheetSummaryReport = () => import(/* webpackChunkName: "monthly-pay-sheet-summary-report" */'@/components/Payroll/Reports/MonthlyPaySheetSummaryReport')
const MonthlyPaySheetSummaryReport_2 = () => import(/* webpackChunkName: "monthly-pay-sheet-summary-report-2" */'@/components/Payroll/Reports/MonthlyPaySheetSummaryReport_2')
const ZealMonthlyPaySheetSummaryReport_2 = () => import(/* webpackChunkName: "zeal-monthly-pay-sheet-summary-report-2" */'@/components/Payroll/Reports/ZealMonthlyPaySheetSummaryReport_2')
const CategoryReport = () => import(/* webpackChunkName: "category-report" */'@/components/Payroll/Reports/CategoryReport')
const PayRollReport = () => import(/* webpackChunkName: "payroll-report" */'@/components/Payroll/Reports/PayRollReport')
const BankAdvice = () => import(/* webpackChunkName: "bank-advice" */'@/components/Payroll/Reports/BankAdvice')
const MonthlySalaryStatement = () => import(/* webpackChunkName: "monthly-salary-statement" */'@/components/Payroll/Reports/MonthlySalaryStatement')
const PaySlip = () => import(/* webpackChunkName: "pay-slip" */'@/components/Payroll/Employee/PaySlip')
const EmployeeSalarySummaryReport = () => import(/* webpackChunkName: "employee-salary-summary-report" */'@/components/Payroll/Reports/EmployeeSalarySummaryReport')

//zeal Examination report
const IndividualReport = () => import(/* webpackChunkName: "individual-report" */'@/components/ZealExamination/IndividualReport')
const CourseMarksAbsentStatus = () => import(/* webpackChunkName: "course-marks-absent-status" */'@/components/ZealExamination/CourseMarksAbsentStatus')
const IndividualReportAssType = () => import(/* webpackChunkName: "individual-report-ass-type" */'@/components/ZealExamination/IndividualReportAssType')
const ChildReportCard = () => import(/* webpackChunkName: "child-report-card" */'@/components/ZealExamination/Parent/ChildReportCard')
const LearnerMarksheetZeal = () => import(/* webpackChunkName: "learner-marksheet-zeal" */'@/components/ZealExamination/Admin/LearnerMarksheetZeal')
const TerminalMarklistReport = () => import(/* webpackChunkName: "terminal-marklist-report" */'@/components/ZealExamination/TerminalMarklistReport')
const TerminalMarkslistReportAssType = () => import(/* webpackChunkName: "terminal-marklist-report-ass-type" */'@/components/ZealExamination/TerminalMarkslistReportAssType')
const CombineMarksList = () => import(/* webpackChunkName: "combine-marks-list" */'@/components/ZealExamination/Admin/CombineMarksList');
const CombineCourseMarks = () => import(/* webpackChunkName: "combine-course-marks" */'@/components/ZealExamination/Admin/CombineCourseMarks');
const InstallmentDetailsReport = () => import(/* webpackChunkName: "installment-details-report" */'@/components/ZealExamination/AccountingAndFees/InstallmentDetailsReport');
const TransportFeeDetailedReport = () => import(/* webpackChunkName: "transport-details-report" */'@/components/ZealExamination/AccountingAndFees/TransportFeeDetailedReport');
const SectionInstallmentReport = () => import(/* webpackChunkName: "section-installment-report" */'@/components/ZealExamination/AccountingAndFees/SectionInstallmentReport');
const AccountDashboard = () => import(/* webpackChunkName: "account-dashboard" */'@/components/ZealExamination/AccountingAndFees/AccountDashboard');

//FAQ Question Answer
const FAQ = () => import(/* webpackChunkName: "faq" */'@/components/shared/FAQ');

//Analytics
const AnalyticalStats = () => import(/* webpackChunkName: "analytical-dashboard" */'@/components/shared/AnalyticalStats');
const InstAnalyticalStats = () => import(/* webpackChunkName: "inst-analytical-dashboard" */'@/components/shared/InstAnalyticalStats');

//shared
const Setting = () => import(/* webpackChunkName: "settings" */'@/components/shared/Setting');
//Transport
const TransportMaster = () => import(/* webpackChunkName: "transport-master" */'@/components/Transport/Admin/TransportMaster');
const RouteStopMaster = () => import(/* webpackChunkName: "route-stop-master" */'@/components/Transport/Admin/RouteStopMaster');
const TransportBusMaster = () => import(/* webpackChunkName: "transport-bus-master" */'@/components/Transport/Admin/TransportBusMaster');
const BusTimingMaster = () => import(/* webpackChunkName: "bus-timing-master" */'@/components/Transport/Admin/BusTimingMaster');
const DistanceSlabMaster = () => import(/* webpackChunkName: "distance-slab-master" */'@/components/Transport/Admin/DistanceSlabMaster');
const JourneyTypeMaster = () => import(/* webpackChunkName: "journey-master" */'@/components/Transport/Admin/JourneyTypeMaster');
const TransportApprovalAuthorityMaster = () => import(/* webpackChunkName: "transport-approval-authority-master" */'@/components/Transport/Admin/TransportApprovalAuthorityMaster');
const TransportApprovalHierarchyMaster = () => import(/* webpackChunkName: "transport-approval-hierarchy-master" */'@/components/Transport/Admin/TransportApprovalHierarchyMaster');
const TransportApprovalStatusMaster = () => import(/* webpackChunkName: "transport-approval-status-master" */'@/components/Transport/Admin/TransportApprovalStatusMaster');
const TransportRoute = () => import(/* webpackChunkName: "transport-route" */'@/components/Transport/Admin/TransportRoute');
const TransportEmployeeRoutePage = () => import(/* webpackChunkName: "transport-route" */'@/components/Transport/Admin/TransportEmployeeRoutePage');
const TransportRouteDetails = () => import(/* webpackChunkName: "transport-route-details" */'@/components/Transport/Admin/TransportRouteDetails');
const TransportInstallment = () => import(/* webpackChunkName: "transport-installment" */'@/components/Transport/Admin/TransportInstallment');
const VehicleMaster = () => import(/* webpackChunkName: "vehicle-master" */'@/components/Transport/Admin/VehicleMaster');
const ApplyTransportAdmin = () => import(/* webpackChunkName: "admin-transport-application" */'@/components/Transport/Admin/ApplyTransportAdmin');

//Transport Learner Attendance 
const TransportLearnerAttendanceReport = () => import(/* webpackChunkName: "transport-learner-attendance-report" */'@/components/TransportLearnerAttendance/TransportLearnerAttendanceReport');
const RoutewiseTransportAttendanceReport = () => import(/* webpackChunkName: "routewise-transport-attendance-report" */'@/components/TransportLearnerAttendance/RoutewiseTransportAttendanceReport');
const AddLearnerRoutes = () => import(/* webpackChunkName: "map-route-to-student" */'@/components/TransportLearnerAttendance/AddLearnerRoutes');
const StudentLateInEarlyOut = () => import(/* webpackChunkName: "student-late-in-early-out" */'@/components/TransportLearnerAttendance/StudentLateInEarlyOut');

//payment
const OfflineTransportPayment = () => import(/* webpackChunkName: "offline-transport-payment" */'@/components/Transport/Admin/OfflineTransportPayment');
const ChangeLearnerTransportRoute = () => import(/* webpackChunkName: "change-learner-transport-route" */'@/components/Transport/Admin/ChangeLearnerTransportRoute');
const BlockStudentForTransport = () => import(/* webpackChunkName: "block-student-for-transport" */'@/components/Transport/Admin/BlockStudentForTransport');
const SyncLearnerTransportFees = () => import(/* webpackChunkName: "sync-learner-transport-fees" */'@/components/Transport/Admin/SyncLearnerTransportFees');

//Report
const TransportReport = () => import(/* webpackChunkName: "transport-report" */'@/components/Transport/Reports/TransportReport');
const RouteStopReport = () => import(/* webpackChunkName: "route-stop-report" */'@/components/Transport/Reports/RouteStopReport');
const ImportTransportApplications = () => import(/* webpackChunkName: "import-transport-applications" */'@/components/Transport/Admin/ImportTransportApplications');

//Parent
const ApplyTransportFacility = () => import(/* webpackChunkName: "apply-transport-facility" */'@/components/Transport/Parent/ApplyTransportFacility');
const BusTracking = () => import(/* webpackChunkName: "bus-tracking" */'@/components/Transport/Parent/BusTracking');
const TransportReceipt = () => import(/* webpackChunkName: "transport-receipt" */'@/components/Transport/TransportReceipt');
const BusTrackingSbpps = () => import(/* webpackChunkName: "bus-tracking-sbpps" */'@/components/Transport/Parent/BusTrackingSbpps');

//Parent
//Coordinators
const ApproverTransporter = () => import(/* webpackChunkName: "approver-transporter" */'@/components/Transport/Approvers/ApproverTransporter');
const ApproverCoordinator = () => import(/* webpackChunkName: "approver-coordinator" */'@/components/Transport/Approvers/ApproverCoordinator');
const CancelTransportApplications = () => import(/* webpackChunkName: "cancel-transport-applications" */'@/components/Transport/Approvers/CancelTransportApplications');
const ChangeTransportRoute = () => import(/* webpackChunkName: "change-transport-route" */'@/components/Transport/Approvers/ChangeTransportRoute');

//Coordinators
//Inward Outward

const IOMaster = () => import(/* webpackChunkName: "IO-master" */'@/components/InwardOutward/Admin/Master');
const Inward = () => import(/* webpackChunkName: "inward" */'@/components/InwardOutward/Office/Inward');
const Outward = () => import(/* webpackChunkName: "outward" */'@/components/InwardOutward/Office/Outward');
const IOReports = () => import(/* webpackChunkName: "IO-reports" */'@/components/InwardOutward/Office/Reports');
const FileJourneyType = () => import(/* webpackChunkName: "file-journey-type" */'@/components/InwardOutward/Admin/FileJourneyType');
const InwardOutwardDepartmentType = () => import(/* webpackChunkName: "inward-outward-department-type" */'@/components/InwardOutward/Admin/InwardOutwardDepartmentType');
const InwardOutwardDepartment = () => import(/* webpackChunkName: "inward-outward-department" */'@/components/InwardOutward/Admin/InwardOutwardDepartment');
const InwardOutwardDepartmentMatrix = () => import(/* webpackChunkName: "inward-outward-department-matrix" */'@/components/InwardOutward/Admin/InwardOutwardDepartmentMatrix');
//ends
//Visitor
const AdminAddVisitor = () => import(/* webpackChunkName: "admin-add-visitor" */'@/components/VisitorMngt/User/AdminAddVisitor');
const ScheduleVisit = () => import(/* webpackChunkName: "schedule-visit" */'@/components/VisitorMngt/User/ScheduleVisit');
const VisitorMaster = () => import(/* webpackChunkName: "visitor-master" */'@/components/VisitorMngt/User/VisitorMaster');
const VisitorInstructions = () => import(/* webpackChunkName: "visitor-instructions" */'@/components/VisitorMngt/User/VisitorInstructions');
const VisitorURL = () => import(/* webpackChunkName: "visitor-url" */'@/components/VisitorMngt/User/VisitorUrl');
const VisitType = () => import(/* webpackChunkName: "visitor-type" */'@/components/VisitorMngt/User/VisitType');
const CheckIn = () => import(/* webpackChunkName: "check-in" */'@/components/VisitorMngt/User/Check-In');
const CheckOut = () => import(/* webpackChunkName: "check-out" */'@/components/VisitorMngt/User/Check-Out');
const ApproveVisit = () => import(/* webpackChunkName: "approve-visit" */'@/components/VisitorMngt/User/ApproveVisit');
const VisitorReports = () => import(/* webpackChunkName: "visitor-reports" */'@/components/VisitorMngt/User/VisitorReports');
//ends
// maintenance system
const IssueMaster = () => import(/* webpackChunkName: "issue-master" */'@/components/MaintenanceSystem/Admin/IssueMaster');
const MaintenanceSectionMaster = () => import(/* webpackChunkName: "maintenance-section-master" */'@/components/MaintenanceSystem/Admin/SectionMaster');
const StatusMaster = () => import(/* webpackChunkName: "status-master" */'@/components/MaintenanceSystem/Admin/StatusMaster');
const MaintenanceMaster = () => import(/* webpackChunkName: "maintenance-master" */'@/components/MaintenanceSystem/Admin/MaintenanceMaster');
const StaffLinking = () => import(/* webpackChunkName: "staff-linking" */'@/components/MaintenanceSystem/Admin/StaffLinking');
const IssueTracking = () => import(/* webpackChunkName: "issue-tracking" */'@/components/MaintenanceSystem/Admin/IssueTracking');
const AddIssue = () => import(/* webpackChunkName: "add-issue" */'@/components/MaintenanceSystem/Staff/AddIssue');
const ResolveIssue = () => import(/* webpackChunkName: "resolve-issue" */'@/components/MaintenanceSystem/Staff/ResolveIssue');

//Health Card
const InstructorHealthCard = () => import(/* webpackChunkName: "instructor-health-card" */'@/components/HealthCard/InstructorHealthCard');
const InstructorHealthCardForm = () => import(/* webpackChunkName: "instructor-health-card-form" */'@/components/HealthCard/InstructorHealthCardForm');
const DoctorViewForm = () => import(/* webpackChunkName: "doctor-view-form" */'@/components/HealthCard/DoctorViewForm');
const ViewInstructorHealthCard = () => import(/* webpackChunkName: "view-instructor-health-card" */'@/components/HealthCard/ViewInstructorHealthCard');
// const StudentHealthCard = () => import(/* webpackChunkName: "student-health-card" */'@/components/HealthCard/StudentHealthCard');
const StudentHealthCardForm = () => import(/* webpackChunkName: "student-health-card-form" */'@/components/HealthCard/StudentHealthCardForm');
//Health Card

//Canteen
const CanteenReportAdmin = () => import(/* webpackChunkName: "canteen-meal-report-admin" */'@/components/Canteen/Report/CanteenReportAdmin');
const CanteenReportParent = () => import(/* webpackChunkName: "canteen-meal-report-parent" */'@/components/Canteen/Report/CanteenReportParent');
const CanteenMenu = () => import(/* webpackChunkName: "canteen-menu" */'@/components/Canteen/Admin/Master/CanteenMenu');
const CanteenTransactionType = () => import(/* webpackChunkName: "canteen-transaction-type" */'@/components/Canteen/Admin/Master/CanteenTransactionType');
const MenuType = () => import(/* webpackChunkName: "menu-type" */'@/components/Canteen/Admin/Master/MenuType');
const MenuCategory = () => import(/* webpackChunkName: "menu-category" */'@/components/Canteen/Admin/Master/MenuCategory');
const ApprovalAuthority = () => import(/* webpackChunkName: "approval-authority" */'@/components/Canteen/Admin/Master/ApprovalAuthority');
const CanteenInstallmentType = () => import(/* webpackChunkName: "canteen-installment-type" */'@/components/Canteen/Admin/Master/CanteenInstallmentType');
const ApprovalHierachy = () => import(/* webpackChunkName: "approval-hierachy" */'@/components/Canteen/Admin/Master/ApprovalHierachy');
const ApprovalSatus = () => import(/* webpackChunkName: "approval-status" */'@/components/Canteen/Admin/Master/ApprovalSatus');
const CanteenMaster = () => import(/* webpackChunkName: "canteen-master" */'@/components/Canteen/Admin/Master/CanteenMaster');
const CanteenOfflineFees = () => import(/* webpackChunkName: "canteen-offline-fees" */'@/components/Canteen/Admin/CanteenOfflineFees');
const CanteenFeeStructure = () => import(/* webpackChunkName: "canteen-fee-structure" */'@/components/Canteen/Admin/CanteenFeeStructure');
const CanteenDailyMealReport = () => import(/* webpackChunkName: "canteen-daily-meal-report" */'@/components/Canteen/Admin/CanteenDailyMealReport');
const MealReport = () => import(/* webpackChunkName: "meal-report" */'@/components/Canteen/Admin/MealReport');
const CanteenDailyReceiptReport = () => import(/* webpackChunkName: "canteen-daily-receipt-report" */'@/components/Canteen/Admin/CanteenDailyReceiptReport');
const CanteenDailyMealHistory = () => import(/* webpackChunkName: "canteen-daily-meal-history" */'@/components/Canteen/Admin/CanteenDailyMealHistory');
const CanteenReceipt = () => import(/* webpackChunkName: "canteen-receipt" */'@/components/Canteen/CanteenReceipt');
const BlockStudentCanteenFacility = () => import(/* webpackChunkName: "block-student-canteen-facility" */'@/components/Canteen/Admin/BlockStudentCanteenFacility');
const SyncLearnerCanteenFees = () => import(/* webpackChunkName: "sync-learner-canteen-fees" */'@/components/Canteen/Admin/SyncLearnerCanteenFees');
const CanteenInstallment = () => import(/* webpackChunkName: "canteen-installment" */'@/components/Canteen/Admin/CanteenInstallment');
const FacultyCanteenPayment = () => import(/* webpackChunkName: "faculty-canteen-payment" */'@/components/Canteen/Faculty/FacultyCanteenPayment');
const FacultyCanteenReport = () => import(/* webpackChunkName: "faculty-canteen-report" */'@/components/Canteen/Faculty/FacultyCanteenReport');
const ApplyCanteenFacility = () => import(/* webpackChunkName: "apply-canteen-facility" */'@/components/Canteen/Parent/ApplyCanteenFacility');
const ApplyCanteenFacilityWWS = () => import(/* webpackChunkName: "apply-canteen-facility-wws" */'@/components/Canteen/Parent/ApplyCanteenFacilityWWS');
const ParentalMenuControl = () => import(/* webpackChunkName: "parent-menu-control" */'@/components/Canteen/Parent/ParentalMenuControl');
const PlaceOrder = () => import(/* webpackChunkName: "place-order" */'@/components/Canteen/Canteen/PlaceOrder');
const PlaceMealOrderWWS = () => import(/* webpackChunkName: "place-meal-order-wws" */'@/components/Canteen/Canteen/PlaceMealOrderWWS');
const CanteenApprove = () => import(/* webpackChunkName: "canteen-approve" */'@/components/Canteen/CanteenApprove/CanteenApprover');
const CancelCanteenApplication = () => import(/* webpackChunkName: "cancel-canteen-application" */'@/components/Canteen/CanteenApprove/CancelCanteenApplication');
const AccountsApprove = () => import(/* webpackChunkName: "account-approve" */'@/components/Canteen/AccountantApprove/AccountsApprove');
const WalletDailyTransactionReport = () => import(/* webpackChunkName: "wallet-daily-transaction-report" */'@/components/Canteen/Admin/WalletDailyTransactionReport');
const CanteenFeesReportWWS = () => import(/* webpackChunkName: "canteen-fees-report-wws" */'@/components/Canteen/Admin/CanteenFeesReportWWS');
const CanteenFeesReportSBPPS = () => import(/* webpackChunkName: "canteen-fees-report-sbpps" */'@/components/Canteen/Admin/CanteenFeesReportSBPPS');
const UpdateLearnerCanteenFees = () => import(/* webpackChunkName: "update-learner-canteen-fees" */'@/components/Canteen/Admin/UpdateLearnerCanteenFees');


//Canteen
//Employee Biometric
const Inoutbuffertimemaster = () => import(/* webpackChunkName: "inout-buffer-time-master" */'@/components/EmployeeBiometric/Admin/Inoutbuffertimemaster');
const InoutPlanMaster = () => import(/* webpackChunkName: "inout-plan-master" */'@/components/EmployeeBiometric/Admin/InoutPlanMaster');
const MarkUnmarkHoliday = () => import(/* webpackChunkName: "mark-unmark-holiday" */'@/components/EmployeeBiometric/Admin/MarkUnmarkHoliday');
const UpdateEmployeeAttendanceDetails = () => import(/* webpackChunkName: "update-employee-attendance-details" */'@/components/EmployeeBiometric/Admin/UpdateEmployeeAttendanceDetails');
const ApproveUnapproveAttendance = () => import(/* webpackChunkName: "approve-unapprove-attendance" */'@/components/EmployeeBiometric/Admin/ApproveUnapproveAttendance');
const ImportEmployeeAttendance = () => import(/* webpackChunkName: "import-employee-attendance" */'@/components/EmployeeBiometric/Admin/ImportEmployeeAttendance');
const Holiday = () => import(/* webpackChunkName: "holiday" */'@/components/EmployeeBiometric/Admin/Holiday');
const CreateEmployeeAttendance = () => import(/* webpackChunkName: "create-employee-attendance" */'@/components/EmployeeBiometric/Admin/CreateEmployeeAttendance');
const HolidayDetails = () => import(/* webpackChunkName: "holiday-details" */'@/components/EmployeeBiometric/Admin/HolidayDetails');
const AddInOutMaster = () => import(/* webpackChunkName: "add-inout-master" */'@/components/EmployeeBiometric/Admin/AddInOutMaster');
const MonthlyAttendanceReportBiometric = () => import(/* webpackChunkName: "monthly-attendance-report-biometric" */'@/components/EmployeeBiometric/Report/MonthlyAttendanceReportBiometric');
const EmployeeAttendanceCalendar = () => import(/* webpackChunkName: "employee-attendance-calendar" */'@/components/EmployeeBiometric/Report/EmployeeAttendanceCalendar');
const EmployeeAttendanceReportWithTime = () => import(/* webpackChunkName: "employee-attendance-report-with-time" */'@/components/EmployeeBiometric/Report/EmployeeAttendanceReportWithTime');
const CopyPayrollAttendance = () => import(/* webpackChunkName: "copy-payroll-attendance" */'@/components/EmployeeBiometric/Admin/CopyPayrollAttendance');
const CopyPayrollAttendanceV2 = () => import(/* webpackChunkName: "copy-payroll-attendance-v2" */'@/components/EmployeeBiometric/Admin/CopyPayrollAttendanceV2');
const AdminAttendanceReport = () => import(/* webpackChunkName: "admin-attendance-report" */'@/components/EmployeeBiometric/Admin/AdminAttendanceReport');
const EmployeeAttendanceReport = () => import(/* webpackChunkName: "employee-attendance-report" */'@/components/EmployeeBiometric/Admin/EmployeeAttendanceReport');
const EmployeePlanDetailedReport = () => import(/* webpackChunkName: "employee-plan-detailed-report" */'@/components/EmployeeBiometric/Admin/EmployeePlanDetailedReport');
const SyncLeaveData = () => import(/* webpackChunkName: "sync-leave-data" */'@/components/EmployeeBiometric/Admin/SyncLeaveData');
const EmployeePenaltyDetails = () => import(/* webpackChunkName: "employee-penalty-details" */'@/components/EmployeeBiometric/Admin/EmployeePenaltyDetails');
const BulkUpdateExpectedInOut = () => import(/* webpackChunkName: "bulk-update-expected-in-out" */'@/components/EmployeeBiometric/Admin/BulkUpdateExpectedInOut');

//Employee Biometric

//Appraisal SBPPS
const AppraisalCredit = () => import(/* webpackChunkName: "appraisal-credit" */'@/components/SelfAppriasal/Masters/AppraisalCredit')
const EvaluationParameter = () => import(/* webpackChunkName: "evaluation-parameter" */'@/components/SelfAppriasal/Masters/EvaluationParameter')
const HREvaluation = () => import(/* webpackChunkName: "HR-evaluation" */'@/components/SelfAppriasal/HR/HREvaluation')
const HRAppraisalParameterEvaluation = () => import(/* webpackChunkName: "HR-appraisal-parameter-evaluation" */'@/components/SelfAppriasal/HR/HRAppraisalParameterEvaluation')
const AppointAppraisalAuthority = () => import(/* webpackChunkName: "appoint-appraisal-authority" */'@/components/SelfAppriasal/Masters/AppointAppraisalAuthority')
const InstructorSelfAppraisalAuthorityTypeMapping = () => import(/* webpackChunkName: "instructor-self-appraisal-authority-type-mapping" */'@/components/SelfAppriasal/Masters/InstructorSelfAppraisalAuthorityTypeMapping')

const AuthorityAppraisalEvaluation = () => import(/* webpackChunkName: "authority-appraisal-evaluation" */'@/components/SelfAppriasal/AuthorityAppraisalEvaluation');
const EmployeeAppraisalEvaluationReport = () => import(/* webpackChunkName: "employee-appraisal-evaluation-report" */'@/components/SelfAppriasal/HR/EmployeeAppraisalEvaluationReport');

const CopyAppraisalMasters = () => import(/* webpackChunkName: "copy-appraisal-masters" */'@/components/SelfAppriasal/Masters/CopyAppraisalMasters')


//
const WebViewReceipt = () => import(/* webpackChunkName: "web-view-receipt" */'@/components/WebView/Receipt');


//Wallet
const OfflineWalletPayment = () => import(/* webpackChunkName: "offline-wallet-payment" */'@/components/Wallet/Account/OfflineWalletPayment');
const OnlineWalletPayment = () => import(/* webpackChunkName: "online-wallet-payment" */'@/components/Wallet/Account/OnlineWalletPayment');
const WalletBalanceReport = () => import(/* webpackChunkName: "wallet-balance-report" */'@/components/Wallet/Account/WalletBalanceReport');

//Live Class
const LiveClassHome = () => import(/* webpackChunkName: "live-class-home" */'@/components/LiveClass/LiveClassHome');
const LearnerLiveClassSession = () => import(/* webpackChunkName: "learner-live-class-meeting-code" */'@/components/LiveClass/LearnerLiveClassSession');
const SmartDeskReport = () => import(/* webpackChunkName: "smart-desk-report" */'@/components/LiveClass/SmartDeskReport');


//Inventory
const InventoryMasters = () => import(/* webpackChunkName: "inventory-masters" */'@/components/Inventory/Admin/InventoryMasters');
const InventoryCategory = () => import(/* webpackChunkName: "inventory-category" */'@/components/Inventory/Admin/InventoryCategory');
const InventoryMaterialType = () => import(/* webpackChunkName: "inventory-material-type" */'@/components/Inventory/Admin/InventoryMaterialType');
const InventoryMaterialSet = () => import(/* webpackChunkName: "inventory-material-set" */'@/components/Inventory/Admin/InventoryMaterialSet');
const InventoryFinanceApprovingCategory = () => import(/* webpackChunkName: "inventory-finance-approving-category" */'@/components/Inventory/Admin/InventoryFinanceApprovingCategory');
const InventoryFinanceApprovingAuthority = () => import(/* webpackChunkName: "inventory-finance-approving-authority" */'@/components/Inventory/Admin/InventoryFinanceApprovingAuthority');
const InventoryDeadstockStatus = () => import(/* webpackChunkName: "inventory-dead-stock-status" */'@/components/Inventory/Admin/InventoryDeadstockStatus');
const InventoryApprovalStatus = () => import(/* webpackChunkName: "inventory-approval-status" */'@/components/Inventory/Admin/InventoryApprovalStatus');
const InventoryServiceStatus = () => import(/* webpackChunkName: "inventory-service-status" */'@/components/Inventory/Admin/InventoryServiceStatus');
const InventoryMaterial = () => import(/* webpackChunkName: "inventory-material" */'@/components/Inventory/Admin/InventoryMaterial');
const MarkApprovingAuthority = () => import(/* webpackChunkName: "mark-approving-authority" */'@/components/Inventory/Admin/MarkApprovingAuthority');
const InventoryDepreciationCycle = () => import(/* webpackChunkName: "inventory-depreciation-cycle" */'@/components/Inventory/Admin/InventoryDepreciationCycle');
const InventoryFinanceApprovingAuthorityLevel = () => import(/* webpackChunkName: "inventory-finance-approving-authority-level" */'@/components/Inventory/Admin/InventoryFinanceApprovingAuthorityLevel');
const InventoryMaterialSpecification = () => import(/* webpackChunkName: "inventory-material-specification" */'@/components/Inventory/Admin/InventoryMaterialSpecification');
const InventoryVendor = () => import(/* webpackChunkName: "inventory-vendor" */'@/components/Inventory/Admin/InventoryVendor');
const InventoryMaterialPart = () => import(/* webpackChunkName: "inventory-material-part" */'@/components/Inventory/Admin/InventoryMaterialPart');




const AddInvoice = () => import(/* webpackChunkName: "add-invoice" */'@/components/Inventory/AccountOfficer/AddInvoice');
const AddInventory = () => import(/* webpackChunkName: "add-inventory" */'@/components/Inventory/StoreKeeper/AddInventory');
const MaterialDepreciationPercentage = () => import(/* webpackChunkName: "material-depreciation-percentage" */'@/components/Inventory/AccountOfficer/MaterialDepreciationPercentage');

//Dairy
const TeacherDairy = () => import(/* webpackChunkName: "teacher-diary" */'@/components/Dairy/Employee/TeacherDairy');
const SubjectTeacherDairy = () => import(/* webpackChunkName: "subject-teacher-diary" */'@/components/Dairy/Employee/SubjectTeacherDairy');
const ParentDiary = () => import(/* webpackChunkName: "parent-diary" */'@/components/Dairy/Parent/ParentDiary');
const ParentSubjectsDairy = () => import(/* webpackChunkName: "parent-subject-diary" */'@/components/Dairy/Parent/ParentSubjectsDairy');
const MessageType = () => import(/* webpackChunkName: "message-type" */'@/components/Dairy/MessageType');

const LearnerMarksheetICSE = () => import(/* webpackChunkName: "learner-marksheet-icse" */'@/components/WWSExamination/Admin/LearnerMarksheetICSE');
const MarkEntryStatus = () => import(/* webpackChunkName: "mark-entry-status-role-based" */'@/components/WWSExamination/Admin/MarkEntryStatus');
const LearnerMarksheetConfig = () => import(/* webpackChunkName: "learner-marksheet-config" */'@/components/WWSExamination/Admin/LearnerMarksheetConfig');
const LearnerMarksheetICSEParent = () => import(/* webpackChunkName: "learner-marksheet-icse-parent" */'@/components/WWSExamination/Admin/LearnerMarksheetICSEParent');
const LearnerMarksheetMarathi = () => import(/* webpackChunkName: "learner-marksheet-marathi" */'@/components/WWSExamination/Admin/LearnerMarksheetMarathi');
const LearnerMarksheetMarathiParent = () => import(/* webpackChunkName: "learner-marksheet-marathi-parent" */'@/components/WWSExamination/Admin/LearnerMarksheetMarathiParent');
const AssessmentDetailedReport = () => import(/* webpackChunkName: "assessment-detailed-report" */'@/components/WWSExamination/Report/AssessmentDetailedReport');
const AnnualMarkBook = () => import(/* webpackChunkName: "annual-mark-report" */'@/components/WWSExamination/Report/AnnualMarkBook');
const AnnualResultBulkPrint = () => import(/* webpackChunkName: "annual-result-bulk-print" */'@/components/WWSExamination/Admin/AnnualResultBulkPrint');
const RubricsDetailsICSE = () => import(/* webpackChunkName: "rubrics-details-icse" */'@/components/WWSExamination/Admin/RubricsDetailsICSE');
const PrePrimMarkScheduling = () => import(/* webpackChunkName: "pre-prim-marks-entry-scheduling" */'@/components/WWSExamination/Admin/PrePrimMarkScheduling');
const AnnualMarksCalculationICSE = () => import(/* webpackChunkName: "annual-marks-calculation-icse" */'@/components/WWSExamination/Admin/AnnualMarksCalculationICSE');

const SyncOldTransportCanteen = () => import(/* webpackChunkName: "sync-old-transport-canteen" */'@/components/TryNError/SyncOldTransportCanteen');

//GeneralFeedback
const Addfeedback = () => import(/* webpackChunkName: "add-feedback" */'@/components/GeneralFeedback/GiveFeedback/Addfeedback');
const AllFeedback = () => import(/* webpackChunkName: "all-feedback" */'@/components/GeneralFeedback/Admin/AllFeedback');
const FeedbackStats = () => import(/* webpackChunkName: "feedback-stats" */'@/components/GeneralFeedback/Admin/FeedbackStats');
const FeedbackStatus = () => import(/* webpackChunkName: "feedback-status" */'@/components/GeneralFeedback/Admin/FeedbackStatus');
const ResolveFeedback = () => import(/* webpackChunkName: "resolve-feedback" */'@/components/GeneralFeedback/Admin/ResolveFeedback');
const ReadAndNotResolved = () => import(/* webpackChunkName: "read-not-resolve-feedback" */'@/components/GeneralFeedback/Admin/ReadAndNotResolved');

//Worksheet
const AddWorksheet = () => import(/* webpackChunkName: "add-worksheet" */'@/components/Worksheet/AddWorksheet');
const AddNewWorksheet = () => import(/* webpackChunkName: "add-new-worksheet" */'@/components/Worksheet/AddNewWorksheet');
const WorksheetReport = () => import(/* webpackChunkName: "worksheet-report" */'@/components/Worksheet/WorksheetReport');


const POC = () => import(/* webpackChunkName: "add-new-worksheet" */'@/components/TryNError/POC.vue');

//AMC
const AddDocument = () => import(/* webpackChunkName: "add-new-document" */'@/components/AMC/AddDocument.vue');
const viewDocumentAccess = () => import(/* webpackChunkName: "view-document-access" */'@/components/AMC/viewDocumentAccess.vue');
const DocumentAccessLogsReport = () => import(/* webpackChunkName: "document-access-logs-report" */'@/components/AMC/DocumentAccessLogsReport.vue');

//Slot booking
const AddEventSlot = () => import(/* webpackChunkName: "add-event-slot" */'@/components/SlotBooking/Teacher/AddEventSlot.vue');
const ParentEventDashboard = () => import(/* webpackChunkName: "parent-event-dashboard" */'@/components/Appointment/Parent/ParentEventDashboard.vue');
const AdminEventDashboard = () => import(/* webpackChunkName: "admin-event-dashboard" */'@/components/Appointment/Admin/AdminEventDashboard.vue');
const AdminEventDashboardReport = () => import(/* webpackChunkName: "admin-event-dashboard-report" */'@/components/Appointment/Admin/AdminEventDashboardReport.vue');

//Appointment
const EventBookingStatus = () => import(/* webpackChunkName: "event-booking-status-master" */'@/components/Appointment/EventBookingStatus.vue');
const Event = () => import(/* webpackChunkName: "event-master" */'@/components/Appointment/Event.vue');
const Master = () => import(/* webpackChunkName: "appointment-master" */'@/components/Appointment/Master.vue');

// Book Review
const Publisher = () => import(/* webpackChunkName: "publisher-master" */'@/components/BookReview/Publisher.vue');
const BookReviewCriteriaType = () => import(/* webpackChunkName: "book-review-criteria-type-master" */'@/components/BookReview/BookReviewCriteriaType.vue');
const BookReviewCriteria = () => import(/* webpackChunkName: "book-review-criteria-master" */'@/components/BookReview/BookReviewCriteria.vue');
const TeacherBookReview = () => import(/* webpackChunkName: "teacher-book-review" */'@/components/BookReview/TeacherBookReview.vue');
const TextBookPurchaseReport = () => import(/* webpackChunkName: "get-text-book-purchase-report" */'@/components/BookReview/TextBookPurchaseReport.vue');
const BookReviewReport = () => import(/* webpackChunkName: "get-book-review-report" */'@/components/BookReview/BookReviewReport.vue');
const BookReviewMaster = () => import(/* webpackChunkName: "book-review-master" */'@/components/BookReview/Master.vue');

//Edu Store
const EdustoreAllMaster = () => import(/* webpackChunkName: "edustore-masters" */'@/components/EduStore/Masters/EdustoreAllMaster.vue');
const DeliveryOption = () => import(/* webpackChunkName: "delivery-option-master" */'@/components/EduStore/Masters/DeliveryOption.vue');
const VendorProfile = () => import(/* webpackChunkName: "vendor-master" */'@/components/EduStore/Masters/VendorProfile.vue');
const VendorShop = () => import(/* webpackChunkName: "vendor-shop-master" */'@/components/EduStore/Masters/VendorShop.vue');
const SizeLabelTypeMaster = () => import(/* webpackChunkName: "size-label-type-master" */'@/components/EduStore/Masters/SizeLabelTypeMaster.vue');
const SizeLabelMaster = () => import(/* webpackChunkName: "size-label-master" */'@/components/EduStore/Masters/SizeLabelMaster.vue');
const ItemCategory = () => import(/* webpackChunkName: "item-category-master" */'@/components/EduStore/Masters/ItemCategory.vue');
const OrderStatus = () => import(/* webpackChunkName: "order-status-master" */'@/components/EduStore/Masters/OrderStatus.vue');
const DeliveryStatus = () => import(/* webpackChunkName: "delivery-status-master" */'@/components/EduStore/Masters/DeliveryStatus.vue');
const InvoiceReport = () => import(/* webpackChunkName: "invoice-report" */'@/components/EduStore/Reports/InvoiceReport.vue');
const MyOrders = () => import(/* webpackChunkName: "my-orders" */'@/components/EduStore/Parent/MyOrders.vue');
const MyCart = () => import(/* webpackChunkName: "my-cart" */'@/components/EduStore/Parent/MyCart.vue');
const DetailedOrderReport = () => import(/* webpackChunkName: "detailed-order-report" */'@/components/EduStore/Reports/DetailedOrderReport.vue');
const EdustoreAddInvoice = () => import(/* webpackChunkName: "edustore-add-invoice" */'@/components/EduStore/Supplier/EdustoreAddInvoice.vue');
const AddItem = () => import(/* webpackChunkName: "additem" */'@/components/EduStore/Supplier/AddItem.vue');
const AddStock = () => import(/* webpackChunkName: "addstock" */'@/components/EduStore/Supplier/AddStock.vue');
const StockTransactionType = () => import(/* webpackChunkName: "stock-transaction-type-master" */'@/components/EduStore/Masters/StockTransactionType.vue');
const StaffStockLogs = () => import(/* webpackChunkName: "staff-stock-logs" */'@/components/EduStore/Reports/StaffStockLogs.vue');
const StockDashboard = () => import(/* webpackChunkName: "stock-dashboard" */'@/components/EduStore/Employee/StockDashboard.vue');
const StaffStockRequest = () => import(/* webpackChunkName: "staff-stock-request" */'@/components/EduStore/Employee/StaffStockRequest.vue');
const StudentStockLogs = () => import(/* webpackChunkName: "student-stock-logs" */'@/components/EduStore/Reports/StudentStockLogs.vue');
const MyStockRegister = () => import(/* webpackChunkName: "my-stock-register" */'@/components/EduStore/Reports/MyStockRegister.vue');
const MyStockDashboard = () => import(/* webpackChunkName: "my-stock-dashboard" */'@/components/EduStore/Employee/MyStockDashboard.vue');
const StockRegister = () => import(/* webpackChunkName: "stock-register" */'@/components/EduStore/Employee/StockRegister.vue');

//TimeSheet
const AddTimeSheet = () => import(/* webpackChunkName: "add-time-sheet" */'@/components/TimeSheet/AddTimeSheet.vue');
const TaskMaster = () => import(/* webpackChunkName: "task-master" */'@/components/TimeSheet/TaskMaster.vue');
const TimesheetReport = () => import(/* webpackChunkName: "timesheet-report" */'@/components/TimeSheet/TimesheetReport.vue');

//ClearanceStatus
const ClearanceStatusMaster = () => import (/* webpackChunkName: "clearance-status" */'@/components/ClearanceStatusMaster.vue');
const ClearanceDepartment = () => import (/* webpackChunkName: "clearance-department" */'@/components/ClearanceDepartment.vue');
const MarkAuthority = () => import (/* webpackChunkName: "mark-authority" */'@/components/MarkAuthority.vue');
const ClearanceRequest = () => import (/* webpackChunkName: "clearance-request" */'@/components/ClearanceRequest.vue');
const ReviewNoDues = () => import(/* webpackChunkName: "review-no-dues" */'@/components/ReviewNoDues.vue');

//Instructor Document Type
const InstructorDocumentType = () => import(/* webpackChunkName: "instructor-document-type" */'@/components/RoleManagement/Masters/InstructorDocumentType.vue');

//LoginLogo 
const LoginLogo = () => import(/* webpackChunkName: "login-logo" */'@/components/LoginLogo.vue');

//Discount Type 
const DiscountTypeMaster = () => import(/* webpackChunkName: "discount-type-master" */'@/components/AccountingAndFees/Master/DiscountTypeMaster.vue')
const StateMaster = () => import(/* webpackChunkName: "state-master" */'@/components/Admission/AdmissionMaster/StateMaster.vue')
const AdminStateMaster = () => import(/* webpackChunkName: "admin-state-master" */'@/components/Admin/SuperMaster/AdminStateMaster.vue')
const AdminDistrictMaster = () => import(/* webpackChunkName: "admin-district-master"*/'@/components/Admin/SuperMaster/AdminDistrictMaster.vue')
//Quiz Report
const QuizReport = () => import(/* webpackChunkName: "quiz-report" */'@/components/QuizReport.vue')
const QuizMarkAnalysisReport = () => import(/* webpackChunkName: "quiz-mark-analysis-report" */'@/components/QuizMarkAnalysisReport.vue')
//Bulk photo upload
const BulkPhotoUpload = () => import(/* webpackChunkName: "bulk-photo-upload" */'@/components/BulkPhotoUpload.vue')
const ServiceType = () => import(/* webpackChunkName: "employee-category" */'@/components/ServiceType.vue')
const OrdinanceRuleMaster = () => import(/* webpackChunkName: "ordinance-rule" */'@/components/OrdinanceRuleMaster.vue')
const OrdinanceRuleMapping = () => import(/* webpackChunkName: "ordinance-rule-mapping" */'@/components/OrdinanceRuleMapping.vue')
const BulkSeatNumberImport = () => import(/* webpackChunkName: "ordinance-rule-mapping" */'@/components/BulkSeatNumberImport.vue')
const ResultClassMaster = () => import(/* webpackChunkName: "result-class" */'@/components/Examination/ResultClassMaster.vue')
const WhatsappTemplate = () => import(/* webpackChunkName: "whatsapp-template" */'@/components/CommunicationType/WhatsappTemplate.vue')

//Digital Learning 
const DigitalLearning = () => import(/* webpackChunkName: "digital-learning" */'@/components/DigitalLearning/DigitalLearning.vue')
const SubjectCatalogue = () => import(/* webpackChunkName: "subject-catalogue" */'@/components/DigitalLearning/SubjectCatalogue.vue')
const Videos = () => import(/* webpackChunkName: "videos" */'@/components/DigitalLearning/Videos.vue')
//Edu Store Reports
const StudentWiseIndividualBill = () => import(/* webpackChunkName: "student-wise-bill-report" */'@/components/EduStore/Reports/StudentWiseIndividualBill.vue')
const AllStudentsBillReport = () => import(/* webpackChunkName: "all-students-bill-report" */'@/components/EduStore/Reports/AllStudentsBillReport.vue')
const AdminMyOrders = () => import(/* webpackChunkName: "admin-my-orders" */'@/components/EduStore/Employee/AdminMyOrders.vue');
const BonafideCertificateDES = () => import(/* webpackChunkName: "bonafide-certificate-des" */'@/components/Admission/Certificate/BonafideCertificateDES.vue')
const AdmissionRound = () => import(/* webpackChunkName: "admission-round" */'@/components/Admission/AdmissionMaster/AdmissionRound.vue')
const AllotmentList = () => import(/* webpackChunkName: "allotment-list" */'@/components/Admission/AdmissionMaster/AllotmentList.vue')
const PayElectiveFees = () => import(/* webpackChunkName: "pay-elective-fees" */'@/components/Admission/PayElectiveFees.vue')
const CourseHead = () => import(/* webpackChunkName: "course-head" */'@/components/Admission/AdmissionMaster/CourseHead.vue')
const SubjectGroup = () => import(/* webpackChunkName: "subject-group" */'@/components/Admission/AdmissionMaster/SubjectGroup.vue')
const SubjectGroupDetails = () => import(/* webpackChunkName: "subject-group-details" */'@/components/Admission/AdmissionMaster/SubjectGroupDetails.vue')
const SubjectGroupOffering = () => import(/* webpackChunkName: "offer-subject-group" */'@/components/Admission/AdmissionMaster/SubjectGroupOffering.vue')
const SelectionType = () => import(/* webpackChunkName: "selection-type" */'@/components/Admission/AdmissionMaster/SelectionType.vue')
const AddTemplate = () => import(/* webpackChunkName: "template" */'@/components/Admission/AddTemplate.vue')
const TemplateDetails = () => import(/* webpackChunkName: "template-details" */'@/components/Admission/TemplateDetails.vue')
const ElectiveAllocationReport = () => import(/* webpackChunkName: "elective-allocation-report" */'@/components/Admission/ElectiveAllocationReport.vue');
const PreferenceForm = () => import(/* webpackChunkName: "preference-form" */'@/components/Admission/PreferenceForm.vue');
const SocialWelfare = () => import(/* webpackChunkName: "social-welfare" */'@/components/Admission/AdmissionMaster/SocialWelfare.vue')
const MaritalStatus= () => import(/* webpackChunkName: "marital-status" */'@/components/Admission/AdmissionMaster/MaritalStatus.vue')
const SubjectGroupReport = () => import(/* webpackChunkName: "subject-report" */'@/components/Admission/Report/AdmissionFeesReport.vue')
const ApplicationFormReport = () => import(/* webpackChunkName: "application-form-report" */'@/components/Admission/Report/AdmissionFormReport.vue')
const StudentProfileDetails = () => import(/* webpackChunkName: "student-profile-details" */'@/components/Parent/Academics/StudentProfileDetails.vue')
const SubjectWiseStudentReport = () => import(/* webpackChunkName: "subject-wise-student-report" */'@/components/Admission/Report/SubjectWiseStudentReport.vue')
const ManageActivity = () => import(/* webpackChunkName: "manage-activity" */'@/components/ActivityManagement/Coordinator/ManageActivity.vue')
const AdmittedStudentProfileReport = () => import(/* webpackChunkName: "admitted-student-profile-report" */'@/components/Admission/Report/AdmittedStudentProfileReport.vue');
const ActivityCategory = () => import(/* webpackChunkName: "activity-category" */'@/components/ActivityManagement/ActivityCategory.vue');
const AffiliationType = () => import(/* webpackChunkName: "affiliation-type" */'@/components/ActivityManagement/AffiliationType.vue');
const ParticipantType = () => import(/* webpackChunkName: "participant-type" */'@/components/ActivityManagement/ParticipantType.vue');
const ActivityCertificateType = () => import(/* webpackChunkName: "activity-certificate-type" */'@/components/ActivityManagement/ActivityCertificateType.vue');
const ActivityFeesComponent = () => import(/* webpackChunkName: "activity-fees-component" */'@/components/ActivityManagement/ActivityFeesComponent.vue');
const ActivityReceipt = () => import(/* webpackChunkName: "activity-receipt" */'@/components/ActivityManagement/ActivityReceipt.vue');
const ActivityList = () => import(/* webpackChunkName: "activity-list" */'@/components/ActivityManagement/ActivityList.vue');
const ActivityMaster = () => import(/* webpackChunkName: "activity-master" */'@/components/ActivityManagement/ActivityMaster.vue');
const ActivitySummary = () => import(/* webpackChunkName: "activity-summary" */'@/components/ActivityManagement/Coordinator/ActivitySummary.vue');
const TrainingHourReport = () => import(/* webpackChunkName: "training-hour-report" */'@/components/ActivityManagement/Coordinator/TrainingHourReport.vue');
const CertificateTemplate = () => import(/* webpackChunkName: "certificate-template" */'@/components/ActivityManagement/CertificateTemplate.vue');
const ActivityCertificateRule = () => import(/* webpackChunkName: "activity-certificate-rule" */'@/components/ActivityManagement/ActivityCertificateRule.vue');
const ResourcePerson = () => import(/* webpackChunkName: "resource-person" */'@/components/ActivityManagement/ResourcePerson.vue');
const ConductType = () => import(/* webpackChunkName: "exam-conduct-type" */'@/components/Examination/SeatingArrangement/Masters/ConductType.vue');
const ExamBenchSide = () => import(/* webpackChunkName: "exam-bench-side" */'@/components/Examination/SeatingArrangement/Masters/ExamBenchSide.vue');
const DoorDisplayReport = () => import(/* webpackChunkName: "door-display-report" */'@/components/Examination/SeatingArrangement/Reports/DoorDisplayReport.vue')
const SupervisorReport = () => import(/* webpackChunkName: "supervisor-report" */'@/components/Examination/SeatingArrangement/Reports/SupervisorReport.vue')
const StudentAttendanceReport = () => import(/* webpackChunkName: "student-attendance-report" */'@/components/Examination/SeatingArrangement/Reports/StudentAttendanceReport.vue')
const RoomUtilizationReport = () => import(/* webpackChunkName: "room-utilization-report" */'@/components/Examination/SeatingArrangement/Reports/RoomUtilizationReport.vue')
const StudentSeatingReport = () => import(/* webpackChunkName: "student-seating-report" */'@/components/Examination/SeatingArrangement/Reports/StudentSeatingReport.vue')
const ExamPlanDetails = () => import(/* webpackChunkName: "exam-plan-details" */'@/components/Examination/SeatingArrangement/ExamPlan/ExamPlanDetails.vue')
const RoomAllotmentReport = () => import(/* webpackChunkName: "room-allotment-report" */'@/components/Examination/SeatingArrangement/ExamPlan/RoomAllotmentReport.vue')
const AllStudentAttendanceReport = () => import(/* webpackChunkName: "all-student-attendance-report" */'@/components/Examination/SeatingArrangement/ExamPlan/AllStudentAttendanceReport.vue')
const SeatingArrangementReport = () => import(/* webpackChunkName: "seating-arrangement-report" */'@/components/Examination/SeatingArrangement/Reports/SeatingArrangementReport.vue')



const LinkSubjects = () => import(/* webpackChunkName: "link-subjects" */'@/components/Examination/SeatingArrangement/ExamPlan/LinkSubjects.vue')
const LinkRoom = () => import(/* webpackChunkName: "link-room" */'@/components/Examination/SeatingArrangement/ExamPlan/LinkRoom.vue')
const StudentExamAttendance = () => import(/* webpackChunkName: "mark-student-exam-attendance" */'@/components/Examination/SeatingArrangement/ExamPlan/StudentExamAttendance.vue')
// const LinkSupervisor = () => import(/* webpackChunkName: "link-supervisor" */'@/components/Examination/SeatingArrangement/ExamPlan/LinkSupervisor.vue')
// const MarkStudentAttendance = () => import(/* webpackChunkName: "mark-student-attendance" */'@/components/Examination/SeatingArrangement/ExamPlan/MarkStudentAttendance.vue')



const routes = [
    { path: '/access-denied', component: AccessDenied },
    { path: '/poc', component: POC },
    //Experiments
    // {path:'/fileupload',component:FileUpload},
    // {path:'/sample',component:Sample},
    // {path:'/sample-calendar',component:SampleCalendar},
    // {path:'/tt',component:TT},
    // {path:'/training',component:Training},
    // {path:'/testing',component:Testing},
    // {path:'/certificate',component:certificate},
    // {path:'/hash',component:Hash},
    // {path:'/auth',component:Auth},
    // {path:'/check-tenent-on',component:Check},
    // {path:'/ref-code',component:RefCode},
    // {path:'/re-usable',component:ReUsable},

    //ends

    //Admin
    {
        path: '/eps-admin', component: SignIn
    },

    //FAQ
    // {
    //     path: '/question-answer',        
    //     component: FAQ
    // },
    //FAQ
    {
        path: '/question-answer',
        name: 'question-answer',
        component: FAQ
    },

    {
        path: '/web-view-receipt',
        name: 'web-view-receipt',
        component: WebViewReceipt
    },
    {
        path: '/web-view-get-child-receipt-details',
        name: 'web-view-get-child-receipt-details',
        component: ChildReceiptDetails
    },
    {
        path: '/eps-admin-dashboard',
        name: '/eps-admin-dashboard',
        component: AdminDashboard,
        children: [
            {
                path: 'access-control-admin',
                name: 'access-control-admin',
                component: AccessControl
            },//
            {
                path: 'create-org-admin',
                name: 'create-org-admin',
                component: CreateAdmin
            },//
            {
                path: 'create-bulk-roles',
                name: 'create-bulk-roles',
                component: CreateBulkRoles
            },
            {
                path: 'tenant-module-management',
                name: 'tenant-module-management',
                component: TenantModuleManagement
            },

            {
                path: 'push-master-to-tenant',
                name: 'push-master-to-tenant',
                component: PushMastersToTenant
            },

            {
                path: 'admin-add-organization',
                name: 'admin-add-organization',
                component: AdminAddOrganization
            },

            {
                path: 'admin-super-master',
                name: 'admin-super-master',
                component: AdminSuperMaster
            },
            {
                path: 'admin-add-tenant',
                name: 'admin-add-tenant',
                component: AdminAddTenant
            },
            {
                path: 'admin-gender-master/admin-super-master',
                name: 'admin-gender-master',
                component: AdminGenderMaster
            },
            {
                path: 'admin-application-status/admin-super-master',
                name: 'admin-application-status',
                component: AdminApplicationStatus
            },
            {
                path: 'admin-user-type/admin-super-master',
                name: 'admin-user-type',
                component: AdminUserTypeMaster
            },
            {
                path: 'admin-language-master/admin-super-master',
                name: 'admin-language-master',
                component: AdminLanguageMaster
            },
            {
                path: 'admin-academic-year-master/admin-super-master',
                name: 'admin-academic-year-master',
                component: AdminAcademicYearMaster
            },
            {
                path: 'admin-address-type-master/admin-super-master',
                name: 'admin-address-type-master',
                component: AdminAddressTypeMaster
            },
            // {
            //     path: 'admin-division-master/admin-super-master',
            //     name: 'admin-division-master',
            //     component: AdminDivisionMaster
            // }, 
            {
                path: 'admin-admission-status-master/admin-super-master',
                name: 'admin-admission-status-master',
                component: AdminAdmissionStatusMaster
            },
            {
                path: 'admin-bank-master/admin-super-master',
                name: 'admin-bank-master',
                component: AdminBankMaster
            },
            {
                path: 'admin-blood-group-master/admin-super-master',
                name: 'admin-blood-group-master',
                component: AdminBloodGroupMaster
            },
            {
                path: 'admin-calender-year-master/admin-super-master',
                name: 'admin-calender-year-master',
                component: AdminCalenderYearMaster
            },
            {
                path: 'admin-cast-master/admin-super-master',
                name: 'admin-cast-master',
                component: AdminCastMaster
            },
            {
                path: 'admin-category-master/admin-super-master',
                name: 'admin-category-master',
                component: AdminCategoryMaster
            },
            {
                path: 'admin-state-master/admin-super-master',
                name: 'admin-state-master',
                component: AdminStateMaster
            },
            {
                path: 'admin-district-master/admin-super-master',
                name: 'admin-district-master',
                component: AdminDistrictMaster
            },
            {
                path: 'admin-communication-type-master/admin-super-master',
                name: 'admin-communication-type-master',
                component: AdminCommunicationTypeMaster
            },
            {
                path: 'admin-country-master/admin-super-master',
                name: 'admin-country-master',
                component: AdminCountryMaster
            },
            {
                path: 'admin-course-rule-master/admin-super-master',
                name: 'admin-course-rule-master',
                component: AdminCourseRuleMaster
            },
            {
                path: 'admin-document-type-master/admin-super-master',
                name: 'admin-document-type-master',
                component: AdminDocumentTypeMaster
            },
            {
                path: 'admin-domacile-master/admin-super-master',
                name: 'admin-domacile-master',
                component: AdminDomacileMaster
            },
            {
                path: 'admin-fees-component-master/admin-super-master',
                name: 'admin-fees-component-master',
                component: AdminFeesComponentMaster
            },
            //deposite type
            {
                path: 'admin-fees-deposite-type-master/admin-super-master',
                name: 'admin-fees-deposite-type-master',
                component: AdminFeesDepositeTypeMaster
            },
            {
                path: 'admin-fees-installment-master/admin-super-master',
                name: 'admin-fees-installment-master',
                component: AdminFeesInstallmentMaster
            },

            {
                path: 'admin-field-type-master/admin-super-master',
                name: 'admin-field-type-master',
                component: AdminFieldTypeMaster
            },
            {
                path: 'admin-field-master/admin-super-master',
                name: 'admin-field-master',
                component: AdminFieldMaster
            },
            {
                path: 'admin-link-master/admin-super-master',
                name: 'admin-link-master',
                component: AdminLinkMaster
            },
            {
                path: 'admin-logo-purpose-master/admin-super-master',
                name: 'admin-logo-purpose-master',
                component: AdminLogoPurposeMaster
            },
            {
                path: 'admin-module-master/admin-super-master',
                name: 'admin-module-master',
                component: AdminModuleMaster
            },
            {
                path: 'admin-role_type-master/admin-super-master',
                name: 'admin-role_type-master',
                component: AdminRoleTypeMaster
            },
            {
                path: 'admin-occupation-master/admin-super-master',
                name: 'admin-occupation-master',
                component: AdminOccupationMaster
            },
            {
                path: 'admin-payment-mode-master/admin-super-master',
                name: 'admin-payment-mode-master',
                component: AdminPaymentModeMaster
            },
            {
                path: 'admin-pin-master/admin-super-master',
                name: 'admin-pin-master',
                component: AdminPinMaster
            },
            {
                path: 'admin-relation-type-master/admin-super-master',
                name: 'admin-relation-type-master',
                component: AdminRelationTypeMaster
            },
            {
                path: 'admin-religion-master/admin-super-master',
                name: 'admin-religion-master',
                component: AdminReligionMaster
            },
            {
                path: 'admin-school-board-master/admin-super-master',
                name: 'admin-school-board-master',
                component: AdminSchoolBoardMaster
            },
            {
                path: 'admin-serial-field-type-master/admin-super-master',
                name: 'admin-serial-field-type-master',
                component: AdminSerialFieldTypeMaster
            },
            {
                path: 'admin-standard-master/admin-super-master',
                name: 'admin-standard-master',
                component: AdminStandardMaster
            },
            {
                path: 'admin-template-page-size-master/admin-super-master',
                name: 'admin-template-page-size-master',
                component: AdminTemplatePageSizeMaster
            },
            {
                path: 'admin-transport-status/admin-super-master',
                name: 'admin-transport-status',
                component: AdminTransportStatusSuperMaster
            },
            {
                path: 'admin-communication-mode-master/admin-super-master',
                name: 'admin-communication-mode-master',
                component: AdminCommunicationModeMaster
            },
            {
                path: 'admin-assessment-type-master/admin-super-master',
                name: 'admin-assessment-type-master',
                component: AdminAssessmentType
            },
            {
                path: 'admin-evaluation-type-master/admin-super-master',
                name: 'admin-evaluation-type-master',
                component: AdminEvaluationType
            },
            {
                path: 'admin-subject-marks-entry-type-master/admin-super-master',
                name: 'admin-subject-marks-entry-type-master',
                component: AdminSubjectMarksEntryType
            },
            {
                path: 'admin-event-type-master/admin-super-master',
                name: 'admin-event-type-master',
                component: AdminEventType
            },
            {
                path: 'admin-day-master/admin-super-master',
                name: 'admin-day-master',
                component: AdminDayMaster
            },
            {
                path: 'admin-stream-master/admin-super-master',
                name: 'admin-stream-master',
                component: AdminStreamMaster
            },
            {
                path: 'admin-quota-master/admin-super-master',
                name: 'admin-quota-master',
                component: AdminQuotaMaster
            },
            {
                path: 'admin-room-type-master/admin-super-master',
                name: 'admin-room-type-master',
                component: AdminRoomTypeMaster
            },
            {
                path: 'admin-component-category/admin-super-master',
                name: 'admin-component-category',
                component: AdminComponentCategoryMaster
            },
            {
                path: 'admin-activity-type/admin-super-master',
                name: 'admin-activity-type',
                component: ActivityTypeSuperMaster
            },
            {
                path: 'admin-award-type/admin-super-master',
                name: 'admin-award-type',
                component: AwardTypeSuperMaster
            },
            {
                path: 'admin-degree/admin-super-master',
                name: 'admin-degree',
                component: DegreeSuperMaster
            },
            {
                path: 'admin-erp-class/admin-super-master',
                name: 'admin-erp-class',
                component: ERPClassSuperMaster
            },
            {
                path: 'admin-experience-type/admin-super-master',
                name: 'admin-experience-type',
                component: ExperienceTypeSuperMaster
            },
            {
                path: 'admin-publication-category/admin-super-master',
                name: 'admin-publication-category',
                component: PublicationCategorySuperMastre
            },
            {
                path: 'admin-publication-index-type/admin-super-master',
                name: 'admin-publication-index-type',
                component: PublicationIndexTypeSuperMaster
            },
            {
                path: 'admin-publication-type/admin-super-master',
                name: 'admin-publication-type',
                component: PublicationTypeSuperMaster
            },
            {
                path: 'admin-research-status/admin-super-master',
                name: 'admin-research-status',
                component: ResearchStatusSuperMaster
            },
            {
                path: 'admin-research-type/admin-super-master',
                name: 'admin-research-type',
                component: ResearchTypeSuperMaster
            },
            {
                path: 'admin-quiz-super-master/admin-super-master',
                name: 'admin-quiz-super-master',
                component: QuizTypeSuperMaster
            },
            {
                path: 'admin-self-apprisal-authority-type-super-master/admin-super-master',
                name: 'admin-self-apprisal-authority-type-super-master',
                component: SelfApprisalAuthorityTypeSuperMaster
            },
            {
                path: 'admin-feedback-type-super-master/admin-super-master',
                name: 'admin-feedback-type-super-master',
                component: FeedbackTypeSuperMaster
            },
            {
                path: 'admin-feedback-question-type-super-master/admin-super-master',
                name: 'admin-feedback-question-type-super-master',
                component: FeedbackQuestionTypeSuperMaster
            },
            {
                path: 'admin-subject-type-super-master/admin-super-master',
                name: 'admin-subject-type-super-master',
                component: SubjectTypeSuperMaster
            },
            {
                path: 'admin-assessment-details-formula-super-master/admin-super-master',
                name: 'admin-assessment-details-formula-super-master',
                component: AssessmentDetailsFormulaSuperMaster
            },
            {
                path: 'admin-configuration-super-master/admin-super-master',
                name: 'admin-configuration-super-master',
                component: ConfigurationSuperMaster
            },
            {
                path: 'admin-salary-rule-super-master/admin-super-master',
                name: 'admin-salary-rule-super-master',
                component: SalaryRuleSuperMaster
            },
            {
                path: 'admin-file-journey-type-super-master/admin-super-master',
                name: 'admin-file-journey-type-super-master',
                component: FileJourneyTypeSuperMaster
            },
            {
                path: 'admin-maintenance-status-super-master/admin-super-master',
                name: 'admin-maintenance-status-super-master',
                component: MaintenanceStatusSuperMaster
            },
            {
                path: 'admin-visit-type-super-master/admin-super-master',
                name: 'admin-visit-type-super-master',
                component: VisitTypeSuperMaster
            },
            {
                path: 'admin-mobile-app-links-master/admin-super-master',
                name: 'admin-mobile-app-links-master',
                component: MobileAppLinksSuperMaster
            },
            //Add Super Master
            {
                path: 'admin-event-type-super-master/admin-super-master',
                name: 'admin-event-type-super-master',
                component: EventTypeSuperMaster
            },
            {
                path: 'admin-course-type-super-master/admin-super-master',
                name: 'admin-course-type-super-master',
                component: CourseTypeSuperMaster
            },
            {
                path: 'admin-primary-report-card-course-type-super-master/admin-super-master',
                name: 'admin-primary-report-card-course-type-super-master',
                component: PrimaryReportCardCourseTypeSuperMaster
            },
            {
                path: 'admin-rubrics-type-super-master/admin-super-master',
                name: 'admin-rubrics-type-super-master',
                component: RubricsSuperMaster
            },
            {
                path: 'admin-rubrics-header-type-super-master/admin-super-master',
                name: 'admin-rubrics-header-type-super-master',
                component: RubricsHeaderSuperMaster
            },
            {
                path: 'admin-event-booking-status-super-master/admin-super-master',
                name: 'admin-event-booking-status-super-master',
                component: EventBookingStatusSuperMaster
            },
            {
                path: 'admin-certificate-type-super-master/admin-super-master',
                name: 'admin-certificate-type-super-master',
                component: CertificateTypeSuperMaster
            },
            {
                path: 'admin-payment-gateway-super-master/admin-super-master',
                name: 'admin-payment-gateway-super-master',
                component: PaymentGatewaySuperMaster
            },
            {
                path: 'admin-payment-type-super-master/admin-super-master',
                name: 'admin-payment-type-super-master',
                component: PaymentTypeSuperMaster
            },
            {
                path: 'admin-payment-transaction-status-super-master/admin-super-master',
                name: 'admin-payment-transaction-status-super-master',
                component: PaymentTransactionStatusSuperMaster
            },

            {
                path: 'admin-family-type-super-master/admin-super-master',
                name: 'admin-family-type-super-master',
                component: FamilyTypeSuperMaster
            },
            {
                path: 'admin-ration-card-super-master/admin-super-master',
                name: 'admin-ration-card-super-master',
                component: RationCardSuperMaster
            },
            {
                path: 'admin-marital-status-super-master/admin-super-master',
                name: 'admin-marital-status-super-master',
                component: MaritalStatusSuperMaster
            },
            {
                path: 'admin-employee-type-super-master/admin-super-master',
                name: 'admin-employee-type-super-master',
                component: EmployeeTypeSuperMaster
            },
            {
                path: 'admin-designation-super-master/admin-super-master',
                name: 'admin-designation-super-master',
                component: DesignationSuperMaster
            },
            {
                path: 'admin-employee-shift-super-master/admin-super-master',
                name: 'admin-employee-shift-super-master',
                component: EmployeeShiftSuperMaster
            },
            {
                path: 'admin-semester-super-master/admin-super-master',
                name: 'admin-semester-super-master',
                component: SemesterSuperMaster
            },
            {
                path: 'admin-division-super-master/admin-super-master',
                name: 'admin-division-super-master',
                component: DivisionSuperMaster
            },
            {
                path: 'admin-section-super-master/admin-super-master',
                name: 'admin-section-super-master',
                component: SectionSuperMaster
            },
            {
                path: 'admin-sub-cast-super-master/admin-super-master',
                name: 'admin-sub-cast-super-master',
                component: SubCastSuperMaster
            },
            //
            {
                path: 'admin-house-super-master/admin-super-master',
                name: 'admin-house-super-master',
                component: HouseSuperMaster
            },
            {
                path: 'admin-document-category-super-master/admin-super-master',
                name: 'admin-document-category-super-master',
                component: DocumentCategorySuperMaster
            },
            {
                path: 'admin-document-level-super-master/admin-super-master',
                name: 'admin-document-level-super-master',
                component: DocumentLevelSuperMaster
            },
            {
                path: 'admin-vaccination-super-master/admin-super-master',
                name: 'admin-vaccination-super-master',
                component: VaccinationMasterSuperMaster
            },
            {
                path: 'admin-admission-instructions-super-master/admin-super-master',
                name: 'admin-admission-instructions-super-master',
                component: AdmissionInstructionsSuperMaster
            },
            {
                path: 'admin-role-super-master/admin-super-master',
                name: 'admin-role-super-master',
                component: RoleSuperMaster
            },
            {
                path: 'admin-leave-academic-year-master/admin-super-master',
                name: 'admin-leave-academic-year-master',
                component: LeaveAcademicYearSuperMaster
            },
            {
                path: 'admin-leave-type-super-master/admin-super-master',
                name: 'admin-leave-type-super-master',
                component: LeaveTypeSuperMaster
            },
            {
                path: 'admin-leave-approval-status-super-master/admin-super-master',
                name: 'admin-leave-approval-status-super-master',
                component: LeaveApprovalStatusSuperMaster
            },
            {
                path: 'admin-leave-approval-authority-super-master/admin-super-master',
                name: 'admin-leave-approval-authority-super-master',
                component: LeaveApprovalAuthoritySuperMaster
            },
            {
                path: 'admin-holiday-super-master/admin-super-master',
                name: 'admin-holiday-super-master',
                component: HolidaySuperMaster
            },
            {
                path: 'admin-in-out-buffer-time-super-master/admin-super-master',
                name: 'admin-in-out-buffer-time-super-master',
                component: InOutBufferTimeSuperMaster
            },
            {
                path: 'admin-calendar-month-super-master/admin-super-master',
                name: 'admin-calendar-month-super-master',
                component: CalendarMonthSuperMaster
            },
            {
                path: 'admin-inward-outward-department-type-super-master/admin-super-master',
                name: 'admin-inward-outward-department-type-super-master',
                component: IODepartmentTypeSuperMaster
            },
            {
                path: 'admin-query-category-super-master/admin-super-master',
                name: 'admin-query-category-super-master',
                component: QueryCategorySuperMaster
            },
            {
                path: 'admin-query-type-super-master/admin-super-master',
                name: 'admin-query-type-super-master',
                component: QueryTypeSuperMaster
            },
            {
                path: 'admin-diary-message-type-super-master/admin-super-master',
                name: 'admin-diary-message-type-super-master',
                component: DiaryMessageTypeSuperMaster
            },
            {
                path: 'admin-maintenance-section-super-master/admin-super-master',
                name: 'admin-maintenance-section-super-master',
                component: MaintenanceSectionSuperMaster
            },
            {
                path: 'admin-quiz-difficulty-level-super-master/admin-super-master',
                name: 'admin-quiz-difficulty-level-super-master',
                component: QuizDifficultyLevelSuperMaster
            },
            {
                path: 'admin-slot-type-super-master/admin-super-master',
                name: 'admin-slot-type-super-master',
                component: SlotTypeSuperMaster
            },
            {
                path: 'admin-timetable-event-super-master/admin-super-master',
                name: 'admin-timetable-event-super-master',
                component: TimetableEventSuperMaster
            },
            {
                path: 'admin-route-stop-super-master/admin-super-master',
                name: 'admin-route-stop-super-master',
                component: RouteStopSuperMaster
            },
            {
                path: 'admin-transport-approval-authority-super-master/admin-super-master',
                name: 'admin-transport-approval-authority-super-master',
                component: TransportApprovalAuthoritySuperMaster
            },
            {
                path: 'admin-canteen-approval-authority-super-master/admin-super-master',
                name: 'admin-canteen-approval-authority-super-master',
                component: CanteenApprovalAuthoritySuperMaster
            },
            {
                path: 'admin-canteen-menu-category-super-master/admin-super-master',
                name: 'admin-canteen-menu-category-super-master',
                component: CanteenMenuCategorySuperMaster
            },
            {
                path: 'admin-canteen-menu-type-super-master/admin-super-master',
                name: 'admin-canteen-menu-type-super-master',
                component: CanteenMenuTypeSuperMaster
            },
            {
                path: 'admin-canteen-approval-status-super-master/admin-super-master',
                name: 'admin-canteen-approval-status-super-master',
                component: CanteenApprovalStatusSuperMaster
            },
            {
                path: 'admin-canteen-installment-type-super-master/admin-super-master',
                name: 'admin-canteen-installment-type-super-master',
                component: CanteenInstallmentTypeSuperMaster
            },
            {
                path: 'admin-pay-commission-super-master/admin-super-master',
                name: 'admin-pay-commission-super-master',
                component: PayCommissionSuperMaster
            },
            {
                path: 'admin-salary-certificate-reason-super-master/admin-super-master',
                name: 'admin-salary-certificate-reason-super-master',
                component: SalaryCertificateReasonSuperMaster
            },
            {
                path: 'admin-salary-certificate-status-super-master/admin-super-master',
                name: 'admin-salary-certificate-status-super-master',
                component: SalaryCertificateStatusSuperMaster
            },
            {
                path: 'admin-salary-component-type-super-master/admin-super-master',
                name: 'admin-salary-component-type-super-master',
                component: SalaryComponentTypeSuperMaster
            },
            {
                path: 'admin-journey-type-super-master/admin-super-master',
                name: 'admin-journey-type-super-master',
                component: JourneyTypeSuperMatser
            },
            {
                path: 'admin-route-super-master/admin-super-master',
                name: 'admin-route-super-master',
                component: RouteSuperMaster
            },
            {
                path: 'admin-misc-fee-category-super-master/admin-super-master',
                name: 'admin-misc-fee-category-super-master',
                component: MiscFeeCategorySuperMaster
            },
            {
                path: 'admin-book-review-criteria-type-super-master/admin-super-master',
                name: 'admin-book-review-criteria-type-super-master',
                component: BookReviewCriteriaTypeSuperMaster
            },
            {
                path: 'admin-minority-super-master/admin-super-master',
                name: 'admin-minority-super-master',
                component: MinoritySuperMaster
            },
            {
                path: 'admin-skill-super-master/admin-super-master',
                name: 'admin-skill-super-master',
                component: SkillSuperMaster
            },
            {
                path: 'admin-interest-super-master/admin-super-master',
                name: 'admin-interest-super-master',
                component: InterestSuperMaster
            },
            {
                path: 'admin-career-super-master/admin-super-master',
                name: 'admin-career-super-master',
                component: CareerSuperMaster
            },
            {
                path: 'admin-physical-disability-type-super-master/admin-super-master',
                name: 'admin-physical-disability-type-super-master',
                component: PhysicalDisabilityTypeSuperMaster
            },
            {
                path: 'admin-Inv-approval-status-super-master/admin-super-master',
                name: 'admin-Inv-approval-status-super-master',
                component: InvApprovalStatusSuperMaster
            },
            {
                path: 'admin-Inv-deadstock-status-super-master/admin-super-master',
                name: 'admin-Inv-deadstock-status-super-master',
                component: InvDeadstockStatusSuperMaster
            },
            {
                path: 'admin-Inv-finance-approving-authority-super-master/admin-super-master',
                name: 'admin-Inv-finance-approving-authority-super-master',
                component: InvFinanceApprovingAuthoritySuperMaster
            },
            {
                path: 'admin-Inv-material-type-super-master/admin-super-master',
                name: 'admin-Inv-material-type-super-master',
                component: InvMaterialTypeSuperMaster
            },
            {
                path: 'admin-grading-scheme-super-master/admin-super-master',
                name: 'admin-grading-scheme-super-master',
                component: GradingSchemeSuperMaster
            },
            {
                path: 'admin-assessment-scheme-super-master/admin-super-master',
                name: 'admin-assessment-scheme-super-master',
                component: AssessmentSchemeSuperMaster
            },
            {
                path: 'admin-default-value-type-super-master/admin-super-master',
                name: 'admin-default-value-type-super-master',
                component: DefaultValueTypeSuperMaster
            },


        ]

    },

    //////////////////////////////////////admin ends
    //home
    {
        path: '/', component: epsLogin
    },
    {
        path: '/forgot-password', component: ForgotPassword
    },
    {
        path: '/support', component: Support
    },
    {
        path: '/sbpps-forgot-password', component: SbppsForgetPassword
    },
    {
        path: '/parent-signup', component: ParentSignup
    },
    {
        path: '/quick-pay', component: QuickPay
    },
    {
        path: '/trial-bypass', component: TrialBypass
    },
    {
        path: '/pay-admission-fee',
        component: PayAdmissionFee
    },
    {
        path: '/change-password', component: ChangePassword
    },
    {
        path: '/user-profile', component: userProfile,
        beforeEnter: ((to, from, next) => {
            if (!localStorage.getItem('EPS-token')) next('/')
            else next()
        })
    },
    {
        path: '/update-password', name: 'update-password', component: updatePassword,
        beforeEnter: ((to, from, next) => {
            if (!localStorage.getItem('EPS-token')) next('/')
            else next()
        })
    },
    {
        path: '/home', component: epsHome,
        children: [
            {
                path: "/role-dashboard",
                name: "/role-dashboard",
                component: RoleDashboard,
                props: true,
                children: [
                    {
                        path: '/settings',
                        name: 'settings',
                        component: Setting
                    },
                    {
                        path: '/master-data',
                        name: 'master-data',
                        component: MasterData
                    },
                    {
                        path: '/inst-analytical-dashboard',
                        name: 'inst-analytical-dashboard',
                        component: InstAnalyticalStats
                    },
                    {
                        path: 'transport-learner-attendance-report',
                        name: 'transport-learner-attendance-report',
                        component: TransportLearnerAttendanceReport
                    },
                    {
                        path: 'student-late-in-early-out',
                        name: 'student-late-in-early-out',
                        component: StudentLateInEarlyOut
                    },
                    {
                        path: 'map-route-to-student',
                        name: 'map-route-to-student',
                        component: AddLearnerRoutes
                    },
                    {
                        path: 'routewise-transport-attendance-report',
                        name: 'routewise-transport-attendance-report',
                        component: RoutewiseTransportAttendanceReport
                    },
                    {
                        path: '/analytical-dashboard',
                        name: 'analytical-dashboard',
                        component: AnalyticalStats
                    },
                    {
                        path: '/emp-role-dashboard',
                        name: 'emp-role-dashboard',
                        component: EmpRole
                    },
                    {
                        path: 'get-instructor-module-roles',
                        name: 'get-instructor-module-roles',
                        component: GetInstructorModuleRoles
                    },
                    {
                        path: 'import-edit-student-registration',
                        name: 'import-edit-student-registration',
                        component: ImportEditStudentRegistration
                    },
                    {
                        path: 'import-edit-parent-info',
                        name: 'import-edit-parent-info',
                        component: ImportEditParentInfo
                    },
                    {
                        path: 'role-dashboard-stats',
                        name: 'role-dashboard-stats',
                        component: RoleDashboardStats
                    },
                    //Module
                    {
                        path: 'modules',
                        name: 'modules',
                        component: Modules
                    },
                    {
                        path: '/editor',
                        name: 'editor',
                        component: Editer
                    },
                    //time table
                    {
                        path: 'time-table-room-offering',
                        name: 'time-table-room-offering',
                        component: TimeTableRoomOffering
                    },
                    {
                        path: 'time-table-slot',
                        name: 'time-table-slot',
                        component: Slot
                    },
                    {
                        path: 'change-login-id',
                        name: 'change-login-id',
                        component: ChangeLoginId
                    },
                    {
                        path: 'time-table-copy-slot',
                        name: 'time-table-copy-slot',
                        component: CopySlot
                    }, //
                    {
                        path: 'manage-time-table',
                        name: 'manage-time-table',
                        component: ManageTimeTable
                    },
                    {
                        path: 'load-report',
                        name: 'load-report',
                        component: LoadReport
                    },
                    {
                        path: 'teacher-abbreviaiton',
                        name: 'teacher-abbreviaiton',
                        component: TeacherAbbreviation
                    },
                    {
                        path: 'time-table-master',
                        name: 'time-table-master',
                        component: TimeTableMaster
                    },
                    {
                        path: 'day/time-table-master',
                        name: 'day',
                        component: TimeTableDay
                    },
                    {
                        path: 'room/time-table-master',
                        name: 'room',
                        component: TimeTableRoom
                    },
                    {
                        path: 'room-type/time-table-master',
                        name: 'room-type',
                        component: TimeTableRoomType
                    },
                    {
                        path: 'slot/time-table-master',
                        name: 'slot',
                        component: TimeTableSlot
                    },
                    {
                        path: 'slot-type/time-table-master',
                        name: 'slot-type',
                        component: TimeTableSlotType
                    },
                    {
                        path: 'time-table-constraint',
                        name: 'time-table-constraint',
                        component: TimeTableConstraint
                    },
                    {
                        path: 'time-table-constraint-parameter',
                        name: 'time-table-constraint-parameter',
                        component: TimeTableConstraintParameter
                    },
                    {
                        path: 'time-table-constraint-assignment',
                        name: 'time-table-constraint-assignment',
                        component: TimeTableConstraintAssignment
                    },
                    {
                        path: 'time-table-version-offering',
                        name: 'time-table-version-offering',
                        component: TimetableVersionOffering
                    },
                    {
                        path: 'time-table-version-master',
                        name: 'time-table-version-master',
                        component: TimeTableVersionMaster
                    },
                    {
                        path: 'copy-time-table',
                        name: 'copy-time-table',
                        component: CopyTimeTable
                    },
                    {
                        path: 'event-type/time-table-master',
                        name: 'event-type',
                        component: TimeTableEventType
                    },
                    {
                        path: 'get-weak-timetable-report',
                        name: 'get-weak-timetable-report',
                        component: GetWeakTimeTableReport
                    },
                    {
                        path: 'get-classteacher-timetable',
                        name: 'get-classteacher-timetable',
                        component: GetClassTeacherTT
                    },
                    {
                        path: 'time-table-event/time-table-master',
                        name: 'time-table-event',
                        component: TimeTableEvent
                    },
                    {
                        path: 'get-faculty-time-table',
                        name: 'get-faculty-time-table',
                        component: GetFacultyTimeTable
                    },

                    {
                        path: 'room-time-table',
                        name: 'room-time-table',
                        component: RoomTimeTable
                    },
                    {
                        path: 'my-time-table',//faculty-itself
                        name: 'my-time-table',
                        component: MyTimeTable
                    },
                    {
                        path: 'get-div-time-table',
                        name: 'get-div-time-table',
                        component: GetDivTimeTable
                    },
                    {
                        path: 'child-time-table',
                        name: 'child-time-table',
                        component: ChildTimeTable
                    },
                    {
                        path: 'library',
                        name: 'library',
                        component: Library
                    },
                    //account
                    {
                        path: 'add-fee-category/account-master',
                        name: 'add-fee-category',
                        component: AddFeeCategory
                    },
                    // {
                    //     path: 'get-receipt/account-master',
                    //     name: 'get-receipt',
                    //     component: GetReceipt
                    // },
                    {
                        path: 'fees-type/account-master',
                        name: 'fees-type',
                        component: FeesType
                    },
                    {
                        path: 'fees-installment/account-master',
                        name: 'fees-installment',
                        component: FeesInstallment
                    },
                    {
                        path: 'payment-mode/account-master',
                        name: 'payment-mode',
                        component: PaymentMode
                    },
                    {
                        path: 'fees-component/account-master',
                        name: 'fees-component',
                        component: FeesComponent
                    },
                    {
                        path: 'bank/account-master',
                        name: 'bank',
                        component: Bank
                    },
                    //AccountMaster
                    {
                        path: 'account-master',
                        name: 'account-master',
                        component: AccountMaster
                    },
                    //ApplicationFormFeesTransctionReport
                    {
                        path: 'application-form-fees-transction-report',
                        name: 'application-form-fees-transction-report',
                        component: ApplicationFormFeesTransctionReport
                    },
                    {
                        path: 'fees-structure',
                        name: 'fees-structure',
                        component: FeesStructure
                    },
                    {
                        path: 'receipt-report',
                        name: 'receipt-report',
                        component: ReceiptReport
                    },

                    {
                        path: 'fees-payment-schedule',
                        name: 'fees-payment-schedule',
                        component: FeesPaymentSchedule
                    },
                    //Fees
                    {
                        path: 'fees-payment',
                        name: 'fees-payment',
                        component: FeesPayment,
                        props: true,
                        children: [
                            {
                                path: 'admission-fees',
                                name: 'admission-fees',
                                component: AdmissionFees
                            },
                            {
                                path: 'hostel-fees',
                                name: 'hostel-fees',
                                component: HostelFees
                            },
                        ]
                    },

                    //rolemanagement
                    {
                        path: 'add-organization',
                        name: 'add-organization',
                        component: AddOrganization
                    },
                    {
                        path: 'add-role',
                        name: 'add-role',
                        component: AddRole
                    },
                    {
                        path: 'search-student',
                        name: 'search-student',
                        component: SearchStudent
                    },
                    {
                        path: 'search-emp',
                        name: 'search-emp',
                        component: SearchEmployee
                    },
                    {
                        path: 'edit-employee',
                        name: 'edit-employee',
                        component: EditEmployee
                    },
                    {
                        path: 'add-role-links',
                        name: 'add-role-links',
                        component: AddRoleLinks
                    },
                    {
                        path: 'add-user',
                        name: 'add-user',
                        component: AddUser
                    },
                    {
                        path: 'import-employee',
                        name: 'import-employee',
                        component: ImportEmployee
                    },
                    {
                        path: 'import-student',
                        name: 'import-student',
                        component: ImportStudent
                    },
                    //QuizReport
                    {
                        path: 'quiz-report',
                        name: 'QuizReport',
                        component: QuizReport
                    },
                    {
                        path: 'quiz-mark-analysis-report',
                        name: 'QuizMarkAnalysisReport',
                        component: QuizMarkAnalysisReport
                    },
                    {
                        path: 'bulk-photo-upload',
                        name: 'BulkPhotoUpload',
                        component: BulkPhotoUpload
                    },
                    {
                        path: 'import-student-des',
                        name: 'import-student-des',
                        component: ImportStudentDes
                    },
                    {
                        path: 'ordinance-rule',
                        name: 'ordinance-rule',
                        component: OrdinanceRuleMaster
                    },
                    {
                        path: 'ordinance-rule-mapping',
                        name: 'ordinance-rule-mapping',
                        component: OrdinanceRuleMapping
                    },
                    {
                        path: 'bulk-seat-no-import',
                        name: 'bulk-seat-no-import',
                        component: BulkSeatNumberImport
                    },
                    {
                        path: 'result-class',
                        name: 'result-class',
                        component: ResultClassMaster
                    },
                    {
                        path: 'edit-student-import',
                        name: 'edit-student-import',
                        component: EditStudentImport
                    },
                    {
                        path: 'get-employee-student',
                        name: 'get-employee-student',
                        component: GetEmployee_Student
                    },
                    {
                        path: 'add-roletouser',
                        name: 'add-roletouser',
                        component: AddRoleToUser
                    },
                    {
                        path: 'add-user-access',
                        name: 'add-user-access',
                        component: AddUserAccess
                    },
                    {
                        path: 'help',
                        name: 'help',
                        component: RoleHelp
                    },
                    {
                        path: 'employee-type',
                        name: 'employee-type',
                        component: EmployeeType
                    },
                    {
                        path: 'employee-category',
                        name: 'employee-category',
                        component: ServiceType
                    },
                    {
                        path: 'employee-shift',
                        name: 'employee-shift',
                        component: EmployeeShift
                    },
                    {
                        path: 'designation',
                        name: 'designation',
                        component: Designation
                    },
                    {
                        path: 'emp-bulk-role',
                        name: 'emp-bulk-role',
                        component: EmployeeBulkRole
                    },
                    {
                        path: 'parent-info',
                        name: 'parent-info',
                        component: ParentInfo
                    },
                    {
                        path: 'data-between-dates',
                        name: 'data-between-dates',
                        component: DataBetweenDates
                    },
                    {
                        path: 'admin-change-password',
                        name: 'admin-change-password',
                        component: AdminChangePassword
                    },// 
                    {
                        path: 'password-manage',
                        name: 'password-manage',
                        component: PasswordManage
                    },// 
                    {
                        path: 'admin-get-password',
                        name: 'admin-get-password',
                        component: UsernamePassword
                    },//
                    {
                        path: 'admin-get-logs',
                        name: 'admin-get-logs',
                        component: Logs
                    },//LoginDetails
                    {
                        path: 'login-details',
                        name: 'login-details',
                        component: LoginDetails
                    },//
                    //  {
                    //     path: 'support',
                    //     name: 'support',
                    //     component: Support
                    // },
                    {
                        path: 'admin-check-master-status',
                        name: 'admin-check-master-status',
                        component: CheckMasterStatus
                    },//
                    {
                        path: 'admin-bypass-login',
                        name: 'admin-bypass-login',
                        component: BypassLogin,
                    },
                    {
                        path: 'emp-bypass-login',
                        name: 'emp-bypass-login',
                        component: EmpByPassLogin,
                    },
                    // {//written new code
                    //     path: 'admin-bypass-login',
                    //     name: 'admin-bypass-login',
                    //     component: BypassLogin
                    // },
                    {
                        path: 'set-learner-status',
                        name: 'set-learner-status',
                        component: SetLearnerStatus
                    },
                    {
                        path: 'map-parent-learner',
                        name: 'map-parent-learner',
                        component: MapParentToLearner
                    },
                    {
                        path: 'default-type-value',
                        name: 'default-type-value',
                        component: DefalultTypeValue
                    },
                    {
                        path: 'default-values',
                        name: 'default-values',
                        component: DefaultValues
                    },
                    {
                        path: 'mobile-app-link-master',
                        name: 'mobile-app-link-master',
                        component: MobileAppLinkMaster
                    },
                    {
                        path: 'instructor-bulk-edit',
                        name: 'instructor-bulk-edit',
                        component: InstructorBulkEdit
                    },
                    //Masters
                    {
                        path: 'role-management-master',
                        name: 'role-management-master',
                        component: MasterMenu
                    },
                    {
                        path: 'activity-type',
                        name: 'activity-type',
                        component: ActivityTypeMaster
                    },
                    {
                        path: 'award-type',
                        name: 'award-type',
                        component: AwardTypeMaster
                    },
                    {
                        path: 'query-level-master',
                        name: 'query-level-master',
                        component: QueryLevelMaster
                    },
                    {
                        path: 'query-status-master',
                        name: 'query-status-master',
                        component: QueryStatusMaster
                    },
                    {
                        path: 'query-type-master',
                        name: 'query-type-master',
                        component: QueryTypeMaster
                    },
                    {
                        path: 'degree-master',
                        name: 'degree-master',
                        component: DegreeMaster
                    },
                    {
                        path: 'erp-class',
                        name: 'erp-class',
                        component: ERPClassMaster
                    },
                    {
                        path: 'experience-type',
                        name: 'experience-type',
                        component: ExperienceTypeMaster
                    },
                    {
                        path: 'publication-category',
                        name: 'publication-category',
                        component: PublicationCategoryMaster
                    },
                    {
                        path: 'publication-index-type',
                        name: 'publication-index-type',
                        component: PublicationIndexTypeMaster
                    },
                    {
                        path: 'publication-type',
                        name: 'publication-type',
                        component: PublicationTypeMaster
                    },
                    {
                        path: 'research-status',
                        name: 'research-status',
                        component: ResearchStatusMaster
                    },
                    {
                        path: 'research-type',
                        name: 'research-type',
                        component: ResearchTypeMaster
                    },
                    //admission
                    {
                        path: 'offer-template',
                        name: 'offer-template',
                        component: OfferTemplate
                    },
                    {
                        path: 'allocate-elective-choices',
                        name: 'allocate-elective-choices',
                        component: AllocateElectiveChoices
                    },
                    {
                        path: 'add-ay',
                        name: 'add-ay',
                        component: AddAy
                    },
                    {
                        path: 'import-address',
                        name: 'import-address',
                        component: ImportAddress
                    },//

                    {
                        path: 'offer-division',
                        name: 'offer-division',
                        component: OfferDivision
                    },//
                    {
                        path: 'copy-offer-division',
                        name: 'copy-offer-division',
                        component: CopyOfferDivision
                    },//
                    {
                        path: 'family-type',
                        name: 'family-type',
                        component: FamilyType
                    },//
                    {
                        path: 'add-student',
                        name: 'add-student',
                        component: AddStudent
                    },//
                    {
                        path: 'add-student-sbpps',
                        name: 'add-student',
                        component: AddStudentSBPPS
                    },//
                    {
                        path: 'add-student-eps',
                        name: 'add-student',
                        component: AddStudentEPS
                    },//
                    {
                        path: 'add-student-wws',
                        name: 'add-student',
                        component: AddStudentWWS
                    },//
                    {
                        path: 'add-student-zeal',
                        name: 'add-student',
                        component: AddStudentZeal
                    },//
                    {
                        path: 'add-employee',
                        name: 'add-employee',
                        component: AddEmployee
                    },//
                    {
                        path: 'create-gmail-account',
                        name: 'create-gmail-account',
                        component: CreateGmailAccount
                    },//
                    {
                        path: 'assign-cordinator',
                        name: 'assign-cordinator',
                        component: AssignCordinator
                    },
                    {
                        path: 'application-form-fees-master',
                        name: 'application-form-fees-master',
                        component: ApplicationFormFeesMaster
                    },
                    {
                        path: 'copy-class-teacher',
                        name: 'copy-class-teacher',
                        component: CopyClassTeacher
                    },
                    {
                        path: 'division-allocation',
                        name: 'division-allocation',
                        component: DivisionAllocation
                    },

                    {
                        path: 'serial-field-config',
                        name: 'serial-field-config',
                        component: SerialFieldConfig
                    },
                    {
                        path: 'form-field-config',
                        name: 'form-field-config',
                        component: FormFieldConfig
                    },
                    //    Edit Profile
                    {
                        path: 'edit-student-profile',
                        name: 'edit-student-profile',
                        component: EditStudentProfile
                    },
                    {
                        path: 'wws-generate-prn',
                        name: 'wws-generate-prn',
                        component: WWSGeneratePRN
                    },
                    {
                        path: 'student-profile-tabs',
                        name: 'student-profile-tabs',
                        component: StudentProfileTabs
                    },
                    {
                        path: 'student-primary-contact-details',
                        name: 'student-primary-contact-details',
                        component: StudentPrimaryContactDetails
                    },
                    //    Edit Employee Profile
                    {
                        path: 'edit-employee-profile',
                        name: 'edit-employee-profile',
                        component: EditEmpProfile
                    },
                    {
                        path: 'edit-emp-profile',
                        name: 'edit-emp-profile',
                        component: EditEmployeeProfile
                    },
                    {
                        path: 'settelment-report',
                        name: 'settelment-report',
                        component: SettelmentReport
                    },
                    {
                        path: 'edit-child-profile',
                        name: 'edit-child-profile',
                        component: EditChildProfile
                    },
                    {
                        path: 'edit-child-profile-new',
                        name: 'edit-child-profile-new',
                        component: EditChildProfileNew
                    },
                    {
                        path: 'edit-child-profile-by-role',
                        name: 'edit-child-profile-by-role',
                        component: EditChildProfileByRole
                    },
                    {
                        path: 'virtual-card',
                        name: 'virtual-card',
                        component: VirtualCard
                    },
                    {
                        path: 'employee-profile-tabs',
                        name: 'employee-profile-tabs',
                        component: EmpProfileTabs
                    },
                    {
                        path: 'stream-mapping',
                        name: 'stream-mapping',
                        component: StreamMapping
                    },
                    {
                        path: 'add-roll-no',
                        name: 'add-roll-no',
                        component: AddRollNo
                    },
                    {
                        path: 'change-offer-division',
                        name: 'change-offer-division',
                        component: ChangeOfferDivision
                    },
                    {
                        path: 'application-status-list',
                        name: 'application-status-list',
                        component: ApplicationStatusList
                    },
                    {
                        path: 'one-view-application-form',
                        name: 'one-view-application-form',
                        component: OneViewApplicationForm
                    },
                    {
                        path: 'admitted-student-report',
                        name: 'admitted-student-report',
                        component: AdmittedStudentReport
                    },  //
                    {
                        path: 'admitted-student-report-ld',
                        name: 'admitted-student-report-ld',
                        component: AdmittedStudentReportWithoutLD
                    },  //
                    {
                        path: 'relative-details-report',
                        name: 'relative-details-report',
                        component: RelativeDetailsReport
                    },  //
                    {
                        path: 'employee-data-report',
                        name: 'employee-data-report',
                        component: EmployeeData
                    },
                    {
                        path: 'roll-call',
                        name: 'roll-call',
                        component: RollCall
                    },
                    {
                        path: 'admission-instruction',
                        name: 'admission-instruction',
                        component: AdmissionInstruction
                    },
                    {
                        path: 'bulk-edit-info',
                        name: 'bulk-edit-info',
                        component: BulkEditOtherInfo
                    },
                    {
                        path: 'academic-dashboard',
                        name: 'academic-dashboard',
                        component: AcademicDashboard
                    },
                    {
                        path: 'academic-data',
                        name: 'academic-data',
                        component: AcademicData
                    },
                    {
                        path: 'fee-receipt-certificate',
                        name: 'fee-receipt-certificate',
                        component: FeeReceiptCertificate
                    },
                    {
                        path: 'certificate-bonafied',
                        name: 'certificate-bonafied',
                        component: Bonafied
                    },//
                    {
                        path: 'certificate-zeal-bonafied',
                        name: 'certificate-zeal-bonafied',
                        component: GetBonafideZeal
                    },//
                    {
                        path: 'request-certificate-bonafied',
                        name: 'request-certificate-bonafied',
                        component: GetBonafideWWS
                    },//
                    {
                        path: 'certificate-fees-payment-receipt',
                        name: 'certificate-fees-payment-receipt',
                        component: CeritificateReceipt
                    },//
                    {
                        path: 'get-certificate-lc',
                        name: 'get-certificate-lc',
                        component: LeavingCertificate
                    },
                    {
                        path: 'generate-bulk-lc',
                        name: 'generate-bulk-lc',
                        component: BulkLeavingCertificate
                    },
                    {
                        path: 'get-certificate-zeal-bonafied',
                        name: 'get-certificate-zeal-bonafied',
                        component: GetCertificateZealBonafide
                    },//
                    {
                        path: 'get-Certificate-Report',
                        name: 'get-Certificate-Report',
                        component: getCertificateReport
                    },//
                    {
                        path: 'get-certificate-bonafied1',
                        name: 'get-certificate-bonafied1',
                        component: getcertificate1
                    },//
                    {
                        path: 'get-certificate-for-report-print',
                        name: 'get-certificate-for-report-print',
                        component: getcertificateforreportprint
                    },//

                    {
                        path: 'get-bonafied-certificate-report-print-SJCV',
                        name: 'get-bonafied-certificate-report-print-SJCV',
                        component: getBonafiedCertificatereportprintSJCV
                    },//

                    {
                        path: 'get-bonafied-certificate-report-print-ssjc',
                        name: 'get-bonafied-certificate-report-print-ssjc',
                        component: getBonafiedCertificatereportprintSSJC
                    },//
                    {
                        path: 'get-bonafied-certificate-report-print-sanjivani',
                        name: 'get-bonafied-certificate-report-print-sanjivani',
                        component: getBonafiedCertificateSanjivanireportprint
                    },//
                    {
                        path: 'get-bonafied-certificate-report-print-vvp',
                        name: 'get-bonafied-certificate-report-print-vvp',
                        component: getBonafiedCertificatereportVVPprint
                    },//
                    {
                        path: 'get-bonafied-certificate-report-print-wws',
                        name: 'get-bonafied-certificate-report-print-wws',
                        component: getBonafiedCertificatereportWWSprint
                    },//
                    {
                        path: 'get-bonafied-certificate-report-print-zeal',
                        name: 'get-bonafied-certificate-report-print-zeal',
                        component: getBonafiedCertificatereportZealprint
                    },//
                    {
                        path: 'get-certificate-bonafied2',
                        name: 'get-certificate-bonafied2',
                        component: getcertificate2
                    },//
                    {
                        path: 'get-bonafied-certificate-sanjivani',
                        name: 'get-bonafied-certificate-sanjivani',
                        component: getBonafiedCertificateSanjivani
                    },//
                    {
                        path: 'get-bonafied-certificate-sjcv',
                        name: 'get-bonafied-certificate-sjcv',
                        component: getBonafiedCertificateSJCV
                    },//
                    {
                        path: 'get-bonafide-certificate-ssjc',
                        name: 'get-bonafide-certificate-ssjc',
                        component: getBonafiedCertificateSSJC
                    },//
                    {
                        path: 'get-bonafied-certificate-sanjivani-print',
                        name: 'get-bonafied-certificate-sanjivani-print',
                        component: getBonafiedCertificateSanjivaniPrint
                    },//
                    {
                        path: 'get-bonafide-certificate-vvp',
                        name: 'get-bonafide-certificate-vvp',
                        component: getBonafideCertificateVvp
                    },//
                    {
                        path: 'get-bonafide-certificate-vvp-print',
                        name: 'get-bonafide-certificate-vvp-print',
                        component: getBonafideCertificateVvpPrint
                    },//
                    {
                        path: 'get-bonafide-certificate-wws',
                        name: 'get-bonafide-certificate-wws',
                        component: getBonafideCertificateWws
                    },
                    {
                        path: 'get-certificate-bonafied',
                        name: 'get-certificate-bonafied',
                        component: getcertificate
                    },
                    {
                        path: 'bonafide-certificate-des',
                        name: 'bonafide-certificate-des',
                        component: BonafideCertificateDES
                    },//
                    {
                        path: 'promote-student',
                        name: 'promote-student',
                        component: PromoteStudent
                    },
                    {
                        path: 'provisional-promote-student',
                        name: 'provisional-promote-student',
                        component: ProvisionalPromoteStudent
                    },
                    {
                        path: 'student-promotion',
                        name: 'student-promotion',
                        component: StudentPromotion
                    },
                    {
                        path: 'set-age-criteria',
                        name: 'set-age-criteria',
                        component: SetAgeCriteria
                    },
                    {
                        path: 'set-std-fee',
                        name: 'set-std-fee',
                        component: SetStdAdmissionFee
                    },
                    {
                        path: 'standard-admission-quota',
                        name: 'standard-admission-quota',
                        component: StandardAdmissionQuota
                    },
                    {
                        path: 'admission-fee-report',
                        name: 'admission-fee-report',
                        component: AdmissionFeeReport
                    },
                    {
                        path: 'import-city',
                        name: 'import-city',
                        component: ImportCity
                    },
                    //AdmissionMaster //
                    {
                        path: 'admission-master',
                        name: 'admission-master',
                        component: AdmissionMaster
                    },
                    //AdmissionMaster-links
                    {
                        path: 'application-status/admission-master',
                        name: 'application-status',
                        component: ApplicationStatus
                    },
                    {
                        path: 'serial-field-type-master/admission-master',
                        name: 'serial-field-type-master',
                        component: SerialFieldTypeMaster
                    },
                    {
                        path: 'serial-field-master',
                        name: 'serial-field-master',
                        component: SerialFieldMaster
                    },
                    {
                        path: 'field-master/admission-master',
                        name: 'field-master',
                        component: FieldMaster
                    },
                    {
                        path: 'address-type-master/admission-master',
                        name: 'address-type-master',
                        component: AddressTypeMaster
                    },
                    {
                        path: 'add-division/admission-master',
                        name: 'add-division',
                        component: AddDivision
                    },
                    {
                        path: 'division-master/admission-master',
                        name: 'division-master',
                        component: DivisionMaster
                    },
                    {
                        path: 'standard-master/admission-master',
                        name: 'standard-master',
                        component: StandardMaster
                    },
                    {
                        path: 'document-category-master/admission-master',
                        name: 'document-category-master',
                        component: DocumentCategoryMaster
                    },
                    {
                        path: 'document-level-master/admission-master',
                        name: 'document-level-master',
                        component: DocumentLevelMaster
                    },
                    {
                        path: 'document-access-control-master/admission-master',
                        name: 'document-access-control-master',
                        component: DocumentAccessControlMaster
                    },
                    {
                        path: 'document-sub-category-master/admission-master',
                        name: 'document-sub-category-master',
                        component: DocumentSubCategoryMaster
                    },
                    {
                        path: 'document-access-control/admission-master',
                        name: 'document-access-control',
                        component: DocumentAccessControl
                    },
                    {
                        path: 'document-access-logs/admission-master',
                        name: 'document-access-logs',
                        component: DocumentAccessLogs
                    },
                    {
                        path: 'district-master/admission-master',
                        name: 'district-master',
                        component: DistrictMaster
                    },
                    {
                        path: 'studentype-master/admission-master',
                        name: 'studentype-master',
                        component: StudentTypeMaster
                    },
                    {
                        path: 'pin-code-master/admission-master',
                        name: 'pin-code-master',
                        component: PinCodeMaster
                    },
                    {
                        path: 'relation-type-master/admission-master',
                        name: 'relation-type-master',
                        component: RelationTypeMaster
                    },
                    {
                        path: 'occupation-master/admission-master',
                        name: 'occupation-master',
                        component: OccupationMaster
                    },
                    {
                        path: 'country-master/admission-master',
                        name: 'country-master',
                        component: CountryMaster
                    },
                    {
                        path: 'state-master/admission-master',
                        name: 'state-master',
                        component: StateMaster
                    },
                    {
                        path: 'day-master/admission-master',
                        name: 'day-master',
                        component: DayMaster
                    },
                    {
                        path: 'stream-master/admission-master',
                        name: 'stream-master',
                        component: StreamMaster
                    },
                    {
                        path: 'quota-master/admission-master',
                        name: 'quota-master',
                        component: QuotaMaster
                    },
                    {
                        path: 'house-master/admission-master',
                        name: 'house-master',
                        component: HouseMaster
                    },
                    {
                        path: 'minority-master/admission-master',
                        name: 'minority-master',
                        component: MinorityMaster
                    },
                    {
                        path: 'skill-master/admission-master',
                        name: 'skill-master',
                        component: SkillMaster
                    },
                    {
                        path: 'interest-master/admission-master',
                        name: 'interest-master',
                        component: InterestMaster
                    },
                    {
                        path: 'career-master/admission-master',
                        name: 'career-master',
                        component: CareerMaster
                    },
                    {
                        path: 'physical-disability-type-master/admission-master',
                        name: 'physical-disability-type-master',
                        component: PhysicalDisabilityTypeMaster
                    },
                    {
                        path: 'learner-house-mapping',
                        name: 'learner-house-mapping',
                        component: LearnerHouseMapping
                    },
                    {
                        path: 'room-type-master/admission-master',
                        name: 'room-type-master',
                        component: RoomTypeMaster
                    },
                    {
                        path: 'document-type-master/admission-master',
                        name: 'document-type-master',
                        component: DocumentTypeMaster
                    },
                    {
                        path: 'document-type-standard-master/admission-master',
                        name: 'document-type-standard-master',
                        component: DocumentTypeStandardMaster
                    },
                    {
                        path: 'category-master/admission-master',
                        name: 'category-master',
                        component: CategoryMaster
                    },
                    {
                        path: 'domacile-master/admission-master',
                        name: 'domacile-master',
                        component: DomacileMaster
                    },
                    {
                        path: 'communication-mode-master/admission-master',
                        name: 'communication-mode-master',
                        component: CommunicationModeMaster
                    },
                    {
                        path: 'religion-master/admission-master',
                        name: 'religion-master',
                        component: ReligionMaster
                    },
                    {
                        path: 'cast-master/admission-master',
                        name: 'cast-master',
                        component: CastMaster
                    },
                    {
                        path: 'subcaste-master/admission-master',
                        name: 'subcaste-master',
                        component: SubCasteMaster
                    },
                    {
                        path: 'rationcard-master/admission-master',
                        name: 'rationcard-master',
                        component: RationCardMaster
                    },
                    {
                        path: 'school-board-master/admission-master',
                        name: 'school-board-master',
                        component: SchoolBoardMaster
                    },
                    {
                        path: 'gender-master/admission-master',
                        name: 'gender-master',
                        component: GenderMaster
                    },
                    {
                        path: 'blood-group-master/admission-master',
                        name: 'blood-group-master',
                        component: BloodGroupMaster
                    },
                    {
                        path: 'language-master/admission-master',
                        name: 'language-master',
                        component: LanguageMaster
                    },
                    {
                        path: 'form-field-type-master/admission-master',
                        name: 'form-field-type-master',
                        component: FormFieldTypeMaster
                    },
                    {
                        path: 'semester-master/admission-master',
                        name: 'semester-master',
                        component: SemesterMaster
                    },
                    {
                        path: 'serial-field-tracking-master/admission-master',
                        name: 'serial-field-tracking-master',
                        component: SerialFieldTracking
                    },
                    {
                        path: 'receipt-headers-master/admission-master',
                        name: 'receipt-headers-master',
                        component: ReceiptHeadersMaster
                    },
                    {
                        path: 'certificate-type-master/admission-master',
                        name: 'certificate-type-master',
                        component: CertificateTypeMaster
                    },

                    {
                        path: 'department-master/admission-master',
                        name: 'department-master',
                        component: Department
                    },
                    {
                        path: 'vaccination-master/admission-master',
                        name: 'vaccination-master',
                        component: VaccinationMaster
                    },
                    {
                        path: 'transportation-mode-master/admission-master',
                        name: 'transportation-mode-master',
                        component: TransportationModeMaster
                    },
                    {
                        path: 'configuration-master/admission-master',
                        name: 'configuration-master',
                        component: ConfigurationMaster
                    },
                    {
                        path: 'section-master/admission-master',
                        name: 'section-master',
                        component: SectionMaster
                    },
                    {
                        path: 'admission-round/admission-master',
                        name: 'admission-round',
                        component: AdmissionRound
                    },
                    {
                        path: 'file-type-master/admission-master',
                        name: 'file-type-master',
                        component: FileTypeMaster
                    },
                    {
                        path: 'allotment-list',
                        name: 'allotment-list',
                        component: AllotmentList
                    },
                    {
                        path: 'pay-elective-fees',
                        name: 'pay-elective-fees',
                        component: PayElectiveFees
                    },
                    {
                        path: 'course-head/admission-master',
                        name: 'course-head',
                        component: CourseHead
                    },
                    {
                        path: 'subject-group/admission-master',
                        name: 'subject-group',
                        component: SubjectGroup
                    },
                    {
                        path: 'subject-group-details/admission-master',
                        name: 'subject-group-details',
                        component: SubjectGroupDetails
                    },
                    {
                        path: 'selection-type/admission-master',
                        name: 'selection-type',
                        component: SelectionType
                    },
                    {
                        path: 'offer-subject-group',
                        name: 'offer-subject-group',
                        component: SubjectGroupOffering
                    },
                    {
                        path: 'add-template',
                        name: 'add-template',
                        component: AddTemplate
                    },
                     {
                        path: 'template-details',
                        name: 'template-details',
                        component: TemplateDetails
                    },
                    {
                        path: 'social-welfare',
                        name: 'social-welfare',
                        component: SocialWelfare
                    },
                    {
                        path: 'marital-status',
                        name: 'marital-status',
                        component: MaritalStatus
                    },
                    //ApplicationForm
                    {
                        path: 'change-division',
                        name: 'change-division',
                        component: ChangeLearnerDivision
                    },
                    {
                        path: 'change-bulk-learner-division',
                        name: 'change-bulk-learner-division',
                        component: ChangeBulkLearnerDivision
                    },
                    {
                        path: 'application-form',
                        name: 'application-form',
                        component: ApplicationForm
                    },
                    {
                        path: 'new-application-form',
                        name: 'new-application-form',
                        component: ApplicationForm
                    },
                    {
                        path: 'view-application-form',
                        name: 'view-application-form',
                        component: ViewApplicationForm
                    },
                    {
                        path: 'teacher-training-report',
                        name: 'teacher-training-report',
                        component: TeacherTrainingReport
                    },
                    {
                        path: 'application-form-fees-parent',
                        name: 'application-form-fees-parent',
                        component: ApplicationFormFeesParent
                    },
                    {
                        path: 'application-form-fees-staff',
                        name: 'application-form-fees-staff',
                        component: ApplicationFormFeesStaff
                    },
                    {
                        path: 'form-fees-receipt',
                        name: 'form-fees-receipt',
                        component: FormFeesReceipt
                    },
                    {
                        path: 'receipt',
                        name: 'receipt',
                        component: Receipt
                    },
                    {
                        path: 'parent-receipt',
                        name: 'parent-receipt',
                        component: ParentReceipt
                    },
                    {
                        path: 'admission-fees-receipt',
                        name: 'admission-fees-receipt',
                        component: AdmissionFeesReceipt
                    },
                    //digital learning
                    {
                        path: 'digital-learning',
                        name: 'digital-learning',
                        component: DigitalLearning
                    },
                    {
                        path: 'subject-catalogue',
                        name: 'subject-catalogue',
                        component: SubjectCatalogue
                    },
                    //communication     
                    {
                        path: 'communication-type-master',
                        name: 'communication-type-master',
                        component: CommunicationTypeMaster
                    },
                    {
                        path: 'whatsapp-template',
                        name: 'whatsapp-template',
                        component: WhatsappTemplate
                    },
                    {
                        path: 'put-faculty-notice',
                        name: 'put-faculty-notice',
                        component: PutFacultyNotice
                    },
                    {
                        path: 'instructor-notice',
                        name: 'instructor-notice',
                        component: InstructorNotice
                    },
                    {
                        path: 'put-notice-home-work',
                        name: 'put-notice-home-work',
                        component: PutNoticeHW
                    },
                    {
                        path: 'put-notice-home-work-report-fortreacher',
                        name: 'put-notice-home-work-report-fortreacher',
                        component: PutNoticeHWReportforTeacher
                    },
                     {
                        path: 'faculty-dashboard',
                        name: 'faculty-dashboard',
                        component: FacultyDashboard
                    },
                    {
                        path: 'add-events',
                        name: 'add-events',
                        component: AddEvents
                    },
                    {
                        path: 'put-notice-home-work-student',
                        name: 'put-notice-home-work-student',
                        component: PutNoticeHWStudent
                    },
                    {
                        path: 'put-notice-home-work-parent',
                        name: 'put-notice-home-work-parent',
                        component: PutNoticeHwForParent
                    },
                    {
                        path: 'put-notice-home-work-management',
                        name: 'put-notice-home-work-management',
                        component: HomeworkNoticeManagement
                    },
                    {
                        path: 'teacher-calendar',
                        name: 'teacher-calendar',
                        component: TeacherCalendar
                    },
                    {
                        path: 'put-album',
                        name: 'put-album',
                        component: PutAlbum
                    },
                    {
                        path: 'cordinator-put-album',
                        name: 'cordinator-put-album',
                        component: CordinatorPutAlbum
                    },
                    {
                        path: 'cordinator-put-notice',
                        name: 'cordinator-put-notice',
                        component: CordinatorPutNotice
                    },
                    {
                        path: 'cordinator-put-calendar',
                        name: 'cordinator-put-calendar',
                        component: CordinatorPutCalendar
                    },
                    {
                        path: 'classteacher-put-album',
                        name: 'classteacher-put-album',
                        component: ClassteacherPutAlbum
                    },
                    {
                        path: 'classteacher-put-notice',
                        name: 'classteacher-put-notice',
                        component: ClassteacherPutNotice
                    },
                    {
                        path: 'classteacher-put-calendar',
                        name: 'classteacher-put-calendar',
                        component: ClassteacherPutCalendar
                    },
                    {
                        path: 'put-calendar',
                        name: 'put-calendar',
                        component: PutCalendar
                    },

                    {
                        path: 'communication-type/communication-type-master',
                        name: 'communication-type',
                        component: CommunicationType
                    },
                    {
                        path: 'communication-event-type/communication-type-master',
                        name: 'communication-event-type',
                        component: EventType
                    },
                    {
                        path: 'communication-schedule',
                        name: 'communication-schedule',
                        component: CommunicationSchedule
                    },
                    {
                        path: 'communication-status',
                        name: 'communication-status',
                        component: CommunicationStatus
                    },
                    {
                        path: 'student-communication',
                        name: 'student-communication',
                        component: AllStudentCommunication
                    },
                    {
                        path: 'sms-template',
                        name: 'sms-template',
                        component: SmsTemplateMaster
                    },
                    {
                        path: 'student-communication-sms',
                        name: 'student-communication-sms',
                        component: AllStudentCommunicationWithTemplate
                    },
                    {
                        path: 'all-student-communications',
                        name: 'all-student-communications',
                        component: AllStudentCommsNew
                    },
                    {
                        path: 'whatsapp-communications',
                        name: 'whatsapp-communications',
                        component: WhatsApp
                    },
                    //communication group
                    {
                        path: 'create-communication-group',
                        name: 'create-communication-group',
                        component: CreateCommunicationGroup
                    },
                    {
                        path: 'message-status',
                        name: 'message-status',
                        component: MessageStatus
                    },
                    {
                        path: 'faculty-join-group',
                        name: 'faculty-join-group',
                        component: FacultyJoinGroup
                    },
                    {
                        path: 'student-join-group',
                        name: 'student-join-group',
                        component: StudentJoinGroup
                    },
                    {
                        path: 'lesson-planning',
                        name: 'lesson-planning',
                        component: LessonPlanning
                    },
                    {
                        path: 'set-lesson-planner',
                        name: 'set-lesson-planner',
                        component: SetLessonPlanner
                    },
                    {
                        path: 'set-course-plane-for-admin',
                        name: 'set-course-plane-for-admin',
                        component: SetCoursePlaneForAdmin
                    },
                    {
                        path: 'lesson-plan-week',
                        name: 'lesson-plan-week',
                        component: LessonPlanWeek
                    },
                    {
                        path: 'lesson-planning-teacher',
                        name: 'lesson-planning-teacher',
                        component: LessonPlanningTeacher
                    },
                    {
                        path: 'lesson-plan-execution',
                        name: 'lesson-plan-execution',
                        component: LessonPlanExecution
                    },
                    {
                        path: 'view-lesson-plan',
                        name: 'view-lesson-plan',
                        component: LessonPlanForParentStudentSide
                    },
                    {
                        path: 'lesson-plan-head-planner',
                        name: 'lesson-plan-head-planner',
                        component: LessonPlanningHeadAndPlanner
                    },
                    {
                        path: 'import-lesson-plan',
                        name: 'import-lesson-plan',
                        component: ImportLessonPlans
                    },
                    {
                        path: 'copy-lesson-plan',
                        name: 'copy-lesson-plan',
                        component: CopyLessonPlan
                    },
                    {
                        path: 'lesson-plan-tracking-report',
                        name: 'lesson-plan-tracking-report',
                        component: LessonPlanTrackingReport
                    },
                    {
                        path: 'upload-grl-mapping',
                        name: 'upload-grl-mapping',
                        component: UploadGrlMapping
                    },
                    //quiz
                    {
                        path: 'quiz-dashboard',
                        name: 'quiz-dashboard',
                        component: QuestionBankDashboard
                    },
                    {
                        path: 'import-quiz-question',
                        name: 'import-quiz-question',
                        component: ImportQuizQuestionList
                    },
                    //learner quiz
                    {
                        path: 'learner-quiz',
                        name: 'learner-quiz',
                        component: Test
                    },
                    {
                        path: 'learner-course-test-result',
                        name: 'learner-course-test-result',
                        component: LearnerTestResult
                    },
                    {
                        path: 'learner-start-exam',
                        name: 'learner-start-exam',
                        component: LearnerStartExam
                    },
                    {
                        path: 'edit-quiz',
                        name: 'edit-quiz',
                        component: EditQuestionBank
                    },
                    {
                        path: 'course-chapters',
                        name: 'course-chapters',
                        component: CourseChapterCard
                    },
                    {
                        path: "communication-group-message",
                        name: "communication-group-message",
                        component: CommunicationGroupMessage,
                        props: true,
                        children: [
                            {
                                path: "group-notice",
                                name: "group-notice",
                                component: GroupNotice,
                            },
                            {
                                path: "group-album",
                                name: "group-album",
                                component: GroupAlbum,
                            },
                            {
                                path: "group-calendar",
                                name: "group-calendar",
                                component: GroupCalendar,
                            },


                        ]
                    },
                    { //not used
                        path: "read-group-message",
                        name: "read-group-message",
                        component: ReadGroupMessage,
                    },
                    {
                        path: "group-communication-link",
                        name: "group-communication-link",
                        component: GroupCommunicationLink,
                    },
                    {
                        path: "/show-notifications",
                        name: "show-notifications",
                        component: ShowNotifications,
                    },
                    {
                        path: "view-group-calendar",
                        name: "view-group-calendar",
                        component: ViewGroupCalender,
                    },
                    {
                        path: "view-group-notice",
                        name: "view-group-notice",
                        component: ViewGroupNotice,
                    },
                    {
                        path: "view-group-album",
                        name: "view-group-album",
                        component: ViewGroupAlbum,
                    },

                    //Parent 
                    {
                        path: 'parent-communication-link',
                        name: 'parent-communication-link',
                        component: ParentCommunicationLink,
                    },
                    {
                        path: 'parent-notice-home-work',
                        name: 'parent-notice-home-work',
                        component: ParentNotice
                    },
                    {
                        path: 'parent-album',
                        name: 'parent-album',
                        component: ParentAlbum
                    },
                    {
                        path: 'parent-calendar',
                        name: 'parent-calendar',
                        component: ParentCalendar
                    },

                    //Examination   
                    {
                        path: 'delete-course-offering-learner',
                        name: 'delete-course-offering-learner',
                        component: DeleteCourseOfferingLearner
                    },
                    {
                        path: 'import-subject-offering',
                        name: 'import-subject-offering',
                        component: ImportSubjectOffering

                    },
                    {
                        path: 'import-subject',
                        name: 'import-subject',
                        component: ImportSubject

                    },
                    {
                        path: 'change-subject-grade',
                        name: 'change-subject-grade',
                        component: ChangeLearnerSubjectGrade

                    },
                    {
                        path: 'copy-subject-offering',
                        name: 'copy-subject-offering',
                        component: CopySubjectOffering

                    },
                    {
                        path: 'import-course-offering-learner',
                        name: 'import-course-offering-learner',
                        component: ImportCourseOfferingLearner

                    },
                    {
                        path: 'import-course-offering-instructor',
                        name: 'import-course-offering-instructor',
                        component: ImportCourseOfferingInstructor

                    },
                    {
                        path: 'subject-registration',
                        name: 'subject-registration',
                        component: SubjectRegistration
                    },
                    {
                        path: 'subject-remark-report',
                        name: 'subject-remark-report',
                        component: SubjectRemarkReport
                    },
                    {
                        path: 'subject-master',
                        name: 'subject-master',
                        component: SubjectMaster
                    },
                    {
                        path: 'offer-subject',
                        name: 'offer-subject',
                        component: OfferSubject
                    },
                    {
                        path: 'edit-offer-subject',
                        name: 'edit-offer-subject',
                        component: EditOfferSubject
                    },
                    {
                        path: 'exam-master',
                        name: 'exam-master',
                        component: ExamMaster
                    },
                    {
                        path: 'subject-rule/exam-master',
                        name: 'subject-rule',
                        component: SubjectRule
                    },
                    {
                        path: 'subject-marks-entry-type/exam-master',
                        name: 'subject-marks-entry-type',
                        component: SubjectMarksEntryType
                    },
                    {
                        path: 'assessment-type/exam-master',
                        name: 'assessment-type',
                        component: AssessmentType
                    },
                    {
                        path: 'management-role-master/exam-master',
                        name: 'management-role-master',
                        component: ManagementRoleMaster
                    },
                    {
                        path: 'management-role-links-master/exam-master',
                        name: 'management-role-links-master',
                        component: ManagementRoleLinksMaster
                    },
                    {
                        path: 'management-user-roles-master/exam-master',
                        name: 'management-user-roles-master',
                        component: ManagementUserRolesMaster
                    },
                    {
                        path: 'assessment-type-config-master/exam-master',
                        name: 'assessment-type-config-master',
                        component: AssessmentTypeConfigMaster
                    },
                    {
                        path: 'evaluation-type/exam-master',
                        name: 'evaluation-type',
                        component: EvaluationType
                    },
                    {
                        path: 'rubrics/exam-master',
                        name: 'rubrics',
                        component: Rubrics
                    },
                     {
                        path: 'assessment-scheme-group/exam-master',
                        name: 'assessment-scheme-group',
                        component: AssessmentSchemeGroup 
                    },
                     {
                        path: 'assessment-type-grade-group/exam-master',
                        name: 'assessment-type-grade-group',
                        component: AssessmentTypeGradeGroup
                    },
                     {
                        path: 'document-template-linking/exam-master',
                        name: 'document-template-linking',
                        component: DocumentTemplateLinking
                    },
                    {
                        path: 'document-template-type/exam-master',
                        name: 'document-template-type',
                        component: DocumentTemplateType
                    },
                    {
                        path: 'document-template/exam-master',
                        name: 'document-template',
                        component: DocumentTemplate
                    },
                    {
                        path: 'rubrics-header/exam-master',
                        name: 'rubrics-header',
                        component: RubricsHeader
                    },
                    {
                        path: 'subject-type/exam-master',
                        name: 'subject-type',
                        component: SubjectType
                    },
                    {
                        path: 'course-type/exam-master',
                        name: 'course-type',
                        component: CourseType
                    },
                    {
                        path: 'assessment-details-formula/exam-master',
                        name: 'assessment-details-formula',
                        component: AssessmentDetailsFormula
                    },
                    {
                        path: 'subject-teacher-mapping',
                        name: 'subject-teacher-mapping',
                        component: SubjectTeacherMapping
                    },
                    {
                        path: 'instructor-sub-reg-info',
                        name: 'instructor-sub-reg-info',
                        component: InstructorSubRegs
                    },
                    {
                        path: 'rubric-scheme',
                        name: 'rubric-scheme',
                        component: RubricsScheme
                    },
                    {
                        path: 'rubric-scheme-report',
                        name: 'rubric-scheme-report',
                        component: RubricSchemeReport
                    },
                    {
                        path: 'subject-consolidated-report',
                        name: 'subject-consolidated-report',
                        component: SubjectConsolidatedReport
                    },
                    {
                        path: 'all-rubrics-subject-consolidated-report',
                        name: 'all-rubrics-subject-consolidated-report',
                        component: AllRubricsSubjectConsolidatedReport
                    },
                    {
                        path: 'all-rubrics-subject-consolidated-report-v2',
                        name: 'all-rubrics-subject-consolidated-report-v2',
                        component: AllRubricsSubjectConsolidatedReport_V2
                    },
                    {
                        path: 'all-subject-consolidated-report',
                        name: 'all-subject-consolidated-report',
                        component: AllSubjectExamReport
                    },
                    {
                        path: 'assessment-analysis-report',
                        name: 'assessment-analysis-report',
                        component: AssessmentAnalysis
                    },
                    {
                        path: 'rubrics-combine-report',
                        name: 'rubrics-combine-report',
                        component: RubricsCombineReport
                    },
                    {
                        path: 'learner-marksheet',
                        name: 'learner-marksheet',
                        component: LearnerMarksheet
                    },
                    {
                        path: 'learner-marksheet-sgs',
                        name: 'learner-marksheet-sgs',
                        component: LearnerMarksheetSGS
                    },
                    {
                        path: 'annual-marksheet-config',
                        name: 'annual-marksheet-config',
                        component: AnnualMarksheetConfig
                    },
                    {
                        path: 'rank-calculation',
                        name: 'rank-calculation',
                        component: RankCalculation
                    },
                    {
                        path: 'sgs-parent-learner-marksheet',
                        name: 'sgs-parent-learner-marksheet',
                        component: SgsParentLearnerMarksheet
                    },
                    {
                        path: 'learner-marksheet-class-teacher',
                        name: 'learner-marksheet-class-teacher',
                        component: LearnetMarksheetOfClassTeacher
                    },
                    {
                        path: 'preprimary-learner-marksheet-admin',
                        name: 'preprimary-learner-marksheet-admin',
                        component: PrePrimaryMarksheetAdmin
                    },
                    {
                        path: 'preprimary-learner-marksheet',
                        name: 'preprimary-learner-marksheet',
                        component: PrePrimaryMarksheet
                    },
                    {
                        path: 'preprimary-learner-marksheet-class-teacher',
                        name: 'preprimary-learner-marksheet-class-teacher',
                        component: PrePrimaryMarksheetClassTeacher
                    },
                    {
                        path: 'term-sheet',
                        name: 'term-sheet',
                        component: TermSheet
                    },
                    {
                        path: 'exam-cust-report',
                        name: 'exam-cust-report',
                        component: ExamCustReport
                    },
                    {
                        path: 'term-sheet-ssc',
                        name: 'term-sheet-ssc',
                        component: TermSheetSSC
                    },
                    {
                        path: 'set-due-date-marks-entry',
                        name: 'set-due-date-marks-entry',
                        component: MarkScheduling
                    },
                    {
                        path: 'teacher-marks-entry-extension',
                        name: 'teacher-marks-entry-extension',
                        component: TeacherMarksEntryExtension
                    },
                    {
                        path: 'upload-course-image',
                        name: 'upload-course-image',
                        component: UploadCourseImage
                    },
                    {
                        path: 'all-rubrics-marks-subject-report',
                        name: 'all-rubrics-marks-subject-report',
                        component: AllRubricsMarksSubjectReport
                    },
                    {
                        path: 'grace-marks-calculation',
                        name: 'grace-marks-calculation',
                        component: GraceMarksCalculation
                    },
                    {
                        path: 'all-subject-marks-report',
                        name: 'all-subject-marks-report',
                        component: AllSubjectMarksReport
                    },
                    {
                        path: 'term-result-sheet',
                        name: 'term-result-sheet',
                        component: TermResultSheet
                    },
                    {
                        path: 'user-height-weight-entry',
                        name: 'user-height-weight-entry',
                        component: UserBMI
                    },
                    {
                        path: 'user-bmi-report',
                        name: 'user-bmi-report',
                        component: BMIReport
                    },
                    {
                        path: 'block-result',
                        name: 'block-result',
                        component: BlockResult
                    },
                    {
                        path: 'block-unblock-result',
                        name: 'block-unblock-result',
                        component: Block_Unblock_Result
                    },
                    {
                        path: 'block-unblock-hall-ticket',
                        name: 'block-unblock-hall-ticket',
                        component: Block_Unblock_Hall_Ticket
                    },
                    {
                        path: 'exam-plan',
                        name: 'exam-plan',
                        component: ExamPlan
                    },
                    {
                        path: 'hall-ticket',
                        name: 'hall-ticket',
                        component: HallticketSJCK
                    },
                    {
                        path: 'active-inactive-student',
                        name: 'active-inactive-student',
                        component: Active_Inactive_Student
                    },
                    {
                        path: 'parent-learner-result',
                        name: 'parent-learner-result',
                        component: ParentLearnerMarksheet
                    },
                    {
                        path: 'import-rubric-marks',
                        name: 'import-rubric-marks',
                        component: ImportRubricMarks
                    },
                    {
                        path: 'import-learner-remark',
                        name: 'import-learner-remark',
                        component: LearnerRemarks
                    },
                    {
                        path: 'pass-fail-analysis-report',
                        name: 'pass-fail-analysis-report',
                        component: PassFailAnalysisReports
                    },
                    {
                        path: 'exam-seating-plan',
                        name: 'exam-seating-plan',
                        component: ExamSeatingPlan
                    },
                    {
                        path: 'learner-subject-remark',
                        name: 'learner-subject-remark',
                        component: ImportLearnerSubjectRemark
                    },

                     {
                        path: 'import-learner-subject-remark',
                        name: 'import-learner-subject-remark',
                        component: SubjectRemark
                    },
                    {
                        path: 'openhouse',
                        name: 'openhouse',
                        component: OpenHouse
                    },
                    {
                        path: 'openhousewws',
                        name: 'openhousewws',
                        component: OpenHouseWWS
                    },
                    {
                        path: 'hall-ticket-setting',
                        name: 'hall-ticket-setting',
                        component: HallTicketSetting
                    },
                    {
                        path: 'anunal-marksheet',
                        name: 'anunal-marksheet',
                        component: AnnualMarksheet
                    },
                    {
                        path: 'annual-marksheet-admin-secondary',
                        name: 'annual-marksheet-admin-secondary',
                        component: AnnualReportSecondary
                    },
                    {
                        path: 'learner-marksheet-admin',
                        name: 'learner-marksheet-admin',
                        component: LearnetMarksheetOfAdmin
                    },
                    {
                        path: 'combine-assessment-type',
                        name: 'combine-assessment-type',
                        component: CombineAssementType
                    },
                    {
                        path: 'combine-marks-list',
                        name: 'combine-marks-list',
                        component: CombineMarksList
                    },
                    {
                        path: 'combine-course-marks',
                        name: 'combine-course-marks',
                        component: CombineCourseMarks
                    },
                    {
                        path: 'installment-detail-report-zeal',
                        name: 'installment-detail-report-zeal',
                        component: InstallmentDetailsReport
                    },
                    {
                        path: 'transport-detail-report',
                        name: 'transport-detail-report',
                        component: TransportFeeDetailedReport
                    },
                    {
                        path: 'section-installment-detail-report-zeal',
                        name: 'section-installment-detail-report-zeal',
                        component: SectionInstallmentReport
                    },
                    {
                        path: 'account-dashboard',
                        name: 'account-dashboard',
                        component: AccountDashboard
                    },
                    {
                        path: 'academic-year-session',
                        name: 'academic-year-session',
                        component: NewAcademicYearSession
                    },
                    {
                        path: 'teacher-result-analysis',
                        name: 'teacher-result-analysis',
                        component: TeacherResultAnalysis
                    },
                    
                    //parent AS
                    {
                        path: 'assessment-scheme',
                        name: 'assessment-scheme',
                        component: AssessmentScheme,
                        children: [
                            {
                                path: 'define-assessment-scheme',
                                name: 'define-assessment-scheme',
                                component: DefineAssessmentScheme
                            },
                            {
                                path: 'offer-assessment-scheme',
                                name: 'offer-assessment-scheme',
                                component: OfferAssessmentScheme
                            },
                            {
                                path: 'apply-assessment-scheme',
                                name: 'apply-assessment-scheme',
                                component: ApplyAssessmentScheme
                            },

                        ]
                    },
                    //parent GS
                    {
                        path: 'grading-scheme',
                        name: 'grading-scheme',
                        component: GradingScheme,
                        children: [
                            {
                                path: 'define-grading-scheme',
                                name: 'define-grading-scheme',
                                component: DefineGradingScheme
                            },
                            {
                                path: 'offer-grading-scheme',
                                name: 'offer-grading-scheme',
                                component: OfferGradingScheme
                            },
                            {
                                path: 'apply-grading-scheme',
                                name: 'apply-grading-scheme',
                                component: ApplyGradingScheme
                            },
                        ],
                    },
                    {
                        path: 'marks-entry',
                        name: 'marks-entry',
                        component: MarksEntry
                    },
                    {
                        path: 'comments-entry',
                        name: 'comments-entry',
                        component: ReportCardCommentsEntry
                    },
                    {
                        path: 'marks-entry-icse',
                        name: 'marks-entry-icse',
                        component: MarkEnteryICSE
                    },
                    {
                        path: 'learner-annual-marksheet-icse',
                        name: 'learner-annual-marksheet-icse',
                        component: LearnerMarksheetAnnual
                    },
                    {
                        path: 'learner-annual-parent-marksheet-icse',
                        name: 'learner-annual-parent-marksheet-icse',
                        component: LearnerMarksheetAnnualParent
                    },
                    {
                        path: 'marks-entry-icse-pre-prim',
                        name: 'marks-entry-icse-pre-prim',
                        component: MarkEntryICSEPrePrim
                    },
                    {
                        path: 'learner-marksheet-icse-pre-prim',
                        name: 'learner-marksheet-icse-pre-prim',
                        component: LearnerMarksheetPrePrimIcse
                    },
                    {
                        path: 'learner-marksheet-icse-pre-prim-parent',
                        name: 'learner-marksheet-icse-pre-prim-parent',
                        component: LearnerMarksheetPrePrimIcseParent
                    },
                    {
                        path: 'combine-subject',
                        name: 'combine-subject',
                        component: CombineSubject
                    },
                    {
                        path: 'combine-marks',
                        name: 'combine-marks',
                        component: ComibineMarks
                    },
                    {
                        path: 'combine-marks-sbpps',
                        name: 'combine-marks-sbpps',
                        component: CombineMarksSbpps
                    },
                    {
                        path: 'combine-marks-sbpps-v2',
                        name: 'combine-marks-sbpps-v2',
                        component: CombineMarksV2Sbpps
                    },
                    {
                        path: 'primary-report-card-subject-type',
                        name: 'primary-report-card-subject-type',
                        component: PrimaryReportCardCourseType
                    },
                    {
                        path: 'import-easy-check-marks-entry',
                        name: 'import-easy-check-marks-entry',
                        component: importEasyCheckMarksEntry
                    }, //
                    {
                        path: 'import-marks-entry',
                        name: 'import-marks-entry',
                        component: ImportMarks
                    }, //
                    {
                        path: 'update-rubrics-marks-entry',
                        name: 'update-rubrics-marks-entry',
                        component: UpdateRubricsMarksEntry
                    }, //
                    {
                        path: 'result-anaysis',
                        name: 'result-anaysis',
                        component: ResultAnalysis
                    }, //
                    {
                        path: 'sync-grade-passing-marks',
                        name: 'sync-grade-passing-marks',
                        component: SyncGradePassingMarks
                    }, //
                    {
                        path: 'subject-result-anaysis',
                        name: 'subject-result-anaysis',
                        component: SubjectResultAnalysis
                    }, //
                    {
                        path: 'assessment-type-subject-avg-calc',
                        name: 'assessment-type-subject-avg-calc',
                        component: AssessmentTypeSubjectAvgCalc
                    }, //
                    {
                        path: 'scheme-applied-status',
                        name: 'scheme-applied-status',
                        component: SchemeAppliedStatus
                    },
                    {
                        path: 'marks-entry-staus',
                        name: 'marks-entry-staus',
                        component: MarksEntryStatus
                    },
                    {
                        path: 'elective-subject-report',
                        name: 'elective-subject-report',
                        component: ElectiveSubjectReport
                    },
                    {
                        path: 'student-registration-info',
                        name: 'student-registration-info',
                        component: StudentRegistrationInfo
                    },
                    {
                        path: 'easy-check-redirection',
                        name: 'easy-check-redirection',
                        component: EasyCheckRedirection
                    },
                    //academics
                    {
                        path: 'ay-details',
                        name: 'ay-details',
                        component: AddAyDetails
                    },
                    {
                        path: 'student-attendance',
                        name: 'student-attendance',
                        component: Studentattendance
                    },
                    {
                        path: 'data-verification',
                        name: 'data-verification',
                        component: DataVerification
                    },
                    {
                        path: 'delete-student',
                        name: 'delete-student',
                        component: DeleteStudent
                    },
                    {
                        path: 'learner-history',
                        name: 'learner-history',
                        component: LearnerHistory
                    },
                    {
                        path: 'import-learner-attendance',
                        name: 'import-learner-attendance',
                        component: ImportLearnerAttendance
                    },
                    {
                        path: 'delete-employee',
                        name: 'delete-employee',
                        component: DeleteEmployee
                    },
                    {
                        path: 'student-attendance-ap',
                        name: 'student-attendance-ap',
                        component: StudentattendanceAP
                    },
                    {
                        path: 'attendance-report',
                        name: 'attendance-report',
                        component: AttendanceReport
                    },
                    {
                        path: 'semester-date-config',
                        name: 'semester-date-config',
                        component: SemesterDateConfig
                    },
                    {
                        path: 'assessment-type-config',
                        name: 'assessment-type-config',
                        component: AssessmentTypeConfig
                    },
                    {
                        path: 'mark-attendance',
                        name: 'mark-attendance',
                        component: Markattendance
                    },
                    {
                        path: 'academic-daily-log-book',
                        name: 'academic-daily-log-book',
                        component: AcademicDailyLogBook
                    },
                    {
                        path: 'view-studentattendance',
                        name: 'view-studentattendance',
                        component: Viewstudentattendance
                    },
                    {
                        path: 'export-attendance',
                        name: 'export-attendance',
                        component: Exportattendance
                    },
                    {
                        path: 'edit-attendance',
                        name: 'edit-attendance',
                        component: Editattendance
                    },
                    {
                        path: 'edit-attendancedetails',
                        name: 'edit-attendancedetails',
                        component: Editattendancedetails
                    },
                    {
                        path: 'course-plan-execution-tracking',
                        name: 'course-plan-execution-tracking',
                        component: CoursePlanExecutionTracker
                    },
                    {
                        path: 'course-plan-execution-tracker-sanjivani',
                        name: 'course-plan-execution-tracker-sanjivani',
                        component: CoursePlanExecutionSanjivani
                    },
                    {
                        path: 'edit-single-student-attendance',
                        name: 'edit-single-student-attendance',
                        component: EditSingleStudentAttendance
                    },
                    //academics parent
                    {
                        path: 'student-leave-report',
                        name: 'student-leave-report',
                        component: StudentLeaveReport
                    },
                    {
                        path: 'child-attendance',
                        name: 'child-attendance',
                        component: ChildAttendance
                    },
                    {
                        path: 'view-child-attendance',
                        name: 'view-child-attendance',
                        component: ViewChildAttendance
                    },
                    {
                        path: 'view-parent-side-log-book',
                        name: 'view-parent-side-log-book',
                        component: ParentSideLogBook
                    },
                    {
                        path: 'request-a-leave',
                        name: 'request-a-leave',
                        component: RequestLeave
                    },
                    {
                        path: 'generate-prn-from-no',
                        name: 'generate-prn-from-no',
                        component: Generate_PRN_From_No
                    },
                    {
                        path: 'student-leave',
                        name: 'student-leave',
                        component: StudentLeave
                    },
                    {
                        path: 'attendance-summary-report',
                        name: 'attendance-summary-report',
                        component: AttendanceSummaryReport
                    },
                    {
                        path: 'monthly-attendance-report',
                        name: 'monthly-attendance-report',
                        component: MonthlyAttendanceReport
                    },
                    {
                        path: 'wws-monthly-attendance-report',
                        name: 'wws-monthly-attendance-report',
                        component: WWSAttendanceReport
                    },
                    {
                        path: 'vvp-monthly-attendance-report',
                        name: 'vvp-monthly-attendance-report',
                        component: VVPAttendanceReport
                    },
                    {
                        path: 'semesterwise-attendance-report',
                        name: 'semesterwise-attendance-report',
                        component: SemesterWiseAttendanceReport
                    },
                    {
                        path: 'admin-academic-planner',
                        name: 'admin-academic-planner',
                        component: AcademicPlannerStudent
                    },
                    {
                        path: 'instructor-academic-planner',
                        name: 'instructor-academic-planner',
                        component: AcademicPlannerInstructor
                    },
                    // instructor Calendar 
                    {
                        path: 'instructor-planner',
                        name: 'instructor-planner',
                        component: InstructorCalendar
                    },
                    {
                        path: 'child-academic-plan',
                        name: 'child-academic-plan',
                        component: ChildAcademicPlan
                    },
                    {
                        path: 'get-child-event',
                        name: 'get-child-event',
                        component: getChildEvent
                    },
                    {
                        path: 'student-academic-plan',
                        name: 'student-academic-plan',
                        component: StudentAcademicPlan
                    },
                    {
                        path: 'bonafide-request',
                        name: 'bonafide-request',
                        component: BonafideRequest
                    },
                    //Tenant Dashboard
                    {
                        path: 'student-details',
                        name: 'student-details',
                        component: StudentDetails
                    },
                    //Student
                    {
                        path: 'student-time-table',
                        name: 'student-time-table',
                        component: StudentTimeTable
                    },
                    {
                        path: 'student-calender',
                        name: 'student-calender',
                        component: ViewLearnerCalender
                    },
                    {
                        path: 'student-album',
                        name: 'student-album',
                        component: ViewLearnerAlbum
                    },
                    {
                        path: 'student-notice',
                        name: 'student-notice',
                        component: ViewLearnerNotice
                    },
                    {
                        path: 'student-join',
                        name: 'student-join',
                        component: StudentJoin
                    },
                    //Fees Account SBP Start
                    //Masters
                    {
                        path: 'fees-account-master',
                        name: 'fees-account-master',
                        component: FeesAccountMaster
                    },
                    {
                        path: 'payent-gateway-type-master',
                        name: 'payent-gateway-type-master',
                        component: PaymentGatewayType
                    },
                    {
                        path: 'payent-type-master',
                        name: 'payent-type-master',
                        component: PaymentType
                    },
                    {
                        path: 'fees-component-category',
                        name: 'fees-component-category',
                        component: FeesComponentCategory
                    },
                    {
                        path: 'fees-accounting-component',
                        name: 'fees-accounting-component',
                        component: FeesComponentAcademicYear
                    },

                    {
                        path: 'payment-transaction-status-master',
                        name: 'payment-transaction-status-master',
                        component: PaymentTransactionStatusmaster
                    },
                    {
                        path: 'order-id-master',
                        name: 'order-id-master',
                        component: OrderIdMaster
                    },
                    {
                        path: 'payment-gateway-details',
                        name: 'payment-gateway-details',
                        component: PaymentGatewayDetails
                    },
                    {
                        path: 'fees-accounting-installment',
                        name: 'fees-accounting-installment',
                        component: FeesInstallmentAcademicYear
                    },
                    {
                        path: 'fees-accounting-payment-mode',
                        name: 'fees-accounting-payment-mode',
                        component: PaymentModeMaster_1
                    },
                    {
                        path: 'fees-accounting-bank',
                        name: 'fees-accounting-bank',
                        component: BankMaster_1
                    },
                    {
                        path: 'discount-type-master',
                        name: 'discount-type-master',
                        component: DiscountTypeMaster
                    },
                    {
                        path: 'misc-other-exam-fees',
                        name: 'misc-other-exam-fees',
                        component: MiscAndOtherFeesMaster
                    },
                    {
                        path: 'fees-installment-matrix',
                        name: 'fees-installment-matrix',
                        component: FeesInstallmentFeesComponentMatrix
                    },
                    {
                        path: 'payment-recheck-matrix',
                        name: 'payment-recheck-matrix',
                        component: PaytmRecheckStatus
                    },
                    {
                        path: 'standard-payment-gateway-mapping',
                        name: 'standard-payment-gateway-mapping',
                        component: StandardPaymentGatewayMapping
                    },
                    {
                        path: 'brunch-config-amount',
                        name: 'brunch-config-amount',
                        component: ConfigureBrunchAmount
                    },
                    {
                        path: 'fees-structure-installment',
                        name: 'fees-structure-installment',
                        component: FeesStructureInstallment
                    },
                    {
                        path: 'office-fees-payment',
                        name: 'office-fees-payment',
                        component: OfficeStaffPayment
                    },
                    {
                        path: 'online-fees-payment-admin',
                        name: 'online-fees-payment-admin',
                        component: OnlineFeesPaymentAdmin
                    },
                    {
                        path: 'copy-fees-structure',
                        name: 'copy-fees-structure',
                        component: CopyFeesStructure
                    },
                    {
                        path: 'learner-quota-history',
                        name: 'learner-quota-history',
                        component: LearnerQuotaHistory
                    },
                    {
                        path: 'assign-learner-quota',
                        name: 'assign-learner-quota',
                        component: AssignLeanerQuota
                    },
                    {
                        path: 'applicationform-fees-payment',
                        name: 'applicationform-fees-payment',
                        component: ApplicationFormFeesPayment
                    },
                    {
                        path: 'inst-fees-payment',
                        name: 'inst-fees-payment',
                        component: InstallmentFeesPaymentSbpps
                    },
                    {
                        path: 'sync-current-standard',
                        name: 'sync-current-standard',
                        component: SyncCurrentStandard
                    },
                    {
                        path: 'zeal-student-receipt',
                        name: 'zeal-student-receipt',
                        component: ZealStudentReceipts
                    },
                    {
                        path: 'generate-challan',
                        name: 'generate-challan',
                        component: GenrateChallan
                    },
                    {
                        path: 'learner-fees-invoice',
                        name: 'learner-fees-invoice',
                        component: LearnerFeesInvoice
                    },

                    {
                        path: 'student-generate-challan',
                        name: 'student-generate-challan',
                        component: StudentGenerateChallan
                    },
                    {
                        path: 'installment-fee-structure-details',
                        name: 'installment-fee-structure-details',
                        component: InstallmentStructureDetails
                    },
                    {
                        path: 'payment-transaction-daily-report',
                        name: 'payment-transaction-daily-report',
                        component: PaymentTransactionDailyReport
                    },
                    {
                        path: 'manage-activity',
                        name: 'manage-activity',
                        component: ManageActivity
                    },
                    {
                        path: 'office-assign-robotics-payment',
                        name: 'office-assign-robotics-payment',
                        component: RoboticsFee
                    },
                    {
                        path: 'config-misc-other-exam-fees',
                        name: 'config-misc-other-exam-fees',
                        component: ConfigMiscAndOtherFees
                    },
                    {
                        path: 'office-misc-other-exam-fees-collection',
                        name: 'office-misc-other-exam-fees-collection',
                        component: MiscAndOtherFeesPaymentOffline
                    },
                    {
                        path: 'standard-learner-fees',
                        name: 'standard-learner-fees',
                        component: StandardLearnerFees
                    },
                    {
                        path: 'generate-refund-receipt',
                        name: 'generate-refund-receipt',
                        component: GenerateRefundReceipt
                    },
                    {
                        path: 'get-studentwise-fees-structure',
                        name: 'get-studentwise-fees-structure',
                        component: GetStudentFeesStructure
                    },
                    {

                        path: 'import-learner-selection',
                        name: 'import-learner-selection',
                        component: ImportLearnerSelection
                    },
                    {
                        path: 'import-student-fees-structure',
                        name: 'import-student-fees-structure',
                        component: ImportStudentFeesStructure
                    },
                    {

                        path: 'import-learner-comp-selection-amount',
                        name: 'import-learner-comp-selection-amount',
                        component: ImportLeanerCompSelectionAmount
                    },
                    {

                        path: 'sync-learner-component-selection-amount',
                        name: 'sync-learner-component-selection-amount',
                        component: SyncLearnerComponentSelction
                    },
                    {
                        path: 'import-learner-receipt-compomnent',
                        name: 'import-learner-receipt-compomnent',
                        component: UpdateReceiptComponent
                    },
                    {
                        path: 'payment-transaction-history-report',
                        name: 'payment-transaction-history-report',
                        component: PaymentTransactionHistoryReport
                    },
                    //Reports
                    {
                        path: 'tax-fees-receipts',
                        name: 'tax-fees-receipts',
                        component: TaxFeesReceipts
                    },
                    {
                        path: 'tax-fees-receipt-print',
                        name: 'tax-fees-receipt-print',
                        component: TaxFeesReceiptsPrint
                    },
                    {
                        path: 'student-fees-receipts',
                        name: 'student-fees-receipts',
                        component: StudentFeeReceipts
                    },
                    {
                        path: 'student-fees-receipts-wws',
                        name: 'student-fees-receipts-wws',
                        component: StudentFeesReceiptWws
                    },
                    {
                        path: 'student-fees-receipts-uwws',
                        name: 'student-fees-receipts-uwws',
                        component: StudentFeesReceiptUWWS
                    },
                    {
                        path: 'student-fees-receipts-sanjivani',
                        name: 'student-fees-receipts-sanjivani',
                        component: StudentFeesReceiptSanjivani
                    },
                    {
                        path: 'student-fees-receipts-vvp',
                        name: 'student-fees-receipts-vvp',
                        component: StudentFeesReceiptVvp
                    },
                     {
                        path: 'student-fees-receipts-des',
                        name: 'student-fees-receipts-des',
                        component: StudentFeesReceiptDes
                    },
                    {
                        path: 'student-elective-fees-receipts-des',
                        name: 'student-elective-fees-receipts-des',
                        component: StudentElectiveFeesReceiptDES,
                    },
                    {
                        path: 'all-fees-receipts-vvp',
                        name: 'all-fees-receipts-vvp',
                        component: AllReceiptVVP
                    },
                    {
                        path: 'fee-reconciliation-report',
                        name: 'fee-reconciliation-report',
                        component: FeeReconciliationReport
                    },
                    {
                        path: 'fee-details-report',
                        name: 'fee-details-report',
                        component: FeeDetailsReport
                    },
                    {
                        path: 'fee-details-report-sbpps',
                        name: 'fee-details-report-sbpps',
                        component: FeeDetailsReportsbpps
                    },
                    {
                        path: 'fee-details-report-zeal',
                        name: 'fee-details-report-zeal',
                        component: FeeDetailsReportZeal
                    },
                    {
                        path: 'fine-details-report',
                        name: 'fine-details-report',
                        component: FineDetailedReport
                    },
                    {
                        path: 'challan-report',
                        name: 'challan-report',
                        component: ChallanReport
                    },
                    {
                        path: 'excess-amount-report',
                        name: 'excess-amount-report',
                        component: ExcessAmountReport
                    },
                    {
                        path: 'installment-outsanding-report',
                        name: 'installment-outsanding-report',
                        component: InstallmentOutstandingReport
                    },
                    {
                        path: 'fees-overall-percentage-report',
                        name: 'fees-overall-percentage-report',
                        component: FeesOverallPercentageReport
                    },
                    {
                        path: 'receipt-details-report',
                        name: 'receipt-details-report',
                        component: ReceiptDetailsReport
                    },
                    {
                        path: 'daily-ay-transaction-report',
                        name: 'daily-ay-transaction-report',
                        component: DailyAyTransactionReport
                    },
                    {
                        path: 'refund-receipt-report',
                        name: 'refund-receipt-report',
                        component: RefundReceiptReport
                    },
                    {
                        path: 'add-admission-fee-to-std',
                        name: 'add-admission-fee-to-std',
                        component: AddAdmissionFeeToStd
                    },
                    {
                        path: 'add-admission-fee-to-stud',
                        name: 'add-admission-fee-to-stud',
                        component: AddAdmissionFeeToStud
                    },
                    {
                        path: 'student-admission-receipt',
                        name: 'student-admission-receipt',
                        component: StudentAdmissionReceipt
                    },
                    { //online fees payment using billdesk
                        path: 'installment-fees-payment',
                        name: 'installment-fees-payment',
                        component: OnlineFeesPaymentBillDesk
                    },
                    {
                        path: 'learner-invoice-online-payment',
                        name: 'learner-invoice-online-payment',
                        component: LearnerInvoiceOnlineFeesPayment
                    },
                    //Office Staff
                    {
                        path: 'add-brunch-to-child',
                        name: 'add-brunch-to-child',
                        component: GetAYFeesDetails
                    },
                    {
                        path: 'add-outstanding-fees-to-child',
                        name: 'add-outstanding-fees-to-child',
                        component: OutstandingFees
                    },
                    //miscFees Report
                    {
                        path: 'misc-other-exam-fees-payment-report',
                        name: 'misc-other-exam-fees-payment-report',
                        component: MiscAndOtherFeesPaymentReport
                    },
                    {
                        path: 'misc-other-exam-fees-payment-receipt',
                        name: 'misc-other-exam-fees-payment-receipt',
                        component: MiscFeeReceipt
                    },
                    {
                        path: 'other-fees',
                        name: 'other-fees',
                        component: OtherFees
                    },
                    {
                        path: 'other-fees-receipt',
                        name: 'other-fees-receipt',
                        component: OtherFeesReceipt
                    },
                    {
                        path: 'misc-fee-category',
                        name: 'misc-fee-category',
                        component: MiscFeeCategory
                    },
                    //oustanding fees
                    {
                        path: 'offline-outstanding-payment',
                        name: 'offline-outstanding-payment',
                        component: OfflineOutstandingPayment
                    },
                    {
                        path: 'online-outstanding-payment',
                        name: 'online-outstanding-payment',
                        component: OnlineOutstandingPayment
                    },
                    { //billdesk online payment parent side
                        path: 'student-online-outstanding-payment',
                        name: 'student-online-outstanding-payment',
                        component: OutstandingFeeBillDesk
                    },
                    {
                        path: 'student-outstanding-payment-receipt',
                        name: 'student-outstanding-payment-receipt',
                        component: StudentOutstandingPaymentReceipt
                    },
                    {
                        path: 'outstanding-fee-report',
                        name: 'outstanding-fee-report',
                        component: OuststandingFeeReport
                    },
                    {
                        path: 'standard-outstanding-fee-report',
                        name: 'standard-outstanding-fee-report',
                        component: StandardOutstandingReport
                    },
                    //Parent //misc-other-fees-payment-parent-billdesk -> path:-student-misc-other-fees-payment
                    {
                        path: 'student-misc-other-exam-fees-payment',
                        name: 'student-misc-other-exam-fees-payment',
                        component: MiscAndOtherFeesPaymentOnline
                    },
                    {
                        path: 'student-misc-other-fees-payment',
                        name: 'student-misc-other-fees-payment',
                        component: MiscOtherFeesPaymentBilldesk
                    },
                    {
                        path: 'online-fee-payment',
                        name: 'online-fee-payment',
                        component: OnlineFeesPayment
                    },
                    {
                        path: 'online-fee-payment-sanjivani',
                        name: 'online-fee-payment-sanjivani',
                        component: OnlineFeesPaymentSanjivani
                    },
                    {
                        path: 'online-fee-payment-multiple',
                        name: 'online-fee-payment-multiple',
                        component: onlinefee_new_multiple
                    },
                    {
                        path: 'parent-fee-history',
                        name: 'parent-fee-history',
                        component: ParentFeeHistory
                    },
                    {
                        path: 'get-child-receipt-details',
                        name: 'get-child-receipt-details',
                        component: ChildReceiptDetails
                    },
                    {
                        path: 'child-fees-receipts',
                        name: 'child-fees-receipts',
                        component: ChildFeesReceipts
                    },
                    {
                        path: 'child=misc-other-exam-fees-payment-receipt',
                        name: 'child=misc-other-exam-fees-payment-receipt',
                        component: ChildMiscFeeReceipts
                    },
                    {
                        path: 'child-outstanding-payment-receipt',
                        name: 'child-outstanding-payment-receipt',
                        component: ChildOutstandingFeeReceipts
                    },
                    {
                        path: 'parent-request-component',
                        name: 'parent-request-component',
                        component: ParentRequestComponent
                    },
                    {
                        path: 'copy-component-details',
                        name: 'copy-component-details',
                        component: CopyComponentDetails
                    },
                    {
                        path: 'transaction_details',
                        name: 'transaction_details',
                        component: TransactionDetails
                    },
                    {
                        path: 'add-receivable-amount',
                        name: 'add-receivable-amount',
                        component: AddReceivableAmount
                    },

                    //Employee Profile
                    {
                        path: 'employee-personal-info',
                        name: 'employee-personal-info',
                        component: EmployeePersonalinfo
                    },
                    {
                        path: 'employee-profile-pic',
                        name: 'employee-profile-pic',
                        component: EmployeeProfilePic
                    },
                    {
                        path: 'employee-qualification',
                        name: 'employee-qualification',
                        component: EmployeeQualification
                    },
                    //Quiz Module
                    {
                        path: 'quiz-scheduling',
                        name: 'quiz-scheduling',
                        component: QuizScheduling
                    },
                    {
                        path: 'quiz-live-dashboard',
                        name: 'quiz-live-dashboard',
                        component: QuizLiveDashboard
                    },
                    {
                        path: 'quiz-assessment-mapping',
                        name: 'quiz-assessment-mapping',
                        component: QuizAssessmentSchemeMapping
                    },
                    //Quiz Master
                    {
                        path: 'approve-unapprove-question-bank',
                        name: 'approve-unapprove-question-bank',
                        component: ApproveUnapproveQuestionBank
                    },
                    {
                        path: 'quiz-master',
                        name: 'quiz-master',
                        component: QuizMaster
                    },
                    {
                        path: 'quiz-type-master',
                        name: 'quiz-type-master',
                        component: QuizTypeMaster
                    },
                    {
                        path: 'difficulty-level-master',
                        name: 'difficulty-level-master',
                        component: DifficultyLevelMaster
                    },
                    {
                        path: 'chapter-master',
                        name: 'chapter-master',
                        component: ChapterMaster
                    },
                    {
                        path: 'topic-master',
                        name: 'topic-master',
                        component: TopicMaster
                    },
                    //Apprisal Start
                    //Apprisal Master Start
                    {
                        path: 'apprisal-master',
                        name: 'apprisal-master',
                        component: ApprisalMasterMenu
                    },
                    {
                        path: 'faculty-post-master',
                        name: 'faculty-post-master',
                        component: FacultyPostMaster
                    },
                    {
                        path: 'apprisal-authority-type-master',
                        name: 'apprisal-authority-type-master',
                        component: AppriasalAuthorityTypeMaster
                    },
                    {
                        path: 'authority-type-post-linking-master',
                        name: 'authority-type-post-linking-master',
                        component: AuthorityTypePostLinkingMaster
                    },
                    {
                        path: 'apprisal-parameter-master',
                        name: 'apprisal-parameter-master',
                        component: AppriasalParameterMaster
                    },
                    {
                        path: 'sub-parameter-apprisal-level-linking',
                        name: 'sub-parameter-apprisal-level-linking',
                        component: SubParameterApprisalLevelLinking
                    },
                    {
                        path: 'apprisal-sub-parameter-master',
                        name: 'apprisal-sub-parameter-master',
                        component: AppriasalSubParameterMaster
                    },
                    {
                        path: 'apprisal-level',
                        name: 'apprisal-level',
                        component: ApprisalLevel
                    },
                    //Apprisal Master End
                    {
                        path: 'faculty-post-linking',
                        name: 'faculty-post-linking',
                        component: FacultyPostLinking
                    },
                    {
                        path: 'fill-self-appriasal',
                        name: 'fill-self-appriasal',
                        component: FillSelfAppriasal
                    },
                    {
                        path: 'fill-self-appriasal-sbpps',
                        name: 'fill-self-appriasal-sbpps',
                        component: FillSelfAppraisalSbpps
                    },
                    {
                        path: 'review-self-appriasal',
                        name: 'review-self-appriasal',
                        component: ReviewSelfAppriasal
                    },

                    {
                        path: 'coordinator-self-appriasal-report',
                        name: 'coordinator-self-appriasal-report',
                        component: CoordinatorSelfAppriasalReport
                    },
                    {
                        path: 'principal-self-appriasal-report',
                        name: 'principal-self-appriasal-report',
                        component: PrincipalSelfAppraisalReport
                    },
                    {
                        path: 'teacher-apprisal-performance-measurement',
                        name: 'teacher-apprisal-performance-measurement',
                        component: TeacherApprisalPerformanceMeasurement
                    },
                    {
                        path: 'bulk-employee-appraisal-report',
                        name: 'bulk-employee-appraisal-report',
                        component: BulkInstructorAppraisalReport
                    },
                    {
                        path: 'faculty-appraisal-report',
                        name: 'faculty-appraisal-report',
                        component: TeachersAppraisalReport
                    },
                    {
                        path: 'self-appriasal-status',
                        name: 'self-appriasal-status',
                        component: SelfAppriasalStatus
                    },
                    {
                        path: 'review-appriasal',
                        name: 'review-appriasal',
                        component: ReviewAppriasal
                    },
                    {
                        path: 'employee-appraisal-report',
                        name: 'employee-appraisal-report',
                        component: EmployeeAppraisalReport
                    },
                    {
                        path: 'get-employee-appraisal-report',
                        name: 'get-employee-appraisal-report',
                        component: GetEmployeeAppraisalReport
                    },
                    {
                        path: 'self-employee-appraisal-report',
                        name: 'self-employee-appraisal-report',
                        component: SelfEmployeeAppraisalReport
                    },
                    {
                        path: 'faculty-authority-linking',
                        name: 'faculty-authority-linking',
                        component: FacultyAuthorityLinking
                    },

                    //Feedback start
                    {
                        path: 'feedback-report',
                        name: 'feedback-report',
                        component: FeedbackReport
                    },
                    {
                        path: 'feedback-masters',
                        name: 'feedback-masters',
                        component: FeedbackMasterMenu
                    },
                    {
                        path: 'feedback-type/feedback-masters',
                        name: 'feedback-type',
                        component: FeedbackTypeMaster
                    },
                    {
                        path: 'feedback-question-type/feedback-masters',
                        name: 'feedback-question-type',
                        component: FeedbackQuestionTypeMaster
                    },
                    {
                        path: 'feedback-version/feedback-masters',
                        name: 'feedback-version',
                        component: FeedbackVersionMaster
                    },
                    {
                        path: 'feedback-questionare',
                        name: 'feedback-questionare',
                        component: FeedbackQuestionare
                    },
                    {
                        path: 'copy-feedback-questionare',
                        name: 'copy-feedback-questionare',
                        component: CopyFeedbackQuestionare
                    },
                    {
                        path: 'feedback-attendance',
                        name: 'feedback-attendance',
                        component: FeedbackAttendance
                    },
                    {
                        path: 'give-student-feedback',
                        name: 'give-student-feedback',
                        component: GiveStudentFeedback
                    },
                    {
                        path: 'performance-index',
                        name: 'performance-index',
                        component: PerformanceIndex
                    },
                    {
                        path: 'give-subject-feedback',
                        name: 'give-subject-feedback',
                        component: GiveSubjectFeedback
                    },
                    {
                        path: 'subject-feedback',
                        name: 'subject-feedback',
                        component: SubjectFeedback
                    },

                    {
                        path: 'add-query',
                        name: 'add-query',
                        component: AddQuery
                    },
                    {
                        path: 'add-instructor-query',
                        name: 'add-instructor-query',
                        component: AddInstructorQuery
                    },
                    {
                        path: 'query-master',
                        name: 'query-master',
                        component: QueryMaster
                    },

                    //Leave Management
                    {
                        path: 'leave-master-cards',
                        name: 'leave-master-cards',
                        component: LeaveMasterCards
                    },
                    {
                        path: 'add-leave-type',
                        name: 'add-leave-type',
                        component: LeaveType
                    },
                    {
                        path: 'add-leave-approval-authority',
                        name: 'add-leave-approval-authority',
                        component: LeaveApprovalAuthority
                    },
                    {
                        path: 'add-leave-approval-hierarchy',
                        name: 'add-leave-approval-hierarchy',
                        component: LeaveApprovalHierarchy
                    },
                    {
                        path: 'add-leave-approval-status',
                        name: 'add-leave-approval-status',
                        component: LeaveApprovalStatus
                    },
                    {
                        path: 'add-leave-master',
                        name: 'add-leave-master',
                        component: LeaveMaster
                    },
                    {
                        path: 'allot-leaves',
                        name: 'allot-leaves',
                        component: AllotLeaves
                    },
                    {
                        path: 'appoint-authority',
                        name: 'appoint-authority',
                        component: AppointAuthority
                    },
                    {
                        path: 'reporting-authority',
                        name: 'reporting-authority',
                        component: ReportingAuthority
                    },
                    {
                        path: 'set-instructor-leave-coordinator',
                        name: 'set-instructor-leave-coordinator',
                        component: SetInstructorLeaveCoordinator
                    },
                    {
                        path: 'leave-transaction-report',
                        name: 'leave-transaction-report',
                        component: LeaveTransactionReport
                    },
                    {
                        path: 'leave-academic-year',
                        name: 'leave-academic-year',
                        component: LeaveAcademicYear
                    },
                    {
                        path: 'leave-balance-report',
                        name: 'leave-balance-report',
                        component: LeaveReports
                    },
                    {
                        path: 'query-report-one',
                        name: 'query-report-one',
                        component: QueryReportLevelOne
                    },
                    {
                        path: 'query-report-two',
                        name: 'query-report-two',
                        component: QueryReportLevelTwo
                    },
                    {
                        path: 'query-report-three',
                        name: 'query-report-three',
                        component: QueryReportLevelThree
                    },
                    {
                        path: 'coordinator-leave-approval',  //coordinator
                        name: 'coordinator-leave-approval',
                        component: CoordinatorLeaveApprove
                    },
                    {
                        path: 'modify-leave-approval',  //Principal
                        name: 'modify-leave-approval',
                        component: ModifyLeaveApproval
                    },
                    {
                        path: 'apply-leave', //Instructor
                        name: 'apply-leave',
                        component: ApplyLeave
                    },
                    {
                        path: 'cancel-leave', //Instructor
                        name: 'cancel-leave',
                        component: CancelSelfLeave
                    },
                    {
                        path: 'mark-leave-approval-matrix',
                        name: 'mark-leave-approval-matrix',
                        component: MarksLeaveApprovalMatrix
                    },

                    {
                        path: 'instructor-icard',
                        name: 'instructor-icard',
                        component: InstructorIcard
                    },
                    {
                        path: 'student-icard',
                        name: 'student-icard',
                        component: StudentIcard
                    },
                    {
                        path: 'icard-master',
                        name: 'icard-master',
                        component: IcardMaster
                    },
                    {
                        path: 'block-icard',
                        name: 'block-icard',
                        component: BlockLearnerIcard
                    },
                    {
                        path: 'genrateIdcard',
                        name: 'genrateIdcard',
                        component: genrateIdcard
                    },
                    {
                        path: 'printidcard',
                        name: 'printidcard',
                        component: printidcard,
                    },
                    {
                        path: 'publish-webinar',
                        name: 'publish-webinar',
                        component: AddWebinarTeacher
                    },
                    {
                        path: 'publish-course-webinar',
                        name: 'publish-course-webinar',
                        component: PublishWebinar
                    },
                    {
                        path: 'learner-course-webinar',
                        name: 'learner-course-webinar',
                        component: LearnerWebinar
                    },
                    {
                        path: 'emp-payroll-info',
                        name: 'emp-payroll-info',
                        component: EmployeePayrollInfo
                    },
                    {
                        path: 'emp-monthly-attendance',
                        name: 'emp-monthly-attendance',
                        component: EmployeeMonthlyAttendance
                    },
                    {
                        path: 'emp-salary-master',
                        name: 'emp-salary-master',
                        component: IndividualEmployeeSalaryMaster
                    },
                    {
                        path: 'import-emp-payroll-info',
                        name: 'import-emp-payroll-info',
                        component: ImportEmployeePayRollInfo
                    },
                    {
                        path: 'increment-year',
                        name: 'increment-year',
                        component: IncrementYear
                    },
                    {
                        path: 'employee-payment-section',
                        name: 'employee-payment-section',
                        component: EmployeePaymentSection
                    },
                    {
                        path: 'map-salaryrule-to-component',
                        name: 'map-salaryrule-to-component',
                        component: MapSalaryRuleToComponent
                    },
                    {
                        path: 'salary-sub-component-master',
                        name: 'salary-sub-component-master',
                        component: SalarySubComponentMaster
                    },
                    {
                        path: 'month',
                        name: 'month',
                        component: Month
                    },
                    {
                        path: 'partial-salary-summary',
                        name: 'partial-salary-summary',
                        component: PartialSalarySummary
                    },
                    {
                        path: 'pay-band',
                        name: 'pay-band',
                        component: PayBand
                    },
                    {
                        path: 'pay-commision',
                        name: 'pay-commision',
                        component: PayCommision
                    },
                    {
                        path: 'pay-matrix',
                        name: 'pay-matrix',
                        component: PayMatrix
                    },
                    {
                        path: 'pay-roll-master',
                        name: 'pay-roll-master',
                        component: PayrollMaster
                    },
                    {
                        path: 'salary-certificate-reason',
                        name: 'salary-certificate-reason',
                        component: SalaryCertificateReason
                    },
                    {
                        path: 'salary-certificate-status',
                        name: 'salary-certificate-status',
                        component: Salarycertificatestatus
                    },
                    {
                        path: 'salary-component',
                        name: 'salary-component',
                        component: SalaryComponent
                    },
                    {
                        path: 'salary-sub-component',
                        name: 'salary-sub-component',
                        component: SalarySubComponent
                    },
                    {
                        path: 'salary-component-type',
                        name: 'salary-component-type',
                        component: SalaryComponentType
                    },
                    {
                        path: 'salary-month',
                        name: 'salary-month',
                        component: SalaryMonth
                    },
                    {
                        path: 'salary-rule-master',
                        name: 'salary-rule-master',
                        component: SalaryRuleMaster
                    },
                    {
                        path: 'pay-roll-bank',
                        name: 'pay-roll-bank',
                        component: PayrollBank
                    },
                    {
                        path: 'salary-rule-master-offering',
                        name: 'salary-rule-master-offering',
                        component: SalaryRuleMasterOffering
                    },
                    {
                        path: 'year',
                        name: 'year',
                        component: Year
                    },
                    {
                        path: 'monthlysalarycalculation',
                        name: 'monthlysalarycalculation',
                        component: MonthlySalaryCalculation
                    },
                    {
                        path: 'employeesalaryregister',
                        name: 'employeesalaryregister',
                        component: EmployeeSalaryRegister
                    },
                    {
                        path: 'all-emp-salary-master',
                        name: 'all-emp-salary-master',
                        component: AllEmployeeSalaryMaster
                    },
                    {
                        path: 'partial-salary-calculation',
                        name: 'partial-salary-calculation',
                        component: PartialSalaryCalculation
                    },
                    {
                        path: 'emp-salary-certificate-application',
                        name: 'emp-salary-certificate-application',
                        component: EmployeeSalaryCertificateApplication
                    },
                    {
                        path: 'freez-unfreez-emp-salary-register',
                        name: 'freez-unfreez-emp-salary-register',
                        component: FreezUnfreezSalaryRegister
                    },
                    {
                        path: 'pay-sheet-summary-report',
                        name: 'pay-sheet-summary-report',
                        component: PaySheetSummaryReport
                    },
                    {
                        path: 'monthly-pay-sheet-summary-report',
                        name: 'monthly-pay-sheet-summary-report',
                        component: MonthlyPaySheetSummaryReport
                    },
                    {
                        path: 'monthly-pay-sheet-summary-report-2',
                        name: 'monthly-pay-sheet-summary-report-2',
                        component: MonthlyPaySheetSummaryReport_2
                    },
                    {
                        path: 'zeal-monthly-pay-sheet-summary-report-2',
                        name: 'zeal-monthly-pay-sheet-summary-report-2',
                        component: ZealMonthlyPaySheetSummaryReport_2
                    },
                    {
                        path: 'category-report',
                        name: 'category-report',
                        component: CategoryReport
                    },
                    {
                        path: 'pay-roll-report',
                        name: 'pay-roll-report',
                        component: PayRollReport
                    },
                    {
                        path: 'bank-advice-report',
                        name: 'bank-advice-report',
                        component: BankAdvice
                    },
                    {
                        path: 'elective-merit-list-generation',
                        name: 'elective-merit-list-generation',
                        component: ElectiveMeritListGeneartion
                    },
                    {
                        path: 'admission-confirmed-student-report',
                        name: 'admission-confirmed-student-report',
                        component: AdmissionConfirmedStudentReport
                    },
                    {
                        path: 'elective-choice-report',
                        name: 'elective-choice-report',
                        component: ElectiveChoiceReport
                    },
                    {
                        path: 'elective-allocation-report',
                        name: 'elective-allocation-report',
                        component: ElectiveAllocationReport
                    },
                    {
                        path: 'subject-group-report',
                        name: 'subject-group-report',
                        component: SubjectGroupReport
                    },
                    {
                        path: 'subject-wise-student-report',
                        name: 'subject-wise-student-report',
                        component: SubjectWiseStudentReport
                    },
                    {
                        path: 'admitted-student-profile-report',
                        name: 'admitted-student-profile-report',
                        component: AdmittedStudentProfileReport
                    },
                    {
                        path: 'application-form-report',
                        name: 'application-form-report',
                        component: ApplicationFormReport
                    },
                    {
                        path: 'preference-form',
                        name: 'preference-form',
                        component: PreferenceForm
                    },
                    {
                        path: 'activity-category',
                        name: 'activity-category',
                        component: ActivityCategory
                    },
                     {
                        path: 'affiliation-type',
                        name: 'affiliation-type',
                        component:AffiliationType
                    },
                    {
                        path: 'activity-certificate-type',
                        name: 'activity-certificate-type',
                        component:ActivityCertificateType
                    },
                     {
                        path: 'activity-fees-component',
                        name: 'activity-fees-component',
                        component:ActivityFeesComponent
                    },
                    {
                        path: 'activity-receipt',
                        name: 'activity-receipt',
                        component:ActivityReceipt
                    },
                    {
                        path: 'activity-list',
                        name: 'activity-list',
                        component:ActivityList
                    },
                   
                    
                    {
                        path: 'activity-master',
                        name: 'activity-master',
                        component:ActivityMaster
                    },
                       {
                        path: 'activity-summary',
                        name: 'activity-summary',
                        component:ActivitySummary
                    },
                    {
                        path: 'training-hour-report',
                        name: 'training-hour-report',
                        component:TrainingHourReport
                    },

                     {
                        path: 'certificate-template',
                        name: 'certificate-template',
                        component:CertificateTemplate
                    },

                    {
                        path: 'activity-certificate-rule',
                        name: 'activity-certificate-rule',
                        component:ActivityCertificateRule
                    },

                     {
                        path: 'resource-person',
                        name: 'resource-person',
                        component:ResourcePerson
                    },
                    {
                        path: 'exam-conduct-type',
                        name: 'exam-conduct-type',
                        component:ConductType
                    },
                    {
                        path: 'exam-bench-side',
                        name: 'exam-bench-side',
                        component:ExamBenchSide
                    },
                    {
                        path: 'door-display-report',
                        name: 'door-display-report',
                        component:DoorDisplayReport
                    },
                    {
                        path: 'supervisor-report',
                        name: 'supervisor-report',
                        component:SupervisorReport
                    },
                    {
                        path: 'student-attendance-report',
                        name: 'student-attendance-report',
                        component:StudentAttendanceReport
                    },
                    {
                        path: 'room-utilization-report',
                        name: 'room-utilization-report',
                        component:RoomUtilizationReport
                    },
                    {
                        path: 'seating-arrangement-report',
                        name: 'seating-arrangement-report',
                        component:SeatingArrangementReport
                    },
                    {
                        path: 'student-seating-report',
                        name: 'student-seating-report',
                        component:StudentSeatingReport
                    },
                    {
                        path: 'exam-plan-details',
                        name: 'exam-plan-details',
                        component:ExamPlanDetails
                    },
                    {
                        path: 'room-allotment-report',
                        name: 'room-allotment-report',
                        component:RoomAllotmentReport
                    },
                    {
                        path: 'all-student-attendance-report',
                        name: 'all-student-attendance-report',
                        component:AllStudentAttendanceReport
                    },
                    {
                        path: 'link-subjects',
                        name: 'link-subjects',
                        component:LinkSubjects
                    },
                    {
                        path: 'link-room',
                        name: 'link-room',
                        component:LinkRoom
                    },
                    {
                        path: 'mark-student-exam-attendance',
                        name: 'mark-student-exam-attendance',
                        component:StudentExamAttendance
                    },
                    // {
                    //     path: 'link-supervisor',
                    //     name: 'link-supervisor',
                    //     component:LinkSupervisor
                    // },
                    // {
                    //     path: 'mark-student-attendance',
                    //     name: 'mark-student-attendance',
                    //     component:MarkStudentAttendance
                    // },
                    {
                        path: 'participant-type',
                        name: 'participant-type',
                        component:ParticipantType
                    },
                    {
                        path: '/student-profile-details',
                        name: 'student-profile-details',
                        component: StudentProfileDetails
                    },
                    {
                        path: 'monthly-salary-statement',
                        name: 'monthly-salary-statement',
                        component: MonthlySalaryStatement
                    },
                    {
                        path: 'pay-slip',
                        name: 'pay-slip',
                        component: PaySlip
                    },
                    {
                        path: 'employee-salary-summary-report',
                        name: 'employee-salary-summary-report',
                        component: EmployeeSalarySummaryReport
                    },
                    {
                        path: 'individual-report',
                        name: 'individual-report',
                        component: IndividualReport
                    },
                    {
                        path: 'course-marks-absent-status',
                        name: 'course-marks-absent-status',
                        component: CourseMarksAbsentStatus
                    },
                    {
                        path: 'individual-report-ass-type',
                        name: 'individual-report-ass-type',
                        component: IndividualReportAssType
                    },

                    {
                        path: 'child-report-card',
                        name: 'child-report-card',
                        component: ChildReportCard
                    },
                    {
                        path: 'learner-marksheet-zeal',
                        name: 'learner-marksheet-zeal',
                        component: LearnerMarksheetZeal
                    },
                    {
                        path: 'terminal-marklist-report-zeal',
                        name: 'terminal-marklist-report-zeal',
                        component: TerminalMarklistReport
                    },
                    {
                        path: 'terminal-marklist-report-ass-type-zeal',
                        name: 'terminal-marklist-reportass-type-zeal',
                        component: TerminalMarkslistReportAssType
                    },
                    {
                        path: 'learner-homework',
                        name: 'learner-homework',
                        component: learnerHomework
                    },
                    {
                        path: 'learner-worksheet',
                        name: 'learner-worksheet',
                        component: learnerWorksheet
                    },
                    {
                        path: 'teacher-add-homework',
                        name: 'teacher-add-homework',
                        component: TeacherAddHomeWork
                    },
                    {
                        path: 'course-attendance',
                        name: 'course-attendance',
                        component: CourseAttendance
                    },
                    {
                        path: 'mark-course-attendance',
                        name: 'mark-course-attendance',
                        component: MarkCourseAttendance
                    },
                    {
                        path: 'edit-course-attendance',
                        name: 'edit-course-attendance',
                        component: EditCourseAttendance
                    },
                    {
                        path: 'edit-course-attendancedetails',
                        name: 'edit-course-attendancedetails',
                        component: EditCourseAttendanceDetails
                    },
                    {
                        path: 'teacher-evaluate-homework',
                        name: 'teacher-evaluate-homework',
                        component: TeacherEvaluateHomeWork
                    },
                    {
                        path: 'teacher-check-homework',
                        name: 'teacher-check-homework',
                        component: TeacherCheckHomeWork
                    },
                    {
                        path: 'parent-side-homework',
                        name: 'parent-side-homework',
                        component: ParentSideHomeWork
                    },
                    {
                        path: 'parent-side-worksheet',
                        name: 'parent-side-worksheet',
                        component: ParentSideWorksheet
                    },
                    {
                        path: 'homework-report',
                        name: 'homework-report',
                        component: HomeWorkReport
                    },
                    {
                        path: 'homework-tracking-report',
                        name: 'homework-tracking-report',
                        component: HomeworkTrackingReport
                    },
                    {
                        path: 'leave-application-report',
                        name: 'leave-application-report',
                        component: LeaveApplicationReport
                    },
                    //transport
                    {
                        path: 'transport-master',
                        name: 'transport-master',
                        component: TransportMaster
                    },
                    {
                        path: 'route-stop-master/transport-master',
                        name: 'route-stop-master',
                        component: RouteStopMaster
                    },
                    {
                        path: 'transport-bus-master/transport-master',
                        name: 'transport-bus-master',
                        component: TransportBusMaster
                    },
                    {
                        path: 'vehicle-master/transport-master',
                        name: 'vehicle-master',
                        component: VehicleMaster
                    },

                    {
                        path: 'bus-timings-master/transport-master',
                        name: 'bus-timings-master',
                        component: BusTimingMaster
                    },
                    {
                        path: 'distance-slab-master/transport-master',
                        name: 'distance-slab-master',
                        component: DistanceSlabMaster
                    },
                    {
                        path: 'journey-type-master/transport-master',
                        name: 'journey-type-master',
                        component: JourneyTypeMaster
                    },
                    {
                        path: 'transport-approval-authority-master/transport-master',
                        name: 'transport-approval-authority-master',
                        component: TransportApprovalAuthorityMaster
                    },
                    {
                        path: 'transport-approval-hierarchy-master/transport-master',
                        name: 'transport-approval-hierarchy-master',
                        component: TransportApprovalHierarchyMaster
                    },
                    {
                        path: 'transport-approval-status-master/transport-master',
                        name: 'transport-approval-status-master',
                        component: TransportApprovalStatusMaster
                    },
                    {
                        path: 'transport-route',
                        name: 'transport-route',
                        component: TransportRoute
                    },
                    {
                        path: 'transport-route-employee',
                        name: 'transport-route-employee',
                        component: TransportEmployeeRoutePage
                    },
                    {
                        path: 'add-route-details',
                        name: 'add-route-details',
                        component: TransportRouteDetails
                    },
                    {
                        path: 'transport-installment',
                        name: 'transport-installment',
                        component: TransportInstallment
                    },
                    {
                        path: 'offline-transport-payment',
                        name: 'offline-transport-payment',
                        component: OfflineTransportPayment
                    },
                    {
                        path: 'change-learner-transport-route',
                        name: 'change-learner-transport-route',
                        component: ChangeLearnerTransportRoute
                    },
                    {
                        path: 'block-learner-transport',
                        name: 'block-learner-transport',
                        component: BlockStudentForTransport
                    },
                    {
                        path: 'sync-learner-transport-fees',
                        name: 'sync-learner-transport-fees',
                        component: SyncLearnerTransportFees
                    },
                    //Reports
                    {
                        path: 'transport-report',
                        name: 'transport-report',
                        component: TransportReport
                    },

                    {
                        path: 'route-stop-report',
                        name: 'route-stop-report',
                        component: RouteStopReport
                    },
                    {
                        path: 'import-transport-applications',
                        name: 'import-transport-applications',
                        component: ImportTransportApplications
                    },
                    {
                        path: 'admin-transport-application',
                        name: 'admin-transport-application',
                        component: ApplyTransportAdmin
                    },
                    //Parent
                    {
                        path: 'apply-transport-facility',
                        name: 'apply-transport-facility',
                        component: ApplyTransportFacility
                    },
                    {
                        path: 'bus-tracking',
                        name: 'bus-tracking',
                        component: BusTracking
                    },
                    {
                        path: 'transport-receipt',
                        name: 'transport-receipt',
                        component: TransportReceipt
                    },
                    {
                        path: 'bus-tracking-sbpps',
                        name: 'bus-tracking-sbpps',
                        component: BusTrackingSbpps
                    },
                    //Parent
                    //Approvers
                    {
                        path: 'coordinator-approve',
                        name: 'coordinator-approve',
                        component: ApproverTransporter
                    },
                    {
                        path: 'transporter-approve',
                        name: 'transporter-approve',
                        component: ApproverCoordinator
                    },
                    {
                        path: 'cancel-transport-application',
                        name: 'cancel-transport-application',
                        component: CancelTransportApplications
                    },
                    {
                        path: 'change-transport-route',
                        name: 'change-transport-route',
                        component: ChangeTransportRoute
                    },
                    //Approvers
                    //Inward-Outward
                    {
                        path: 'inward-outward-master',
                        name: 'inward-outward-master',
                        component: IOMaster
                    },
                    {
                        path: 'inward',
                        name: 'inward',
                        component: Inward
                    },
                    {
                        path: 'outward',
                        name: 'outward',
                        component: Outward
                    },
                    {
                        path: 'io-reports',
                        name: 'io-reports',
                        component: IOReports
                    },
                    {
                        path: 'file-journey-type',
                        name: 'file-journey-type',
                        component: FileJourneyType
                    },
                    {
                        path: 'inward-outward-department',
                        name: 'inward-outward-department',
                        component: InwardOutwardDepartment
                    },
                    {
                        path: 'inward-outward-department-type',
                        name: 'inward-outward-department-type',
                        component: InwardOutwardDepartmentType
                    },
                    {
                        path: 'inward-outward-department-matrix',
                        name: 'inward-outward-department-matrix',
                        component: InwardOutwardDepartmentMatrix
                    },
                    //Visitor
                    {
                        path: 'admin-add-visitor',
                        name: 'admin-add-visitor',
                        component: AdminAddVisitor
                    },
                    {
                        path: 'admin-schedule-visitor',
                        name: 'admin-schedule-visitor',
                        component: ScheduleVisit
                    },
                    {
                        path: 'visitor-master',
                        name: 'visitor-master',
                        component: VisitorMaster
                    },
                    {
                        path: 'visitor-url',
                        name: 'visitor-url',
                        component: VisitorURL
                    },
                    {
                        path: 'visitor-instructions',
                        name: 'visitor-instructions',
                        component: VisitorInstructions
                    },
                    {
                        path: 'visit-type-master',
                        name: 'visit-type-master',
                        component: VisitType
                    },
                    {
                        path: 'visitor-check-in',
                        name: 'visitor-check-in',
                        component: CheckIn
                    },
                    {
                        path: 'visitor-check-out',
                        name: 'visitor-check-out',
                        component: CheckOut
                    },
                    {
                        path: 'host-visit-approve',
                        name: 'host-visit-approve',
                        component: ApproveVisit
                    },
                    {
                        path: 'visit-reports',
                        name: 'visit-reports',
                        component: VisitorReports
                    },
                    //maintenance System
                    {
                        path: 'maintenance-master',
                        name: 'maintenance-master',
                        component: MaintenanceMaster
                    },
                    {
                        path: 'maintenance-issue-master',
                        name: 'maintenance-issue-master',
                        component: IssueMaster
                    },
                    {
                        path: 'maintenance-section-master',
                        name: 'maintenance-section-master',
                        component: MaintenanceSectionMaster
                    },
                    {
                        path: 'maintenance-status-master',
                        name: 'maintenance-status-master',
                        component: StatusMaster
                    },
                    {
                        path: 'maintenance-staff-linking',
                        name: 'maintenance-staff-linking',
                        component: StaffLinking
                    },
                    {
                        path: 'maintenance-issue-tracking',
                        name: 'maintenance-issue-tracking',
                        component: IssueTracking
                    },
                    {
                        path: 'maintenance-add-issue',
                        name: 'maintenance-add-issue',
                        component: AddIssue
                    },
                    {
                        path: 'maintenance-resolve-issue',
                        name: 'maintenance-resolve-issue',
                        component: ResolveIssue
                    },

                    //HealthCard
                    {
                        path: 'instructor-health-card',
                        name: 'instructor-health-card',
                        component: InstructorHealthCard
                    },
                    {
                        path: 'instructor-health-card-form',
                        name: 'instructor-health-card-form',
                        component: InstructorHealthCardForm
                    },
                    {
                        path: 'doctor-view-form',
                        name: 'doctor-view-form',
                        component: DoctorViewForm
                    },
                    {
                        path: 'view-instructor-health-card',
                        name: 'view-instructor-health-card',
                        component: ViewInstructorHealthCard
                    },
                    // {
                    //     path: 'student-health-card',
                    //     name: 'student-health-card',
                    //     component:StudentHealthCard
                    // },
                    {
                        path: 'student-health-card-form',
                        name: 'student-health-card-form',
                        component:StudentHealthCardForm
                    },

                    //HealthCard

                    {
                        path: 'approval-authority',
                        name: 'approval-authority',
                        component: ApprovalAuthority
                    },
                    {
                        path: 'canteen-installment-type',
                        name: 'canteen-installment-type',
                        component: CanteenInstallmentType
                    },
                    {
                        path: 'canteen-menu',
                        name: 'canteen-menu',
                        component: CanteenMenu
                    },
                    {
                        path: 'canteen-meal-report-admin',
                        name: 'canteen-meal-report-admin',
                        component: CanteenReportAdmin
                    },
                    {
                        path: 'canteen-meal-report-parent',
                        name: 'canteen-meal-report-parent',
                        component: CanteenReportParent
                    },
                    {
                        path: 'canteen-menu-type',
                        name: 'canteen-menu-type',
                        component: MenuType
                    },
                    {
                        path: 'canteen-transaction-type',
                        name: 'canteen-transaction-type',
                        component: CanteenTransactionType
                    },
                    {
                        path: 'canteen-menu-category',
                        name: 'canteen-menu-category',
                        component: MenuCategory
                    },
                    {
                        path: 'approval-hierachy',
                        name: 'approval-hierachy',
                        component: ApprovalHierachy
                    },
                    {
                        path: 'approval-status',
                        name: 'approval-status',
                        component: ApprovalSatus
                    },
                    {
                        path: 'canteen-installment',
                        name: 'canteen-installment',
                        component: CanteenInstallment
                    },
                    {
                        path: 'block-student-canteen-facility',
                        name: 'block-student-canteen-facility',
                        component: BlockStudentCanteenFacility
                    },
                    {
                        path: 'sync-learner-canteen-fees',
                        name: 'sync-learner-canteen-fees',
                        component: SyncLearnerCanteenFees
                    },
                    {
                        path: 'canteen-master',
                        name: 'canteen-master',
                        component: CanteenMaster
                    },
                    {
                        path: 'canteen-fee-structure',
                        name: 'canteen-fee-structure',
                        component: CanteenFeeStructure
                    },
                    {
                        path: 'canteen-daily-meal-report',
                        name: 'canteen-daily-meal-report',
                        component: CanteenDailyMealReport
                    },
                    {
                        path: 'meal-report',
                        name: 'meal-report',
                        component: MealReport
                    },
                    {
                        path: 'canteen-daily-receipt-report',
                        name: 'canteen-daily-receipt-report',
                        component: CanteenDailyReceiptReport
                    },
                    {
                        path: 'canteen-daily-meal-history',
                        name: 'canteen-daily-meal-history',
                        component: CanteenDailyMealHistory
                    },
                    {
                        path: 'wallet-daily-transaction-report',
                        name: 'wallet-daily-transaction-report',
                        component: WalletDailyTransactionReport
                    },
                    {
                        path: 'canteen-fees-report-wws',
                        name: 'canteen-fees-report-wws',
                        component: CanteenFeesReportWWS
                    },
                    {
                        path: 'canteen-fees-report-sbpps',
                        name: 'canteen-fees-report-sbpps',
                        component: CanteenFeesReportSBPPS
                    },
                    {
                        path: 'update-learner-canteen-fees',
                        name: 'update-learner-canteen-fees',
                        component: UpdateLearnerCanteenFees
                    },
                    {
                        path: 'canteen-receipt',
                        name: 'canteen-receipt',
                        component: CanteenReceipt
                    },
                    {
                        path: 'canteen-offline-fees',
                        name: 'canteen-offline-fees',
                        component: CanteenOfflineFees
                    },
                    //Parent
                    {
                        path: 'faculty-canteen-payment',
                        name: 'faculty-canteen-payment',
                        component: FacultyCanteenPayment
                    },
                    {
                        path: 'faculty-canteen-report',
                        name: 'faculty-canteen-report',
                        component: FacultyCanteenReport
                    },
                    {
                        path: 'apply-canteen-facility',
                        name: 'apply-canteen-facility',
                        component: ApplyCanteenFacility
                    },
                    {
                        path: 'apply-canteen-facility-wws',
                        name: 'apply-canteen-facility-wws',
                        component: ApplyCanteenFacilityWWS
                    },
                    {
                        path: 'parental-menu-control',
                        name: 'parental-menu-control',
                        component: ParentalMenuControl
                    },
                    {
                        path: 'place-order',
                        name: 'place-order',
                        component: PlaceOrder
                    },
                    {
                        path: 'place-meal-order-wws',
                        name: 'place-meal-order-wws',
                        component: PlaceMealOrderWWS
                    },
                    //Canteen Person
                    {
                        path: 'canteen-approve-first',
                        name: 'canteen-approve-first',
                        component: CanteenApprove
                    },
                    {
                        path: 'cancel-canteen-application',
                        name: 'cancel-canteen-application',
                        component: CancelCanteenApplication
                    },
                    //Account Person
                    {
                        path: 'canteen-approve-second',
                        name: 'canteen-approve-second',
                        component: AccountsApprove
                    },

                    //Biometric
                    {
                        path: 'inout-buffertime-master',
                        name: 'inout-buffertime-master',
                        component: Inoutbuffertimemaster
                    },
                    {
                        path: 'holiday-master',
                        name: 'holiday-master',
                        component: Holiday
                    },
                    {
                        path: 'holiday-derails',
                        name: 'holiday-derails',
                        component: HolidayDetails
                    },
                    {
                        path: 'add-in-out-master',
                        name: 'add-in-out-master',
                        component: AddInOutMaster
                    },
                    {
                        path: 'create-employee-attendance',
                        name: 'create-employee-attendance',
                        component: CreateEmployeeAttendance
                    },
                    {
                        path: 'inout-plan-master',
                        name: 'inout-plan-master',
                        component: InoutPlanMaster
                    },
                    {
                        path: 'mark-unmark-holiday',
                        name: 'mark-unmark-holiday',
                        component: MarkUnmarkHoliday
                    },
                    {
                        path: 'update-employee-attenance-details',
                        name: 'update-employee-attenance-details',
                        component: UpdateEmployeeAttendanceDetails
                    },
                    {
                        path: 'approve-unapprove-employee-attenance',
                        name: 'approve-unapprove-employee-attenance',
                        component: ApproveUnapproveAttendance
                    },
                    {
                        path: 'import-employee-attenance',
                        name: 'import-employee-attenance',
                        component: ImportEmployeeAttendance
                    },
                    {
                        path: 'monthly-attenance-report-biometric',
                        name: 'monthly-attenance-report-biometric',
                        component: MonthlyAttendanceReportBiometric
                    },
                    {
                        path: 'emp-attenance-calendar',
                        name: 'emp-attenance-calendar',
                        component: EmployeeAttendanceCalendar
                    },
                    {
                        path: 'emp-attenance-with-time',
                        name: 'emp-attenance-with-time',
                        component: EmployeeAttendanceReportWithTime
                    },
                    {
                        path: 'copy-payroll-attendance',
                        name: 'copy-payroll-attendance',
                        component: CopyPayrollAttendance
                    },
                    {
                        path: 'copy-payroll-attendance-v2',
                        name: 'copy-payroll-attendance-v2',
                        component: CopyPayrollAttendanceV2
                    },
                    {
                        path: 'admin-attendance-report',
                        name: 'admin-attendance-report',
                        component: AdminAttendanceReport
                    },
                    {
                        path: 'my-attendance-details',
                        name: 'my-attendance-details',
                        component: EmployeeAttendanceReport
                    },
                    {
                        path: 'emp-plan-details-report',
                        name: 'emp-plan-details-report',
                        component: EmployeePlanDetailedReport
                    },
                    {
                        path: 'sync-leave-data',
                        name: 'sync-leave-data',
                        component: SyncLeaveData
                    },
                    {
                        path: 'emp-penalty-data',
                        name: 'emp-penalty-data',
                        component: EmployeePenaltyDetails
                    },
                    {
                        path: 'bulk-inout-update',
                        name: 'bulk-inout-update',
                        component: BulkUpdateExpectedInOut
                    },
                    //Appraisal SBPPS
                    {
                        path: 'appraisal-credit',
                        name: 'appraisal-credit',
                        component: AppraisalCredit
                    },
                    {
                        path: 'evaluation-parameter',
                        name: 'evaluation-parameter',
                        component: EvaluationParameter
                    },
                    {
                        path: 'HR-evaluation',
                        name: 'HR-evaluation',
                        component: HREvaluation
                    },
                    //
                    {
                        path: 'HR-appraisalparameter-evaluation',
                        name: 'HR-appraisalparameter-evaluation',
                        component: HRAppraisalParameterEvaluation
                    },
                    {
                        path: 'appoint-appraisal-authority',
                        name: 'appoint-appraisal-authority',
                        component: AppointAppraisalAuthority
                    },
                    {
                        path: 'instructor-appraisal-authoritytype-mapping',
                        name: 'instructor-appraisal-authoritytype-mapping',
                        component: InstructorSelfAppraisalAuthorityTypeMapping
                    },
                    {
                        path: 'copy-appraisal-masters',
                        name: 'copy-appraisal-masters',
                        component: CopyAppraisalMasters
                    },
                    {
                        path: 'authority-appriasal-evaluation',
                        name: 'authority-appriasal-evaluation',
                        component: AuthorityAppraisalEvaluation
                    },
                    {
                        path: 'employee-appriasal-evaluation-report',
                        name: 'employee-appriasal-evaluation-report',
                        component: EmployeeAppraisalEvaluationReport
                    },
                    {
                        path: 'offline-wallet-payment',
                        name: 'offline-wallet-payment',
                        component: OfflineWalletPayment
                    },
                    {
                        path: 'online-wallet-payment',
                        name: 'online-wallet-payment',
                        component: OnlineWalletPayment
                    },
                    {
                        path: 'wallet-balance-report',
                        name: 'wallet-balance-report',
                        component: WalletBalanceReport
                    },
                    {
                        path: 'deleted-receipts-logs',
                        name: 'deleted-receipts-logs',
                        component: DeletedReceipsLogs
                    },
                    //Live Class
                    {
                        path: 'live-class-home',
                        name: 'live-class-home',
                        component: LiveClassHome
                    },
                    {
                        path: 'learner-live-class-meeting-code',
                        name: 'learner-live-class-meeting-code',
                        component: LearnerLiveClassSession
                    },
                    {
                        path: 'smart-desk-report',
                        name: 'smart-desk-report',
                        component: SmartDeskReport
                    },

                    //InventoryMaster-links

                    {
                        path: 'inventory-master',
                        name: 'inventory-master',
                        component: InventoryMasters
                    },

                    {
                        path: 'invCategory-master/inventory-master',
                        name: 'invCategory-master',
                        component: InventoryCategory
                    },
                    {
                        path: 'invMaterialType-master/inventory-master',
                        name: 'invMaterialType-master',
                        component: InventoryMaterialType
                    },
                    {
                        path: 'invMaterialSet-master/inventory-master',
                        name: 'invMaterialSet-master',
                        component: InventoryMaterialSet
                    },
                    {
                        path: 'invFinanceApprovingCategory-master/inventory-master',
                        name: 'invFinanceApprovingCategory-master',
                        component: InventoryFinanceApprovingCategory
                    },
                    {
                        path: 'invFinanceApprovingAuthority-master/inventory-master',
                        name: 'invFinanceApprovingAuthority-master',
                        component: InventoryFinanceApprovingAuthority
                    },
                    {
                        path: 'invDeadstockStatus-master/inventory-master',
                        name: 'invDeadstockStatus-master',
                        component: InventoryDeadstockStatus
                    },
                    {
                        path: 'invApprovalStatus-master/inventory-master',
                        name: 'invApprovalStatus-master',
                        component: InventoryApprovalStatus
                    },
                    {
                        path: 'invServiceStatus-master/inventory-master',
                        name: 'invServiceStatus-master',
                        component: InventoryServiceStatus
                    },
                    {
                        path: 'invMaterial-master/inventory-master',
                        name: 'invMaterial-master',
                        component: InventoryMaterial
                    },
                    {
                        path: 'invMarkApprovingAuthority',
                        name: 'invMarkApprovingAuthority',
                        component: MarkApprovingAuthority
                    },
                    {
                        path: 'invDepreciationCycle',
                        name: 'invDepreciationCycle',
                        component: InventoryDepreciationCycle
                    },
                    {
                        path: 'invFinanceApprovingAuthLevel',
                        name: 'invFinanceApprovingAuthLevel',
                        component: InventoryFinanceApprovingAuthorityLevel
                    },
                    {
                        path: 'invMaterialSpecification',
                        name: 'invMaterialSpecification',
                        component: InventoryMaterialSpecification
                    },
                    {
                        path: 'invVendor',
                        name: 'invVendor',
                        component: InventoryVendor
                    },
                    {
                        path: 'invMaterialPart',
                        name: 'invMaterialPart',
                        component: InventoryMaterialPart
                    },
                    {
                        path: 'add-invoice',
                        name: 'add-invoice',
                        component: AddInvoice
                    },
                    {
                        path: 'add-inventory',
                        name: 'add-inventory',
                        component: AddInventory
                    },
                    {
                        path: 'add-material-depreciation-percentage',
                        name: 'add-material-depreciation-percentage',
                        component: MaterialDepreciationPercentage
                    },
                    {
                        path: 'teacher-diary',
                        name: 'teacher-diary',
                        component: TeacherDairy
                    },
                    {
                        path: 'subject-teacher-diary',
                        name: 'subject-teacher-diary',
                        component: SubjectTeacherDairy
                    },
                    {
                        path: 'parent-diary',
                        name: 'parent-diary',
                        component: ParentDiary
                    },
                    {
                        path: 'parent-subject-diary',
                        name: 'parent-subject-diary',
                        component: ParentSubjectsDairy
                    },
                    {
                        path: 'message-type',
                        name: 'message-type',
                        component: MessageType

                    },
                    {
                        path: 'learner-marksheet-icse',
                        name: 'learner-marksheet-icse',
                        component: LearnerMarksheetICSE

                    },
                    {
                        path: 'mark-entry-status-role-based',
                        name: 'mark-entry-status-role-based',
                        component: MarkEntryStatus

                    },
                    {
                        path: 'learner-marksheet-config',
                        name: 'learner-marksheet-config',
                        component: LearnerMarksheetConfig

                    },
                    {
                        path: 'learner-marksheet-icse-parent',
                        name: 'learner-marksheet-icse-parent',
                        component: LearnerMarksheetICSEParent

                    },
                    {
                        path: 'learner-marksheet-marathi',
                        name: 'learner-marksheet-marathi',
                        component: LearnerMarksheetMarathi

                    },
                    {
                        path: 'learner-marksheet-marathi-parent',
                        name: 'learner-marksheet-marathi-parent',
                        component: LearnerMarksheetMarathiParent

                    },
                    {
                        path: 'rubrics-details-icse',
                        name: 'rubrics-details-icse',
                        component: RubricsDetailsICSE

                    },
                    {
                        path: 'pre-prim-marks-entry-scheduling',
                        name: 'pre-prim-marks-entry-scheduling',
                        component: PrePrimMarkScheduling
                    },
                    {
                        path: 'annual-marks-calculation-icse',
                        name: 'annual-marks-calculation-icse',
                        component: AnnualMarksCalculationICSE
                    },
                    {
                        path: 'assessment-detailed-report',
                        name: 'assessment-detailed-report',
                        component: AssessmentDetailedReport

                    },
                    {
                        path: 'annual-mark-book',
                        name: 'annual-mark-book',
                        component: AnnualMarkBook

                    },
                    {
                        path: 'annual-result-bulk-print',
                        name: 'annual-result-bulk-print',
                        component: AnnualResultBulkPrint
                    },
                    {
                        path: 'sync-transport-canteen',
                        name: 'sync-transport-canteen',
                        component: SyncOldTransportCanteen
                    },


                    //GeneralFeedback
                    {
                        path: 'add-feedback',
                        name: 'add-feedback',
                        component: Addfeedback

                    },

                    {
                        path: 'feedback-status',
                        name: 'feedback-status',
                        component: FeedbackStatus,
                        children: [
                            {
                                path: 'resolve-feedback',
                                name: 'resolve-feedback',
                                component: ResolveFeedback

                            },
                            {
                                path: 'all-feedback',
                                name: 'all-feedback',
                                component: AllFeedback

                            },
                            {
                                path: 'feedback-stats',
                                name: 'feedback-stats',
                                component: FeedbackStats

                            },
                            {
                                path: 'read-not-resolve-feedback',
                                name: 'read-not-resolve-feedback',
                                component: ReadAndNotResolved

                            },
                        ],
                    },

                    {
                        path: 'add-worksheet',
                        name: 'add-worksheet',
                        component: AddWorksheet

                    },
                    {
                        path: 'worksheet-report',
                        name: 'worksheet-report',
                        component: WorksheetReport

                    },
                    {
                        path: 'add-new-worksheet',
                        name: 'add-new-worksheet',
                        component: AddNewWorksheet

                    },
                    {
                        path: 'add-new-document',
                        name: 'add-new-document',
                        component: AddDocument

                    },
                    {
                        path: 'view-document-access',
                        name: 'view-document-access',
                        component: viewDocumentAccess

                    },
                    {
                        path: 'document-access-logs-report',
                        name: 'document-access-logs-report',
                        component: DocumentAccessLogsReport

                    },

                    {
                        path: 'event-booking-status-master',
                        name: 'event-booking-status-master',
                        component: EventBookingStatus

                    },
                    {
                        path: 'event-master',
                        name: 'event-master',
                        component: Event

                    },
                    {
                        path: 'appointment-master',
                        name: 'appointment-master',
                        component: Master

                    },
                    //Book Review
                    {
                        path: 'publisher-master',
                        name: 'publisher-master',
                        component: Publisher

                    },
                    {
                        path: 'book-review-criteria-master',
                        name: 'book-review-criteria-master',
                        component: BookReviewCriteria

                    },
                    {
                        path: 'book-review-criteria-type-master',
                        name: 'book-review-criteria-type-master',
                        component: BookReviewCriteriaType

                    },
                    {
                        path: 'teacher-book-review',
                        name: 'teacher-book-review',
                        component: TeacherBookReview

                    },
                    {
                        path: 'get-text-book-purchase-report',
                        name: 'get-text-book-purchase-report',
                        component: TextBookPurchaseReport

                    },
                    {
                        path: 'get-book-review-report',
                        name: 'get-book-review-report',
                        component: BookReviewReport

                    },
                    {
                        path: 'book-review-master',
                        name: 'book-review-master',
                        component: BookReviewMaster

                    },

                    //Slot booking
                    {
                        path: 'add-event-slot',
                        name: 'add-event-slot',
                        component: AddEventSlot
                    },
                    {
                        path: 'parent-event-dashboard',
                        name: 'parent-event-dashboard',
                        component: ParentEventDashboard
                    },
                    {
                        path: 'admin-event-dashboard',
                        name: 'admin-event-dashboard',
                        component: AdminEventDashboard
                    },
                    {
                        path: 'admin-event-dashboard-report',
                        name: 'admin-event-dashboard-report',
                        component: AdminEventDashboardReport
                    },

                    // Edu Store
                    {
                        path: 'edustore-masters',
                        name: 'edustore-masters',
                        component: EdustoreAllMaster
                    },
                    {
                        path: 'delivery-option-master',
                        name: 'delivery-option-master',
                        component: DeliveryOption
                    },
                    {
                        path: 'vendor-master',
                        name: 'vendor-master',
                        component: VendorProfile
                    },
                    {
                        path: 'vendor-shop-master',
                        name: 'vendor-shop-master',
                        component: VendorShop
                    },
                    {
                        path: 'size-label-type-master',
                        name: 'size-label-type-master',
                        component: SizeLabelTypeMaster
                    },
                    {
                        path: 'size-label-master',
                        name: 'size-label-master',
                        component: SizeLabelMaster
                    },
                    {
                        path: 'item-category-master',
                        name: 'item-category-master',
                        component: ItemCategory
                    },
                    {
                        path: 'order-status-master',
                        name: 'order-status-master',
                        component: OrderStatus
                    },
                    {
                        path: 'delivery-status-master',
                        name: 'delivery-status-master',
                        component: DeliveryStatus
                    },
                    {
                        path: 'invoice-report',
                        name: 'invoice-report',
                        component: InvoiceReport
                    },
                    {
                        path: 'my-orders',
                        name: 'my-orders',
                        component: MyOrders
                    },
                    {
                        path: 'my-cart',
                        name: 'my-cart',
                        component: MyCart
                    },
                    {
                        path: 'detailed-order-report',
                        name: 'detailed-order-report',
                        component: DetailedOrderReport
                    },
                    {
                        path: 'edustore-add-invoice',
                        name: 'edustore-add-invoice',
                        component: EdustoreAddInvoice
                    },

                    {
                        path: 'additem',
                        name: 'additem',
                        component: AddItem
                    },
                    {
                        path: 'addstock',
                        name: 'addstock',
                        component: AddStock
                    },
                    {
                        path: 'stock-transaction-type-master',
                        name: 'stock-transaction-type-master',
                        component: StockTransactionType
                    },
                    {
                        path: 'staff-stock-logs',
                        name: 'staff-stock-logs',
                        component: StaffStockLogs
                    },
                    {
                        path: 'stock-dashboard',
                        name: 'stock-dashboard',
                        component: StockDashboard
                    },
                    {
                        path: 'staff-stock-request',
                        name: 'staff-stock-request',
                        component: StaffStockRequest
                    },

                    {
                        path: 'student-stock-logs',
                        name: 'student-stock-logs',
                        component: StudentStockLogs
                    },
                    {
                        path: 'my-stock-dashboard',
                        name: 'my-stock-dashboard',
                        component: MyStockDashboard
                    },
                    {
                        path: 'stock-register',
                        name: 'stock-register',
                        component: StockRegister
                    },
                    {
                        path: 'my-stock-register',
                        name: 'my-stock-register',
                        component: MyStockRegister
                    },
                    {
                        path: 'student-wise-bill-report',
                        name: 'student-wise-bill-report',
                        component: StudentWiseIndividualBill
                    },
                    {
                        path: 'all-students-bill-report',
                        name: 'all-students-bill-report',
                        component: AllStudentsBillReport
                    },
                    {
                        path: 'admin-my-orders',
                        name: 'admin-my-orders',
                        component: AdminMyOrders
                    },
                   

                    //TimeSheet

                    {
                        path: 'add-time-sheet',
                        name: 'add-time-sheet',
                        component: AddTimeSheet
                    },
                    {
                        path: 'task-master',
                        name: 'task-master',
                        component: TaskMaster
                    },
                    {
                        path: 'timesheet-report',
                        name: 'timesheet-report',
                        component: TimesheetReport
                    },
                    //clearanceStatus
                    {
                        path: '/clearance-status',
                        name: 'ClearanceStatusMaster',
                        component: ClearanceStatusMaster
                    },
                     {
                        path: '/clearance-department',
                        name: 'ClearanceDepartment',
                        component: ClearanceDepartment
                    },
                    {
                        path: '/mark-authority',
                        name: 'MarkAuthority',
                        component: MarkAuthority
                    },
                    {
                        path: '/clearance-request',
                        name: 'ClearanceRequest',
                        component: ClearanceRequest
                    },
                    {
                        path: '/review-no-dues',
                        name: 'ReviewNoDues',
                        component: ReviewNoDues
                    },

                    //Instructor document type
                    {
                        path: 'instructor-document-type',
                        name: 'instructor-document-type',
                        component: InstructorDocumentType
                    },

                    //LoginLogo
                    {
                        path: '/login-logo',
                        name: 'LoginLogo',
                        component: LoginLogo
                    },
                 
                    
  
                ]
            },
            {
                path: 'videos',
                name: 'videos',
                component: Videos
            }
        ],
        beforeEnter: ((to, from, next) => {
            if (!localStorage.getItem('EPS-token')) next('/')
            else next()
        }),
        // beforeRouteLeave:((to, from,next) =>{
        //     alert("hi")
        //     console.log("home:",this.$route.path)
        //     next();
        // })
    },

    {
        path: '/home2', component: epsHome2,
        beforeEnter: ((to, from, next) => {
            if (!localStorage.getItem('EPS-token')) next('/')
            else next()
        })
    },
    {
        path: '/home-updated', component: HomeUpdated,
        beforeEnter: ((to, from, next) => {
            if (!localStorage.getItem('EPS-token')) next('/')
            else next()
        })
    },




];

export default routes